/* ═══════════════════════════════════════════════════════════════
   FrogMatch · Vetrina settimanale — runtime v2 editorial
   ───────────────────────────────────────────────────────────────
   Architettura Spotify-like: hero specchio + mood chips +
   spotlight wide + N rows-per-motivazione (carousel, mosaic,
   paired, discovery, trio) + closer.

   Le rows vengono composte dal JS al volo in base ai segnali del
   profilo:
   - 🌱 Evoluzione di [tuo top]        — carousel (5 card medium)
   - 🤝 La coppia della settimana       — paired (2 card grandi)
   - 👥 Per il tuo tavolo in [N]        — mosaic 2x2 (4 card)
   - 🔥 Hot tra i [archetipo]           — carousel (4 card)
   - 🌿 La scoperta della settimana     — discovery big single
   - 🌒 Fuori dal solito, ma con bussola — trio (3 card)

   Dipende da:
   - window.FrogMatch (computeMatch, archetypeLabel, _communityData)
   - window.FrogMatchVetrinaCustomer (id, firstName, weeklyPicks)
   ═══════════════════════════════════════════════════════════════ */

(function () {
  'use strict';

  console.info('[Vetrina] script caricato — v5.47.0 (CADENZA COERENTE: selezione + pool ora STABILI nella settimana (spina dorsale riconoscibile), niente più churn giornaliero del pool che neutralizzava i seed settimanali. Freschezza quotidiana confinata dove serve: Daily Drop (1 pick/giorno) + deck "Continua a scoprire" ora daily. v dati 7→8 per ricalcolo pulito. Include il fix tagline compagno v5.46: tetto di riuso, no "del tuo Jaipur" ovunque)', new Date().toLocaleTimeString());

  // ── helpers ─────────────────────────────────────────────────
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.from((root || document).querySelectorAll(sel)); }

  function getISOWeek(date) {
    const d = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
    const dayNum = d.getUTCDay() || 7;
    d.setUTCDate(d.getUTCDate() + 4 - dayNum);
    const yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
    const weekNum = Math.ceil((((d - yearStart) / 86400000) + 1) / 7);
    return d.getUTCFullYear() + '-W' + String(weekNum).padStart(2, '0');
  }

  // YYYY-MM-DD locale (per seed daily — la Vetrina rinfresca ogni 24h, non settimanale)
  function getISODate(date) {
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');
    return y + '-' + m + '-' + d;
  }

  // Saluto + emoji + eyebrow time-aware (mattino / pomeriggio / sera / notte)
  // Il campo `palette` viene anche usato come data-time sul .fm-vt-page per
  // adaptive CSS variables (palette diversa per momento del giorno).
  function getTimeContext(date) {
    const h = date.getHours();
    if (h >= 5 && h < 12) return { greeting: 'Buongiorno', icon: '🌅', eyebrow: 'STAMATTINA', moment: 'mattino', palette: 'morning' };
    if (h >= 12 && h < 18) return { greeting: 'Buon pomeriggio', icon: '☀️', eyebrow: 'POMERIGGIO', moment: 'giorno', palette: 'day' };
    if (h >= 18 && h < 23) return { greeting: 'Buonasera', icon: '🌙', eyebrow: 'STASERA', moment: 'sera', palette: 'evening' };
    return { greeting: 'Notte fonda', icon: '🌌', eyebrow: 'STANOTTE', moment: 'notte', palette: 'night' };
  }

  // Applica data-time al .fm-vt-page → attiva la palette CSS adaptive
  function applyTimePalette() {
    const pageEl = $('[data-fm-vt-page]');
    if (!pageEl) return;
    const ctx = getTimeContext(new Date());
    pageEl.setAttribute('data-time', ctx.palette);
    console.info('[Vetrina] palette time-aware:', ctx.palette, '(' + ctx.moment + ')');
  }

  function seedRandom(seedStr) {
    let h = 2166136261 >>> 0;
    for (let i = 0; i < seedStr.length; i++) {
      h = Math.imul(h ^ seedStr.charCodeAt(i), 16777619);
    }
    return function () {
      h += 0x6D2B79F5;
      let t = h;
      t = Math.imul(t ^ (t >>> 15), t | 1);
      t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
      return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
  }
  function shuffleDeterministic(arr, seed) {
    const rng = seedRandom(seed);
    const a = arr.slice();
    for (let i = a.length - 1; i > 0; i--) {
      const j = Math.floor(rng() * (i + 1));
      const tmp = a[i]; a[i] = a[j]; a[j] = tmp;
    }
    return a;
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c];
    });
  }

  const FALLBACK_WORKER = 'https://froghunt.info-frogames.workers.dev';
  function getWorkerUrl() {
    const pageEl = $('[data-fm-vt-page]');
    const setting = pageEl && pageEl.dataset.workerUrl ? pageEl.dataset.workerUrl : '';
    if (/^https?:\/\/[a-z0-9-]+\.workers\.dev/i.test(setting)) return setting;
    return FALLBACK_WORKER;
  }

  // ── Score tiers (internal — non più mostrati come "fasce" in UI) ─
  // Pool grandi per dare materiale a 6+ rows senza ripetizioni.
  // Le rows fanno dedupe (un gioco usato in una row non riappare in altre).
  const TIERS = {
    t1: { min: 75, max: 101, n: 20 },
    t2: { min: 60, max: 75,  n: 30 },
    t3: { min: 45, max: 60,  n: 30 },
    t4: { min: 30, max: 45,  n: 15 }
  };

  // ── Esclusioni catalogo ─────────────────────────────────────
  // Pattern fallback per intercettare espansioni quando il metafield
  // gioco_base non è valorizzato (capita su prodotti pre-sync BGG).
  // Pattern conservativo: solo termini inequivocabilmente "espansione".
  // Niente "big box" o "deluxe edition" (falsi positivi frequenti — molti
  // giochi base sono "Wingspan Deluxe" o "Carcassonne Big Box" e SONO il gioco base).
  const EXP_PATTERN = /\b(espansione|expansion|add[-\s]?on|promo pack)\b/i;
  function looksLikeExpansion(product) {
    if (!product || !product.t) return false;
    return EXP_PATTERN.test(product.t);
  }
  function isExcluded(product, ownedBggIds, ownedHandles) {
    if (product.bgg && ownedBggIds.has(product.bgg)) return true;
    if (ownedHandles.has(product.h)) return true;
    if ((product.av === false || product.available === false)) return true;
    if (product.is_exp === true) return true;
    if (looksLikeExpansion(product)) return true; // fallback testuale
    return false;
  }

  function buildOwnedSets(profile) {
    const bggIds = new Set();
    const handles = new Set();
    if (profile && profile.bggCollection && Array.isArray(profile.bggCollection.owned)) {
      for (const item of profile.bggCollection.owned) {
        const id = (typeof item === 'object') ? item.id : item;
        if (id) bggIds.add(id);
      }
    }
    if (profile && Array.isArray(profile.manualOwned)) {
      for (const mo of profile.manualOwned) if (mo && mo.bggId) bggIds.add(mo.bggId);
    }
    if (profile && Array.isArray(profile.purchasedProducts)) {
      for (const pp of profile.purchasedProducts) {
        if (pp && pp.bggId) bggIds.add(pp.bggId);
        if (pp && pp.handle) handles.add(pp.handle);
      }
    }
    return { bggIds, handles };
  }

  // ── Leva "Compagno di tavolo" ───────────────────────────────
  // Ritorna TUTTI i "compagni di tavolo" plausibili dal tuo storico, ordinati per
  // pertinenza (overlap meccaniche/categorie; le partite fanno da spareggio dolce:
  // a parità di affinità vince il gioco che porti di più al tavolo). Serve alla
  // tagline per avere un SECONDO/TERZO riferimento quando il primo è già stato usato
  // troppo → le card non finiscono per citare tutte lo stesso gioco.
  function findCompanionCandidates(product, profile) {
    if (!product || !profile) return [];
    const topPlayed = (profile.playsActivity && profile.playsActivity.topPlayed) || [];
    if (topPlayed.length === 0) return [];
    const productMechs = new Set(product.mch || []);
    const productCats = new Set(product.cat || []);
    if (productMechs.size === 0 && productCats.size === 0) return [];
    const out = [];
    for (const tp of topPlayed) {
      if (!tp || !tp.name) continue;
      if ((tp.plays || 0) < 3) continue;
      const tpMechs = Array.isArray(tp.mch) ? tp.mch : [];
      const tpCats = Array.isArray(tp.cat) ? tp.cat : [];
      let overlapMech = 0; const mechNames = [];
      for (const m of tpMechs) if (productMechs.has(m)) { overlapMech++; mechNames.push(m); }
      let overlapCat = 0; const catNames = [];
      for (const c of tpCats) if (productCats.has(c)) { overlapCat++; catNames.push(c); }
      const overlap = overlapMech * 2 + overlapCat;
      if (overlap < 2) continue;
      // Spareggio dolce sulle partite (max +0.9): l'affinità resta il criterio primario.
      const playsBonus = Math.min(tp.plays || 0, 30) * 0.03;
      out.push({ name: tp.name, plays: tp.plays || 0, score: overlap + playsBonus, mechShared: overlapMech, catShared: overlapCat, mechNames: mechNames, catNames: catNames });
    }
    out.sort((a, b) => b.score - a.score);
    return out;
  }

  // Miglior compagno singolo (retro-compat: usato da hero/spotlight explainer).
  function findCompanion(product, profile) {
    const list = findCompanionCandidates(product, profile);
    return list.length ? list[0] : null;
  }

  function findCommunityCount(product) {
    if (!product || !product.bgg) return 0;
    const cd = window.FrogMatch && window.FrogMatch._communityData;
    if (!cd) return 0;
    const entry = cd[product.bgg];
    if (!entry) return 0;
    return entry.players || entry.owners || entry.frogger_count || 0;
  }

  // ── Detect helpers per il profilo ───────────────────────────
  function detectArchetypeLabel(profile) {
    try {
      if (window.FrogMatch && window.FrogMatch.archetypeLabel) {
        const label = window.FrogMatch.archetypeLabel(profile);
        if (label) return label;
      }
    } catch (e) {}
    return profile.archetypeName || profile.archetype || null;
  }

  function detectPreferredPlayerCount(profile) {
    // Cerca in vari campi possibili del profilo
    if (profile.preferredPlayerCount) return profile.preferredPlayerCount;
    if (profile.playerCountIdeal) return profile.playerCountIdeal;
    if (profile.playerCount) return profile.playerCount;
    // Fallback: stima dai topPlayed (la moda dei "best" player count)
    const topPlayed = (profile.playsActivity && profile.playsActivity.topPlayed) || [];
    if (topPlayed.length > 0) {
      const counts = {};
      for (const tp of topPlayed) {
        const pb = tp.pbest || tp.players_best;
        if (pb) counts[pb] = (counts[pb] || 0) + 1;
      }
      const sorted = Object.entries(counts).sort((a, b) => b[1] - a[1]);
      if (sorted.length > 0) return parseInt(sorted[0][0], 10);
    }
    return null;
  }

  // ── TRACKING EVENTI — foundazione algoritmo V1 (multi-segnale pesato + decay) ──
  // Logga silenziosamente eventi utente con peso variabile (stile TikTok).
  // Storage rolling max 200 eventi, ultimi 90gg. Sync to worker in batch (parked).
  const EVENT_WEIGHTS = {
    view_card:        1,   // mostrato in vetrina (auto sui card visibili)
    click_open:       3,   // aperto modal explainer
    visit_repeat:     5,   // 3+ apertura stesso gioco in 7gg
    wishlist_add:     7,   // aggiunto wishlist
    wishlist_hot:    10,   // wishlist flag Hot
    cart_add:         8,
    cart_abandon:     5,
    daily_drop_view:  4,   // ha visto il Daily Drop di oggi
    skip_quick:      -2,   // chiusa modal senza azione
    not_interested: -15    // 👎 esplicito
  };
  const EVENT_STORAGE_KEY = 'frogmatch_events';
  const EVENT_MAX = 200;

  function trackEvent(name, gameHandle, extra) {
    try {
      const weight = EVENT_WEIGHTS[name] || 0;
      const evt = {
        n: name,
        h: gameHandle || null,
        w: weight,
        t: Math.floor(Date.now() / 1000)
      };
      if (extra) Object.assign(evt, extra);
      const raw = localStorage.getItem(EVENT_STORAGE_KEY);
      const arr = raw ? JSON.parse(raw) : [];
      arr.push(evt);
      // Rolling: tieni solo ultimi MAX
      if (arr.length > EVENT_MAX) arr.splice(0, arr.length - EVENT_MAX);
      localStorage.setItem(EVENT_STORAGE_KEY, JSON.stringify(arr));
      // (future) batch flush to worker /api/frogmatch/events
    } catch (e) { /* localStorage piena o disabilitata, silent */ }
  }

  // Compute interest score per gioco dai segnali tracciati, con decay temporale.
  // Decay: ≤7gg = peso pieno, 7-30gg ×0.6, 30-90gg ×0.2, oltre ignorato.
  function computeInterestScore(gameHandle) {
    try {
      const raw = localStorage.getItem(EVENT_STORAGE_KEY);
      if (!raw) return 0;
      const arr = JSON.parse(raw);
      const now = Math.floor(Date.now() / 1000);
      let total = 0;
      for (const evt of arr) {
        if (evt.h !== gameHandle) continue;
        const ageSec = now - (evt.t || 0);
        const ageDays = ageSec / 86400;
        let factor = 1;
        if (ageDays > 90) continue;
        else if (ageDays > 30) factor = 0.2;
        else if (ageDays > 7) factor = 0.6;
        total += (evt.w || 0) * factor;
      }
      return total;
    } catch (e) { return 0; }
  }

  // Conta visite distinte stesso gioco negli ultimi N giorni → segnala intent
  function countRecentVisits(gameHandle, days) {
    try {
      const raw = localStorage.getItem(EVENT_STORAGE_KEY);
      if (!raw) return 0;
      const arr = JSON.parse(raw);
      const cutoff = Math.floor(Date.now() / 1000) - (days * 86400);
      return arr.filter(e => e.h === gameHandle && e.n === 'click_open' && e.t >= cutoff).length;
    } catch (e) { return 0; }
  }

  // ── F0.5 MEMORIA & DELTA — data layer silenzioso ────────────────
  // Ricorda cosa il cliente ha visto/valutato e quando è tornato, per:
  //  · "Riprendi da dove eri" / "Stai valutando" / "Il tuo radar" (strato L0)
  //  · riga "Bentornato + delta" (calo prezzo / restock dall'ultima volta)
  // Tutto in localStorage (v1 solo-tema; mirror worker cross-device in v2).
  // NB: gli "opens" per gioco si derivano dal sistema eventi esistente
  // (click_open) via countRecentVisits — qui memorizziamo solo il BASELINE
  // prezzo/disponibilità "come li hai visti", che gli eventi non salvano.
  const MEM_KEY = 'fmv_seen';        // handle → { p:prezzoVisto, av:dispVista, t:ultimaVista }
  const VISIT_KEY = 'fmv_visit';     // { prev:tsVisitaPrecedente, cur:tsVisitaCorrente }
  const SESSION_GAP = 30 * 60;       // 30 min di inattività = nuova sessione
  let PREV_VISIT = 0;                // ts visita precedente (riferimento per i delta)

  function loadMem() {
    try { const o = JSON.parse(localStorage.getItem(MEM_KEY) || '{}'); return (o && typeof o === 'object') ? o : {}; }
    catch (e) { return {}; }
  }
  function saveMem(m) { try { localStorage.setItem(MEM_KEY, JSON.stringify(m)); } catch (e) {} }

  // Una volta a inizio pagina: calcola la visita precedente (per i delta) e registra
  // quella corrente. Sessioni separate da >30 min di inattività (refresh = stessa sessione).
  function initVisitMemory() {
    const now = Math.floor(Date.now() / 1000);
    let v = {};
    try { v = JSON.parse(localStorage.getItem(VISIT_KEY) || '{}') || {}; } catch (e) {}
    if (v.cur && (now - v.cur) > SESSION_GAP) PREV_VISIT = v.cur;        // ultima sessione = riferimento delta
    else if (v.prev) PREV_VISIT = v.prev;                               // refresh: mantieni riferimento
    else PREV_VISIT = 0;                                                // prima visita assoluta
    try { localStorage.setItem(VISIT_KEY, JSON.stringify({ prev: PREV_VISIT, cur: now })); } catch (e) {}
    console.info('[Vetrina] memoria: visita prec=' +
      (PREV_VISIT ? new Date(PREV_VISIT * 1000).toLocaleString() : 'prima volta') +
      ' · giochi ricordati=' + Object.keys(loadMem()).length);
  }

  // Registra prezzo+disponibilità "come li hai visti ORA" (al click_open o al wishlist):
  // baseline su cui, al ritorno, calcoleremo i delta (calo prezzo / restock).
  function snapshotSeen(handle, catalog) {
    if (!handle) return;
    try {
      const product = (catalog || []).find(p => p.h === handle);
      if (!product) return;
      const m = loadMem();
      const priceNum = parseFloat(String(product.price || '0').replace(',', '.')) || 0;
      m[handle] = { p: priceNum, av: (product.av !== false), t: Math.floor(Date.now() / 1000) };
      saveMem(m);
    } catch (e) {}
  }

  // Delta dall'ultima volta. v1 AFFIDABILE: cali prezzo (baseline fmv_seen vs prezzo
  // attuale del catalog). Il baseline si aggiorna solo quando RIAPRI il gioco, quindi
  // il "calo da quando l'hai visto" persiste finché non lo riguardi. (Restock/novità:
  // arrivano quando avremo la disponibilità reale per-handle — v2.)
  function computeDeltas(catalog) {
    const out = { priceDrops: [] };
    try {
      const mem = loadMem();
      for (const h in mem) {
        const base = mem[h];
        if (!base || typeof base.p !== 'number' || base.p <= 0) continue;
        const product = (catalog || []).find(p => p.h === h);
        if (!product) continue;
        if (product.av === false || product.available === false) continue;
        const cur = parseFloat(String(product.price || '0').replace(',', '.')) || 0;
        if (cur > 0 && cur < base.p - 0.01) {
          out.priceDrops.push({ h: h, t: product.t, oldP: base.p, newP: cur, pct: Math.round((1 - cur / base.p) * 100) });
        }
      }
    } catch (e) {}
    return out;
  }

  // ── F0.5 ANTI-RIPETIZIONE — "stabilità ≠ immobilità" ────────────
  // Conta quante SESSIONI distinte un gioco è stato mostrato. Se ≥3 sessioni
  // senza nessun segnale d'interesse (mai cliccato/wishlistato) → "stanco":
  // lo declassiamo nel ranking così ruota fuori e lasciano spazio facce nuove.
  const SHOWS_KEY = 'fmv_shows';     // handle → { c:sessioniMostrato, s:tsUltimaSessione }
  const FATIGUE_SESSIONS = 3;        // soglia sessioni
  const FATIGUE_PENALTY = 25;        // punti tolti al ranking (lo spinge in fondo/fuori)

  function loadShows() {
    try { const o = JSON.parse(localStorage.getItem(SHOWS_KEY) || '{}'); return (o && typeof o === 'object') ? o : {}; }
    catch (e) { return {}; }
  }
  // Registra (una sola volta per sessione) gli handle mostrati in questo render.
  function recordShows(handles) {
    try {
      const m = loadShows();
      const now = Math.floor(Date.now() / 1000);
      for (const h of handles) {
        if (!h) continue;
        const rec = m[h] || { c: 0, s: 0 };
        if (now - (rec.s || 0) > SESSION_GAP) { rec.c = (rec.c || 0) + 1; rec.s = now; m[h] = rec; }
      }
      localStorage.setItem(SHOWS_KEY, JSON.stringify(m));
    } catch (e) {}
  }
  // "Stanco" = mostrato in ≥3 sessioni E nessun interesse positivo accumulato.
  function isFatigued(handle) {
    try {
      const rec = loadShows()[handle];
      if (!rec || (rec.c || 0) < FATIGUE_SESSIONS) return false;
      return computeInterestScore(handle) <= 0; // mai cliccato/wishlistato
    } catch (e) { return false; }
  }

  // ── PRESENCE — Counter live "X Frogger in vetrina ora" (trust signal soft) ──
  // Heartbeat ogni 60s → worker mantiene chi è online ultimi 5min.
  // Fetch online ogni 90s → update chip nella sidebar dx.
  //
  // CONGELATO 2026-06-06: con community piccola il rischio è "anti-trust"
  // (mostrare 1 o 2 Frogger fa sembrare la pagina deserta, opposto dell'effetto
  // voluto). Riattivare cambiando PRESENCE_ENABLED a true quando avremo
  // ≥10 Frogger attivi simultanei stabili (probabilmente dopo le newsletter
  // post-Bologna Play / quando la base utenti supera i 500 attivi/mese).
  //
  // L'infrastruttura backend (endpoint /api/frogmatch/heartbeat e /online)
  // resta deployata e funzionante, semplicemente nessun client la chiama.
  const PRESENCE_ENABLED = false;
  function startPresenceLoop() {
    if (!PRESENCE_ENABLED) {
      console.info('[Vetrina] presence: congelata (community ancora piccola, evita "1 Frogger" anti-trust)');
      return;
    }
    const cid = window.FrogMatchVetrinaCustomer && window.FrogMatchVetrinaCustomer.id;
    if (!cid) return;
    const workerUrl = getWorkerUrl();
    if (!workerUrl) return;
    const base = workerUrl.replace(/\/$/, '');

    async function pingHeartbeat() {
      try {
        await fetch(base + '/api/frogmatch/heartbeat', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ customerId: String(cid) })
        });
      } catch (e) { /* silent */ }
    }
    async function fetchOnline() {
      try {
        const res = await fetch(base + '/api/frogmatch/online');
        if (!res.ok) return;
        const json = await res.json();
        if (json && typeof json.online === 'number') {
          updatePresenceChip(json.online);
        }
      } catch (e) { /* silent */ }
    }
    // Soglia conservativa: il chip live appare SOLO con ≥3 Frogger.
    // Sotto soglia la community è troppo piccola e mostrare "Sei tu" o
    // "1 Frogger" sarebbe ANTI-trust signal (pagina sembra deserta).
    // Quando la community cresce e siamo sempre ≥3, il chip è valore puro.
    const MIN_VISIBLE = 3;
    function updatePresenceChip(count) {
      const sideRight = $('[data-fm-vt-sidebar-right]');
      if (!sideRight) return;
      const existing = sideRight.querySelector('[data-fm-vt-online]');
      if (count < MIN_VISIBLE) {
        // Sotto soglia → rimuovi se presente, non mostrare nulla
        if (existing) existing.remove();
        return;
      }
      let chip = existing;
      if (!chip) {
        chip = document.createElement('div');
        chip.setAttribute('data-fm-vt-online', '');
        chip.className = 'fm-vt-side__block fm-vt-online';
        sideRight.insertBefore(chip, sideRight.firstChild);
      }
      chip.innerHTML =
        '<span class="fm-vt-online__dot" aria-hidden="true"></span>' +
        '<span class="fm-vt-online__label"><strong>' + count + ' Frogger</strong> in vetrina ora</span>';
    }

    pingHeartbeat().then(() => fetchOnline());
    setInterval(pingHeartbeat, 60000);
    setInterval(fetchOnline, 90000);
  }

  // ── COMMUNITY STATS — trust signal soft "negli ultimi 30 giorni" ──
  // Numeri onesti che danno percezione di scala senza fake. Cachato dal worker.
  // Sidebar dx, primo blocco — appare solo se i numeri sono caricati.
  async function loadCommunityStats() {
    const workerUrl = getWorkerUrl();
    if (!workerUrl) return;
    try {
      const res = await fetch(workerUrl.replace(/\/$/, '') + '/api/frogmatch/community-stats');
      if (!res.ok) return;
      const stats = await res.json();
      if (!stats || !stats.frogger_active) return;
      renderCommunityStatsBlock(stats);
    } catch (e) { /* silent — fallback è semplicemente non mostrare */ }
  }
  function renderCommunityStatsBlock(stats) {
    const sideRight = $('[data-fm-vt-sidebar-right]');
    if (!sideRight) return;
    let block = sideRight.querySelector('[data-fm-vt-cstats]');
    if (!block) {
      block = document.createElement('div');
      block.setAttribute('data-fm-vt-cstats', '');
      block.className = 'fm-vt-side__block fm-vt-cstats';
      // In cima alla sidebar dx
      sideRight.insertBefore(block, sideRight.firstChild);
    }
    block.innerHTML =
      '<h3 class="fm-vt-side__head">📊 Negli ultimi 30 giorni</h3>' +
      '<ul class="fm-vt-cstats__list">' +
        '<li><strong>' + stats.frogger_active + '</strong> Frogger qui</li>' +
        '<li><strong>' + stats.plays_logged + '</strong> partite registrate</li>' +
        '<li><strong>' + stats.wishlist_adds + '</strong> giochi salvati</li>' +
      '</ul>';
  }

  // ── "Più giocati dai Frogger" — colonna destra DATA-DRIVEN (FrogMatch) ──
  // Fonte: /api/community/most-played (partite reali registrate + collezioni BGG
  // sincronizzate). Mostra SOLO titoli che abbiamo in catalogo, esclude quelli che
  // già possiedi/giochi, gli esauriti e le espansioni. Ordine: FrogMatch regna →
  // blend community×match (il match conta sempre). Click → modal (delegato su document).
  async function renderFroggerHot(catalog, profile) {
    const workerUrl = getWorkerUrl();
    if (!workerUrl) return;
    const sideRight = $('[data-fm-vt-sidebar-right]');
    if (!sideRight || !catalog || !catalog.length) return;
    let data;
    try {
      const res = await fetch(workerUrl.replace(/\/$/, '') + '/api/community/most-played?days=7&limit=60');
      if (!res.ok) return;
      data = await res.json();
    } catch (e) { return; }
    if (!data || !Array.isArray(data.games) || !data.games.length) return;

    const owned = buildOwnedSets(profile);
    // bggId → product (prima copia disponibile; le espansioni le scarta isExcluded)
    const byBgg = {};
    for (const p of catalog) {
      if (!p || !p.bgg) continue;
      if (!byBgg[p.bgg]) byBgg[p.bgg] = p;
    }
    const seenBgg = new Set();
    const items = [];
    for (const g of data.games) {
      const prod = byBgg[g.bggId];
      if (!prod) continue;                                  // solo ciò che abbiamo in catalogo
      if (seenBgg.has(g.bggId)) continue;
      if (isExcluded(prod, owned.bggIds, owned.handles)) continue; // no posseduti/esauriti/espansioni
      let m = 0;
      try { const r = window.FrogMatch.computeMatch(profile, prod); if (r && typeof r.pct === 'number') m = Math.round(r.pct); } catch (e) {}
      seenBgg.add(g.bggId);
      // Finestra 30gg (design: partite di TUTTI i Frogger negli ultimi 30 giorni).
      items.push({ prod: prod, froggers: g.uniqueFroggers || 0, plays: (g.totalPlays30d || 0), score: g.weightedScore || 0, m: m });
    }
    if (items.length < 3) return;   // sotto soglia: meglio non mostrare (anti "community vuota")

    // NB worker: il param "days" NON filtra (le partite sono su finestre fisse 30/90gg).
    // Quindi la lista grezza è SEMPRE la stessa → ruotiamo NOI ogni lunedì su un pool
    // ampio, così non resta fisso ma resta onesta (tutti sono davvero tra i più giocati).
    items.sort((a, b) => (b.plays - a.plays) || (b.score - a.score)); // i più giocati in cima
    const cid = (window.FrogMatchVetrinaCustomer && window.FrogMatchVetrinaCustomer.id) || 'anon';
    const pool = items.slice(0, 22);                         // top 22 reali
    const rotated = shuffleDeterministic(pool, cid + '_froggerhot_' + getISOWeek(new Date()));
    const working = rotated.slice(0, Math.min(16, rotated.length));
    // Mostro SEMPRE ordinati per partite (numero visibile) → niente "1 partita sopra 4".
    // Il match resta tiebreak (a parità di partite, prima il più affine a te).
    working.sort((a, b) => (b.plays - a.plays) || (b.m - a.m));
    const top = working.slice(0, 10);

    let block = sideRight.querySelector('[data-fm-vt-froggerhot]');
    if (!block) {
      block = document.createElement('div');
      block.setAttribute('data-fm-vt-froggerhot', '');
      block.className = 'fm-vt-side__block fm-vt-froggerhot';
    }
    const froggerN = (data.totalFroggers || 0);
    block.innerHTML =
      '<h3 class="fm-vt-side__head">🔥 Più giocati dai Frogger</h3>' +
      '<p class="fm-vt-side__sub">Sui tavoli veri negli ultimi 30 giorni' +
        (froggerN ? ' — da ' + froggerN + ' Frogger che registrano le partite' : '') +
        '. Solo titoli che abbiamo, esclusi quelli che hai già. Ruota ogni lunedì.</p>' +
      '<div class="fm-vt-side__minis">' +
        top.map(function (it) {
          return renderMiniCard({ h: it.prod.h, m: it.m }, it.prod, it.froggers + ' Frogger · ' + it.plays + ' partite');
        }).join('') +
      '</div>';

    // Posiziona DOPO le community stats ma PRIMA della nota del curatore.
    const note = sideRight.querySelector('.fm-vt-side__note');
    if (note) sideRight.insertBefore(block, note);
    else sideRight.appendChild(block);
  }

  // ── TOAST con VOCE di Frog (feedback caldo invece del toast generico Frogames) ──
  // Bottom-left sticky, fade-in / auto-hide 3.5s. 1 alla volta.
  let _toastEl = null;
  let _toastTimer = null;
  function showFrogToast(message, options) {
    options = options || {};
    if (_toastEl) {
      try { _toastEl.remove(); } catch (e) {}
      clearTimeout(_toastTimer);
    }
    const el = document.createElement('div');
    el.style.cssText = [
      'position:fixed','bottom:20px','left:20px','z-index:9999',
      'background:linear-gradient(135deg,#1F1A14 0%,#2A2418 100%)',
      'color:#FAF7F0','padding:13px 18px','border-radius:14px',
      'box-shadow:0 12px 32px rgba(31,26,20,0.35),inset 0 0 0 1px rgba(201,154,46,0.3)',
      "font-family:'Poppins',system-ui,sans-serif",'font-size:14px','font-weight:500',
      'max-width:340px','line-height:1.4',
      'transition:opacity 0.35s ease,transform 0.35s ease',
      'opacity:0','transform:translateY(12px)'
    ].join(';');
    el.innerHTML =
      escapeHtml(message) +
      '<div style="font-family:\'Poppins\',system-ui,sans-serif;font-weight:600;font-size:11px;color:rgba(201,154,46,0.85);margin-top:6px;letter-spacing:0.05em">— Frog</div>';
    // Azione opzionale (es. "Annulla" dopo la ✕) → recupero immediato da misclick.
    if (options.action && options.action.label && typeof options.action.onClick === 'function') {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.textContent = options.action.label;
      btn.style.cssText = 'margin-top:9px;background:rgba(201,154,46,0.92);color:#1F1A14;border:none;border-radius:999px;padding:6px 15px;font-family:\'Poppins\',system-ui,sans-serif;font-weight:700;font-size:12px;cursor:pointer';
      btn.addEventListener('click', function (ev) {
        ev.stopPropagation();
        try { options.action.onClick(); } catch (e) {}
        clearTimeout(_toastTimer);
        try { el.remove(); } catch (e) {}
        if (_toastEl === el) _toastEl = null;
      });
      el.appendChild(btn);
    }
    document.body.appendChild(el);
    requestAnimationFrame(() => {
      el.style.opacity = '1';
      el.style.transform = 'translateY(0)';
    });
    _toastEl = el;
    _toastTimer = setTimeout(() => {
      el.style.opacity = '0';
      el.style.transform = 'translateY(12px)';
      setTimeout(() => { try { el.remove(); } catch (e) {} if (_toastEl === el) _toastEl = null; }, 400);
    }, options.duration || 3500);
  }

  // ── ALGORITMO V2 — Diversità intra-feed + Esplorazione 70/20/10 ──
  // Mossa 1: dopo il sort per ranking, riordina i picks evitando N+ giochi
  // consecutivi con stessa meccanica principale. Stacca il "treno di Engine
  // Builder" che annoia il feed. Mantiene comunque il ranking globale.
  function diversifyByMech(picks, maxConsecutive) {
    maxConsecutive = maxConsecutive || 2;
    if (!picks || picks.length < 4) return picks;
    const out = [];
    const buckets = {}; // mechanic key → array di picks
    const noMech = []; // picks senza mech
    // Bucket per meccanica principale (prima della list)
    for (const p of picks) {
      const m = (p.product && p.product.mch && p.product.mch[0]) || '';
      if (!m) noMech.push(p);
      else {
        if (!buckets[m]) buckets[m] = [];
        buckets[m].push(p);
      }
    }
    // Round-robin: scorri il sort originale, ma se l'ultima N posizioni hanno
    // tutte stessa mech, salta al prossimo bucket disponibile.
    const consumed = new Set();
    let recentMechs = []; // ultime maxConsecutive mech aggiunte
    while (consumed.size < picks.length) {
      let placed = false;
      // Cerca il primo pick (in ordine ranking) che non rompe la regola
      for (const p of picks) {
        if (consumed.has(p.h)) continue;
        const m = (p.product && p.product.mch && p.product.mch[0]) || '__none__';
        // Conta quante delle ultime N posizioni hanno la stessa mech
        const sameCount = recentMechs.filter(x => x === m).length;
        if (sameCount >= maxConsecutive) continue; // skip — troppi consecutivi
        out.push(p);
        consumed.add(p.h);
        recentMechs.push(m);
        if (recentMechs.length > maxConsecutive) recentMechs.shift();
        placed = true;
        break;
      }
      if (!placed) {
        // Fallback: prendi qualsiasi pick rimanente (capita se tutti uguali)
        for (const p of picks) {
          if (!consumed.has(p.h)) {
            out.push(p);
            consumed.add(p.h);
            const m = (p.product && p.product.mch && p.product.mch[0]) || '__none__';
            recentMechs.push(m);
            if (recentMechs.length > maxConsecutive) recentMechs.shift();
            break;
          }
        }
      }
    }
    return out;
  }

  // Mossa 2: split 70/20/10 — 70% sicuro (top ranked), 20% stretch (mid score),
  // 10% wild (random dal catalog con almeno 1 mech in comune col profilo).
  // Wild slots ricevono flag `wildSlot:true` → badge "🎲 nuovo per te" su card.
  // Usato sulle row catch-all/lunghe per forzare esplorazione.
  function applyExplorationMix(picks, catalog, profile, used, totalSize) {
    if (!picks || picks.length < 5) return picks;
    totalSize = totalSize || picks.length;
    const wantSafe = Math.ceil(totalSize * 0.7);
    const wantStretch = Math.floor(totalSize * 0.2);
    const wantWild = totalSize - wantSafe - wantStretch;
    // 70%: i top ranked (già ordinati)
    const safe = picks.slice(0, wantSafe);
    // 20%: stretch — picks oltre il 70% ranking
    const stretch = picks.slice(wantSafe, wantSafe + wantStretch);
    // 10%: wild — random dal catalog non già usato, con ≥1 mech in comune
    const topMechs = (profile.topMechanics || []).slice(0, 4);
    const wildPool = catalog.filter(c => {
      if (used && used.has(c.h)) return false;
      if (c.is_exp === true || looksLikeExpansion(c)) return false;
      if (c.av === false || c.available === false) return false;
      if (isBlocked(c.h)) return false;
      // Skip già nei picks ricevuti
      if (picks.some(p => p.h === c.h)) return false;
      const cm = c.mch || [];
      return topMechs.length === 0 || cm.some(m => topMechs.indexOf(m) !== -1);
    });
    // Shuffle daily-seeded
    const customerId = (window.FrogMatchVetrinaCustomer && window.FrogMatchVetrinaCustomer.id) || 'a';
    // F0.5: seed SETTIMANALE (non giornaliero) → niente "mondo diverso ogni giorno".
    const seed = customerId + '_wild_' + getISOWeek(new Date());
    const wildShuffled = shuffleDeterministic(wildPool, seed).slice(0, wantWild);
    // Trasforma in picks (compute match%, marker wildSlot)
    const wildPicks = wildShuffled.map(product => {
      let m = 50;
      try {
        const r = window.FrogMatch.computeMatch(profile, product);
        if (r && typeof r.pct === 'number') m = Math.round(r.pct);
      } catch (e) {}
      return {
        h: product.h,
        m: m,
        ranked: m,
        r: [],
        e: null,
        comp: null,
        com: findCommunityCount(product),
        tag: null,
        product: product,
        wildSlot: true
      };
    });
    return safe.concat(stretch, wildPicks);
  }

  // ── REACTIONS — ♡ Wishlist (integrata Frogames) + ✕ Non mostrarmi più ──
  // Wishlist: usa il sistema esistente Frogames (window.addToWishlist + __wishlist.items).
  //   Niente lista parallela — un solo storage condiviso col resto del sito.
  // Not interested: blocco 90gg in localStorage (specifico della Vetrina, niente
  //   metafield per non sporcare wishlist con segnali negativi).
  const BLOCKED_KEY = 'frogmatch_blocked';

  // ── Wishlist Frogames (integrata) ──
  // Fonte affidabile: il METAFIELD cliente custom.wishlist (array di GID), emesso nel
  // bootstrap. Fallback/merge col runtime window.__wishlist.items. Ritorna Set di id.
  let _wishCache = null;
  function getWishlistIds() {
    if (_wishCache) return _wishCache;
    const ids = new Set();
    try {
      const wl = window.FrogMatchVetrinaCustomer && window.FrogMatchVetrinaCustomer.wishlist;
      if (Array.isArray(wl)) { for (const g of wl) { const m = String(g).match(/(\d+)\s*$/); if (m) ids.add(m[1]); } }
    } catch (e) {}
    try { const items = (window.__wishlist && window.__wishlist.items) || []; for (const it of items) ids.add(String(it)); } catch (e) {}
    _wishCache = ids;
    return ids;
  }
  function isWishlisted(productId) {
    if (!productId) return false;
    return getWishlistIds().has(String(productId));
  }
  function toggleWishlistFrogames(productId, handle) {
    if (!productId) {
      console.warn('[Vetrina] wishlist toggle: productId mancante per', handle);
      return false;
    }
    const wasWishlisted = isWishlisted(productId);
    try {
      if (wasWishlisted) {
        if (typeof window.removeFromWishlist === 'function') window.removeFromWishlist(productId);
      } else {
        if (typeof window.addToWishlist === 'function') window.addToWishlist(productId);
      }
    } catch (e) {
      console.warn('[Vetrina] wishlist call error:', e.message);
    }
    // Tracking per algoritmo (peso forte sui segnali wishlist)
    trackEvent(wasWishlisted ? 'wishlist_remove' : 'wishlist_hot', handle);
    _wishCache = null; // invalida cache wishlist (cambiata)
    // Aggiorna anche il set runtime così getWishlistIds resta coerente nella sessione
    try {
      if (!window.__wishlist) window.__wishlist = { items: [] };
      if (!Array.isArray(window.__wishlist.items)) window.__wishlist.items = [];
      const idx = window.__wishlist.items.indexOf(String(productId));
      if (wasWishlisted) { if (idx !== -1) window.__wishlist.items.splice(idx, 1); }
      else if (idx === -1) window.__wishlist.items.push(String(productId));
    } catch (e) {}
    return !wasWishlisted; // nuovo stato
  }

  // ── Carrello rapido (F1) — aggiungi senza aprire la scheda ──
  // Il catalog ha solo il product id → prendo il variant da /products/{h}.js,
  // poi POST /cart/add.js e apro il drawer col pattern del tema (cart:refresh).
  async function addToCartQuick(handle, btn, catalog) {
    if (!handle || (btn && btn.disabled)) return;
    if (btn) { btn.disabled = true; btn.textContent = '…'; }
    try {
      const res = await fetch('/products/' + encodeURIComponent(handle) + '.js', { headers: { 'Accept': 'application/json' } });
      if (!res.ok) throw new Error('product fetch ' + res.status);
      const pj = await res.json();
      const variant = (pj.variants || []).find(v => v.available) || (pj.variants || [])[0];
      if (!variant) throw new Error('no variant');
      const add = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: variant.id, quantity: 1 }] })
      });
      if (!add.ok) throw new Error('cart add ' + add.status);
      // Pattern tema (come frogrush.js / frog-product.js): apre/aggiorna il drawer.
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
      try { trackEvent('cart_add', handle); } catch (e) {}
      if (btn) { btn.textContent = '✓ Fatto'; btn.classList.add('is-added'); }
      showFrogToast('Aggiunto al carrello. Te lo tengo lì.');
    } catch (err) {
      console.warn('[Vetrina] cart add error:', err.message);
      if (btn) btn.textContent = 'Riprova';
      showFrogToast('Non sono riuscito ad aggiungerlo — provalo dalla scheda.');
    } finally {
      if (btn) setTimeout(function () { btn.disabled = false; btn.textContent = '🛒 Aggiungi'; btn.classList.remove('is-added'); }, 1600);
    }
  }

  // ── Add to cart dal MODAL (bottone con label, non l'icona della card) ──
  // Stesso flusso di addToCartQuick ma gestisce il proprio testo ("Aggiungo…"/"✓").
  async function addToCartModal(handle, btn) {
    if (!handle || (btn && btn.disabled)) return;
    const orig = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.innerHTML = 'Aggiungo…'; }
    try {
      const res = await fetch('/products/' + encodeURIComponent(handle) + '.js', { headers: { 'Accept': 'application/json' } });
      if (!res.ok) throw new Error('product fetch ' + res.status);
      const pj = await res.json();
      const variant = (pj.variants || []).find(v => v.available) || (pj.variants || [])[0];
      if (!variant) throw new Error('no variant');
      const add = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: variant.id, quantity: 1 }] })
      });
      if (!add.ok) throw new Error('cart add ' + add.status);
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
      try { trackEvent('cart_add', handle); } catch (e) {}
      if (btn) { btn.innerHTML = '✓ Aggiunto'; btn.classList.add('is-added'); }
      showFrogToast('Aggiunto al carrello. Te lo tengo lì.');
    } catch (err) {
      console.warn('[Vetrina] modal cart add error:', err.message);
      if (btn) btn.innerHTML = 'Riprova';
      showFrogToast('Non sono riuscito ad aggiungerlo — provalo dalla scheda.');
    } finally {
      if (btn) setTimeout(function () { btn.disabled = false; btn.innerHTML = orig; btn.classList.remove('is-added'); }, 1800);
    }
  }

  // ── Frase preordine con precisione (mapping uguale al resto del tema) ──
  function preorderPhrase(dateISO, precision) {
    const monthOnly = formatPreorderDate(String(dateISO).slice(0, 7)); // es. "mar 2026"
    const full = formatPreorderDate(dateISO);                          // es. "1 mar 2026"
    // "stimata", mai "entro": è una previsione, non una garanzia.
    if (precision === 'da_confermare') return 'consegna stimata ' + monthOnly + ' · da confermare';
    if (precision === 'prima_meta')   return 'consegna stimata prima metà ' + monthOnly;
    if (precision === 'seconda_meta') return 'consegna stimata seconda metà ' + monthOnly;
    return 'consegna stimata ' + full;
  }
  // Chip STATO unificato: Preordine / Disponibile / Esaurito. Chiaro e semplice.
  // Priorità: preordine (anche se acquistabile) → esaurito → disponibile.
  function setModalStatus(data) {
    const box = document.querySelector('[data-fm-vt-modal-status]');
    const cart = document.querySelector('[data-fm-vt-modal-cart]');
    const cartFree = cart && !cart.classList.contains('is-added') && !cart.disabled;
    if (!box) return;
    if (data.preorder && data.release) {
      box.dataset.state = 'preorder';
      box.innerHTML = '🌱 <strong>Preordine</strong> · ' + escapeHtml(preorderPhrase(data.release, data.precision));
      box.hidden = false;
      if (cartFree) cart.innerHTML = '🌱 Preordina';
    } else if (data.available === false) {
      box.dataset.state = 'soldout';
      box.innerHTML = '⚫ <strong>Esaurito</strong>';
      box.hidden = false;
      if (cart) { cart.innerHTML = 'Esaurito'; cart.disabled = true; }
    } else if (data.available === true) {
      box.dataset.state = 'available';
      box.innerHTML = '✅ <strong>Disponibile</strong>';
      box.hidden = false;
      if (cartFree) cart.innerHTML = '🛒 Aggiungi al carrello';
    }
  }
  // ── Enrich modal: lingua + stato dai METAFIELD/dati reali del prodotto ──
  // Il catalog del worker non porta lingua/preordine/disponibilità → li leggo
  // on-demand dal template JSON /products/{h}?view=fm-meta (custom.lingua,
  // consegna_fino_al, data_precisione, product.available). Per QUALSIASI prodotto.
  function enrichModalMeta(handle) {
    if (!handle) return;
    // NB: NIENTE header Accept:application/json — con quell'header Shopify serve il
    // JSON standard del prodotto e IGNORA ?view=fm-meta. Senza, rende il nostro template.
    fetch('/products/' + encodeURIComponent(handle) + '?view=fm-meta')
      .then(r => r.ok ? r.text() : null)
      .then(txt => {
        if (!txt) return;
        let data;
        try { data = JSON.parse(txt.trim()); }
        catch (e) { console.warn('[Vetrina] fm-meta parse fallita (template product.fm-meta caricato?):', e.message); return; }
        // Lingua (lista metafield → array, o stringa CSV) → bandiera + nome, IN ALTO
        const slot = document.querySelector('[data-fm-vt-modal-lang]');
        if (slot && data.lang) {
          const langs = Array.isArray(data.lang)
            ? data.lang
            : String(data.lang).split(',').map(s => s.trim()).filter(Boolean);
          if (langs.length) {
            const FLAG = {
              'italiano': '🇮🇹', 'italian': '🇮🇹', 'inglese': '🇬🇧', 'english': '🇬🇧',
              'francese': '🇫🇷', 'french': '🇫🇷', 'tedesco': '🇩🇪', 'german': '🇩🇪',
              'spagnolo': '🇪🇸', 'spanish': '🇪🇸', 'portoghese': '🇵🇹', 'olandese': '🇳🇱',
              'multilingua': '🌍', 'multilingue': '🌍', 'multilingual': '🌍'
            };
            slot.innerHTML = langs.map(function (l) {
              const f = FLAG[String(l).trim().toLowerCase()] || '';
              return (f ? f + ' ' : '') + escapeHtml(l);
            }).join('&nbsp;·&nbsp;');
            slot.hidden = false;
            const sep = document.querySelector('[data-fm-vt-modal-langsep]');
            if (sep) sep.hidden = false;
          }
        }
        // Stato (preordine / disponibile / esaurito)
        setModalStatus(data);
      })
      .catch(() => {});
  }

  // ── Blocco 90gg (not_interested) — localStorage Vetrina-only ──
  function readBlocked() {
    try { return JSON.parse(localStorage.getItem(BLOCKED_KEY) || '{}'); } catch (e) { return {}; }
  }
  function writeBlocked(data) {
    try { localStorage.setItem(BLOCKED_KEY, JSON.stringify(data)); } catch (e) {}
  }
  function toggleBlocked(handle) {
    const b = readBlocked();
    if (b[handle]) {
      delete b[handle];
      writeBlocked(b);
      return false;
    } else {
      b[handle] = Math.floor(Date.now() / 1000);
      writeBlocked(b);
      trackEvent('not_interested', handle);
      return true;
    }
  }
  function isBlocked(handle) {
    const b = readBlocked();
    if (!b[handle]) return false;
    const ageSec = Math.floor(Date.now() / 1000) - b[handle];
    return ageSec < 90 * 86400;
  }

  // ── DAILY DROP — il pick del giorno (MUBI-style: 1 gioco curato + paragrafo lungo) ──
  // Cambia ogni 24h (seed deterministico per giorno). Sempre dal top tier per
  // qualità garantita. Voce di Frog il curatore. Paragrafo 80-120 parole.
  function pickDailyDrop(profile, catalog, picks, spotlightHandle) {
    // Pool: top picks di t1 + t2 esclusi spotlight e t1[0] (già al centro come spotlight)
    // Per evitare che il Daily Drop sia uguale allo Spotlight: shuffle daily separato.
    const customerId = (window.FrogMatchVetrinaCustomer && window.FrogMatchVetrinaCustomer.id) || 'anon';
    const day = getISODate(new Date());
    const dailySeed = customerId + '_daily_' + day;
    function enrich(arr) {
      return (arr || []).map(p => {
        const product = catalog.find(x => x.h === p.h);
        if (!product) return null;
        // Mai un esaurito (o un gioco bloccato) come hero del giorno.
        if (product.av === false || product.available === false) return null;
        if (isBlocked(product.h)) return null;
        return Object.assign({}, p, { product });
      }).filter(Boolean);
    }
    const t1 = enrich(picks.t1);
    const t2 = enrich(picks.t2);
    let pool = [].concat(t1, t2).filter(p => p.h !== spotlightHandle);
    if (pool.length === 0) {
      pool = enrich(picks.t3);
      if (pool.length === 0) return null;
    }
    // Shuffle daily, pesca il primo
    const shuffled = shuffleDeterministic(pool, dailySeed);
    return shuffled[0] || null;
  }

  // Genera paragrafo curatoriale 80-120 parole. Composable da template + dati
  // del profilo + dati del gioco. Voce: Frog, curatore caldo non venditore.
  function buildDailyDropProse(pick, product, profile, customerName, timeCtx) {
    const archetype = detectArchetypeLabel(profile);
    const topMechs = profile.topMechanics || [];
    const topMech = topMechs[0] || '';
    const productMechs = product.mch || [];
    // Mech che il gioco condivide col tuo top
    const sharedMechs = productMechs.filter(m => topMechs.indexOf(m) !== -1).slice(0, 2);
    const companion = pick.comp;
    const com = pick.com || 0;

    const lines = [];

    // Apertura time-aware + personale
    if (timeCtx.moment === 'mattino') {
      lines.push(customerName + ', ti accolgo con questo.');
    } else if (timeCtx.moment === 'sera') {
      lines.push('Stasera tieni d\'occhio questo, ' + customerName + '.');
    } else {
      lines.push('Eccoti il pesce del giorno, ' + customerName + '.');
    }

    // Corpo — perché OGGI proprio questo
    if (companion && companion.name && companion.mechShared >= 2) {
      lines.push('Tocca le stesse corde del tuo ' + companion.name + ', con cui hai macinato ' + companion.plays + ' partite — ma le porta in un terreno nuovo.');
    } else if (sharedMechs.length >= 1 && topMech) {
      lines.push('Vive di ' + sharedMechs.join(' e ') + ', che è esattamente quello che vai cercando.');
    } else if (archetype) {
      lines.push('È stato pensato per il tipo di tavolo che ami — quello dei ' + archetype + '.');
    } else {
      lines.push('Si muove sul terreno che è il tuo.');
    }

    // Trust signal — community o BGG
    if (com >= 5) {
      lines.push(com + ' Frogger della community lo hanno già nello scaffale: di solito è un segnale.');
    } else if (product.rk && product.rk > 0 && product.rk <= 200) {
      lines.push('Top ' + product.rk + ' BoardGameGeek mondiale — non è una scoperta tua, è una conferma.');
    } else if (product.rt && product.rt >= 7.5) {
      lines.push('Rating BGG ' + product.rt.toFixed(1) + ': la community lo ama, e io capisco perché.');
    }

    // Chiusura — invito caldo, non vendita
    const closer = [
      'Ti ho lasciato i dettagli sotto. Decidi tu se merita il tuo tavolo.',
      'Apri, guarda. Se ti dice qualcosa, lo trovi qui ogni giorno.',
      'Lo apri, lo guardi, mi dirai.',
      'Ti aspetto di sotto con tutto quello che serve sapere.'
    ];
    const idx = pick.m % closer.length;
    lines.push(closer[idx]);

    return lines.join(' ');
  }

  // Render Daily Drop section — hero box dorato sopra lo Spotlight, full-width
  function renderDailyDrop(pick, product, profile, customerName, timeCtx) {
    if (!product) return '';
    const matchTier = pick.m >= 75 ? 't1' : pick.m >= 60 ? 't2' : pick.m >= 45 ? 't3' : 't4';
    return (
      '<article class="fm-vt-daily" data-fm-vt-card data-pick="' + escapeHtml(JSON.stringify(stripPick(pick))) + '">' +
        '<div class="fm-vt-daily__inner">' +
          '<div class="fm-vt-daily__cover">' +
            '<img src="' + escapeHtml(product.img) + '" alt="' + escapeHtml(product.t) + '" loading="eager">' +
            '<span class="fm-vt-daily__match fm-vt-daily__match--' + matchTier + '">' + pick.m + '<small>%</small></span>' +
          '</div>' +
          '<div class="fm-vt-daily__body">' +
            '<div class="fm-vt-daily__eyebrowRow">' +
              '<span class="fm-vt-daily__eyebrow">' + timeCtx.icon + ' ' + timeCtx.eyebrow + '</span>' +
              '<span class="fm-vt-daily__fresh">fresco oggi</span>' +
            '</div>' +
            '<h2 class="fm-vt-daily__title">' + escapeHtml(product.t) + '</h2>' +
            '<p class="fm-vt-daily__prose">' + escapeHtml(buildDailyDropProse(pick, product, profile, customerName, timeCtx)) + '</p>' +
            '<div class="fm-vt-daily__footer">' +
              '<span class="fm-vt-daily__price">€ ' + escapeHtml(product.price) + '</span>' +
              '<span class="fm-vt-daily__sig">— Frog</span>' +
              '<button type="button" class="fm-vt-daily__cta" data-fm-vt-card-open>Voglio vederlo →</button>' +
            '</div>' +
          '</div>' +
        '</div>' +
      '</article>'
    );
  }

  // ── NARRATIVE — Specchio identità (hero paragraph) ───────────
  // Frase calda tipo "Andrea, sei un Tableau Builder che ama l'engine
  // building, soprattutto in 2 al tavolo. Vediamo cosa ho per te."
  function buildMirror(profile, customerName) {
    const archetype = detectArchetypeLabel(profile);
    const topMechs = (profile.topMechanics || []);
    const topMech = topMechs[0] || '';
    const playerC = detectPreferredPlayerCount(profile);
    const weight = profile.weightTarget || 0;
    const weightWord = weight >= 3.5 ? 'profondi'
                     : weight >= 2.8 ? 'di medio peso'
                     : weight >= 2.0 ? 'accessibili ma con strategia'
                     : weight > 0 ? 'leggeri e veloci'
                     : '';
    const playerStr = playerC === 1 ? 'in solitaria'
                    : playerC === 2 ? 'in 2'
                    : playerC === 3 ? 'in 3'
                    : playerC === 4 ? 'fino a 4'
                    : playerC ? 'a tavoli da ' + playerC : '';

    // Compose: identità + meccanica preferita + player count + peso
    const fragments = [];
    if (archetype) fragments.push('sei un ' + archetype);
    if (topMech) {
      const mechLow = topMech.toLowerCase();
      fragments.push(fragments.length === 0
        ? 'vai forte sull\'' + mechLow
        : 'con un debole per ' + mechLow);
    }
    if (playerStr) fragments.push('giochi soprattutto ' + playerStr);
    if (weightWord) fragments.push('e cerchi giochi ' + weightWord);

    let mirror;
    if (fragments.length === 0) {
      mirror = customerName + ', vediamo cosa ho per te questa settimana.';
    } else {
      mirror = customerName + ', ' + fragments.join(', ') + '. Vediamo cosa ho per te.';
    }
    return mirror;
  }

  // ── HERO VISUAL — montage cover top played per il banner ─────
  // Cerca immagini in playsActivity.topPlayed (cover/image), poi
  // bggCollection.owned, poi manualOwned. Fallback decorativo.
  // Hero visual ONESTO + ATTUALE: gradient temporale 30gg → 90gg → cumulativo.
  // "Chi sei ADESSO" pesato sulle partite recenti, non sul passato.
  //   1. Prima cerca giocati negli ultimi 30gg (plays30d ≥ 2) → "stai giocando questo"
  //   2. Fallback ultimi 90gg (plays90d ≥ 3)                  → "tornato di recente"
  //   3. Ultimo fallback cumulativo (plays ≥ 3)               → "i tuoi di sempre"
  // Tooltip dichiara la finestra: "Wingspan · 5 partite ultimi 30gg"
  function buildHeroVisual(profile) {
    const tp = (profile.playsActivity && profile.playsActivity.topPlayed) || [];
    const candidates = [];
    let labelType = '';

    function pickFromPool(pool, getCount) {
      const out = [];
      for (const g of pool) {
        const img = g.cover || g.image || g.imgFull || g.thumb;
        if (img) out.push({ img, name: g.name, count: getCount(g) });
        if (out.length >= 3) break;
      }
      return out;
    }

    // Debug visibilità: mostra cosa il profilo dice sui campi temporali del topPlayed
    if (tp.length > 0) {
      const sample = tp.slice(0, 5).map(g => g.name + '[plays:' + (g.plays || 0) + ' 30d:' + (g.plays30d || 0) + ' 90d:' + (g.plays90d || 0) + ']').join(', ');
      console.info('[Vetrina] hero data — top 5 topPlayed:', sample);
    } else {
      console.warn('[Vetrina] hero data — topPlayed VUOTO (profile.playsActivity.topPlayed = ' + JSON.stringify(profile.playsActivity) + ')');
    }

    // 1. Ultimi 30gg (chi sei adesso) — soglia 1: anche 1 sola partita conta
    const pool30 = tp.filter(g => g && g.name && (g.plays30d || 0) >= 1)
      .sort((a, b) => (b.plays30d || 0) - (a.plays30d || 0));
    let found = pickFromPool(pool30, g => g.plays30d);
    if (found.length > 0) { candidates.push.apply(candidates, found); labelType = 'ultimi 30gg'; }

    // 2. Ultimi 90gg (pausa breve) — soglia 2
    if (candidates.length === 0) {
      const pool90 = tp.filter(g => g && g.name && (g.plays90d || 0) >= 2)
        .sort((a, b) => (b.plays90d || 0) - (a.plays90d || 0));
      found = pickFromPool(pool90, g => g.plays90d);
      if (found.length > 0) { candidates.push.apply(candidates, found); labelType = 'ultimi 90gg'; }
    }

    // 3. Cumulativo lifetime — soglia 3
    if (candidates.length === 0) {
      const poolLife = tp.filter(g => g && g.name && (g.plays || 0) >= 3)
        .sort((a, b) => (b.plays || 0) - (a.plays || 0));
      found = pickFromPool(poolLife, g => g.plays);
      if (found.length > 0) { candidates.push.apply(candidates, found); labelType = 'cumulativo'; }
    }

    if (candidates.length === 0) {
      console.info('[Vetrina] hero visual: NESSUN candidato, fallback rana');
      return '<div class="fm-vt-hero__visualFallback">🐸</div>';
    }
    console.info('[Vetrina] hero visual:', candidates.length, 'cover · finestra:', labelType, '· nomi:', candidates.map(c => c.name + '(' + c.count + ')').join(', '));

    return candidates.map((c, i) =>
      '<div class="fm-vt-hero__card fm-vt-hero__card--' + i + '" title="' + escapeHtml(c.name) + ' · ' + c.count + ' partite ' + escapeHtml(labelType) + '">' +
        '<img src="' + escapeHtml(c.img) + '" alt="">' +
      '</div>'
    ).join('');
  }

  // ── NARRATIVE — Tagline calda per card medium ────────────────
  // Evito "L'evoluzione naturale di X" (suona marketing-y e spesso non vero):
  // due giochi possono condividere meccaniche senza essere "evoluzione" l'uno dell'altro.
  // Frasi più oneste: "Tocca le stesse corde di X" / "Affine al tuo X".
  // Tetto di riuso del "compagno di tavolo": lo stesso gioco del tuo storico non può
  // fare da riferimento a più di COMPANION_TAGLINE_CAP card nella stessa vetrina.
  // Quando è saturo si passa al compagno successivo più pertinente; se non ce ne sono
  // altri, la card ripiega su una tagline non-compagno. Fix generico (per ogni utente)
  // del bug "tutte le card dicono 'del tuo Jaipur'".
  const COMPANION_TAGLINE_CAP = 2;
  function chooseCompanionUnderCap(pick, product, profile, usage) {
    // Senza budget di render → comportamento storico (miglior candidato singolo).
    if (!usage) return (pick && pick.comp && pick.comp.name) ? pick.comp : null;
    const cands = findCompanionCandidates(product, profile);
    for (const c of cands) {
      const n = usage.get(c.name) || 0;
      if (n < COMPANION_TAGLINE_CAP) { usage.set(c.name, n + 1); return c; }
    }
    return null; // tutti i compagni plausibili già saturi → niente tagline-compagno
  }

  function buildCardTagline(pick, product, profile, usage) {
    const comp = chooseCompanionUnderCap(pick, product, profile, usage);
    if (comp && comp.name) {
      if (comp.mechShared >= 2) {
        return 'Tocca le stesse corde del tuo ' + comp.name + '.';
      }
      return 'Affine al tuo ' + comp.name + '.';
    }
    if (Array.isArray(pick.r) && pick.r.length > 0) {
      const first = pick.r[0] || '';
      const mech = first.replace(/\s*\([^)]*\)\s*$/, '').trim();
      if (mech && first.indexOf('tuo') !== -1) {
        return 'Costruito su ' + mech + ', come ti piace.';
      }
    }
    if (product.rk && product.rk > 0 && product.rk <= 100 && pick.m >= 70) {
      return 'Top ' + product.rk + ' BGG · validato da migliaia di giocatori.';
    }
    if (product.w && profile.weightTarget) {
      const delta = Math.abs(product.w - profile.weightTarget);
      if (delta < 0.4) return 'Nel tuo peso ideale, con le vibes che cerchi.';
    }
    return null; // niente tagline > tagline generica
  }

  // ── Reasons + Explain (per modal) ───────────────────────────
  function buildReasons(matchResult, profile) {
    const reasons = [];
    if (!matchResult || !matchResult.positives) return reasons;
    const topMechs = profile.topMechanics || [];
    for (const pos of matchResult.positives) {
      if (reasons.length >= 3) break;
      if (pos.kind === 'mechanics' && Array.isArray(pos.shared) && pos.shared.length > 0) {
        const mech = pos.shared[0];
        const pos1 = topMechs.indexOf(mech);
        if (pos1 === 0) reasons.push(mech + ' (il tuo top)');
        else if (pos1 >= 0) reasons.push(mech + ' (' + (pos1 + 1) + '° tuo)');
        else reasons.push(mech);
      } else if (pos.kind === 'typology' && Array.isArray(pos.match) && pos.match.length > 0) {
        reasons.push(pos.match[0]);
      } else if (pos.kind === 'category' && Array.isArray(pos.shared) && pos.shared.length > 0) {
        reasons.push('Categoria: ' + pos.shared[0]);
      } else if (pos.kind === 'weight' && pos.delta != null) {
        reasons.push('Peso ' + (matchResult.product && matchResult.product.w || '?') + ' come il tuo target');
      } else if (pos.kind === 'alea' && pos.match) {
        reasons.push('Alea ' + pos.value + ' (in linea)');
      } else if (pos.kind === 'interaction' && pos.match) {
        reasons.push('Interazione ' + pos.value);
      }
    }
    return reasons.slice(0, 3);
  }

  // Formatta un positive/negative del computeMatch in stringa user-friendly.
  // Ognuna delle 11 dimensioni ha shape diversa, traduco in italiano.
  function formatExplainPart(part, product, profile) {
    if (!part || !part.kind) return null;
    switch (part.kind) {
      case 'typology':
        return 'Tipologia ' + ((part.match || []).join(' / ')) + (part.strength === 'high' ? ' (match forte)' : ' (match medio)');
      case 'mechanics':
        const mechList = (part.shared || []).slice(0, 3).join(', ');
        const moreM = (part.count || 0) > 3 ? ' (+ altre ' + ((part.count || 0) - 3) + ')' : '';
        return 'Meccaniche in comune: ' + mechList + moreM;
      case 'categories':
        const catList = (part.shared || []).slice(0, 3).join(', ');
        return 'Categorie in comune: ' + catList;
      case 'weight':
        if (part.diff != null) {
          return 'Peso ' + (part.productW != null ? part.productW.toFixed(1) : '?') +
                 ' vs tuo target ' + (part.userW != null ? part.userW.toFixed(1) : '?') +
                 ' (differenza ' + part.diff.toFixed(1) + ')';
        }
        return 'Peso ' + (part.productW != null ? part.productW.toFixed(1) : '?') +
               ' in linea col tuo ' + (part.userW != null ? part.userW.toFixed(1) : '?');
      case 'duration':
        return 'Durata ' + (part.tmin || '?') + '–' + (part.tmax || '?') + ' min, in linea col tuo solito';
      case 'players':
        return 'Player count ' + (part.pmin || '?') + '–' + (part.pmax || '?') + ' compatibile';
      case 'interaction':
        return 'Interazione ' + part.product + (part.user === part.product ? ' (uguale al tuo)' : ' (tuo preferito: ' + part.user + ')');
      case 'alea':
        return 'Alea ' + part.product + (part.user === part.product ? ' (uguale al tuo)' : ' (tuo preferito: ' + part.user + ')');
      case 'rating':
        return 'Rating BGG ' + (part.value ? part.value.toFixed(1) : '?') + ' — la community lo ama';
      case 'avoided':
        return 'Contiene ' + (part.list || []).slice(0, 2).join(', ') + ' (che tendi a evitare)';
      case 'favorites':
        return 'Centra i tuoi favorites: ' + (part.matched || []).slice(0, 2).join(', ');
      case 'community':
        return part.froggers + ' Frogger del tuo profilo lo hanno';
      case 'realFit':
        return 'Tratti reali in comune: ' + (part.shared || []).slice(0, 3).join(', ');
      case 'ownership':
        return 'Già nella tua collezione';
      default:
        return null;
    }
  }

  function buildExplainObject(result, product, profile) {
    if (!result) return null;
    const out = {
      mech: [], cat: [], typ: [],
      weight: null, duration: null,
      positives: result.positives || [],
      negatives: result.negatives || [],
      unknowns: result.unknowns || []
    };
    const topMechs = profile.topMechanics || [];
    const topCats = profile.topCategories || [];
    if (Array.isArray(product.mch)) {
      for (const m of product.mch) {
        const idx = topMechs.indexOf(m);
        out.mech.push({ name: m, rank: idx >= 0 ? idx + 1 : null });
      }
    }
    if (Array.isArray(product.cat)) {
      for (const c of product.cat) {
        const idx = topCats.indexOf(c);
        out.cat.push({ name: c, rank: idx >= 0 ? idx + 1 : null });
      }
    }
    if (product.w && profile.weightTarget) out.weight = { game: product.w, user: profile.weightTarget };
    if (product.tmin || product.tmax) out.duration = { min: product.tmin, max: product.tmax };
    return out;
  }

  // ── Computazione picks settimanali ──────────────────────────
  function computeWeeklyPicks(profile, catalog) {
    if (!window.FrogMatch || !window.FrogMatch.computeMatch) return null;
    const owned = buildOwnedSets(profile);
    const customerId = (window.FrogMatchVetrinaCustomer && window.FrogMatchVetrinaCustomer.id) || 'anon';
    const now = new Date();
    const week = getISOWeek(now);  // seed della selezione: STABILE nella settimana (spina dorsale riconoscibile)
    const day = getISODate(now);   // conservato per label + Daily Drop (che resta giornaliero)
    const seedBase = customerId + '_' + week;

    const scored = [];
    let excluded = 0, excludedExp = 0, excludedOwned = 0, excludedOOS = 0;
    for (const product of catalog) {
      if (product.is_exp === true) { excluded++; excludedExp++; continue; }
      if (looksLikeExpansion(product)) { excluded++; excludedExp++; continue; }
      if (product.bgg && owned.bggIds.has(product.bgg)) { excluded++; excludedOwned++; continue; }
      if (owned.handles.has(product.h)) { excluded++; excludedOwned++; continue; }
      if ((product.av === false || product.available === false)) { excluded++; excludedOOS++; continue; }
      if (isBlocked(product.h)) { excluded++; continue; } // not_interested attivo
      try {
        const result = window.FrogMatch.computeMatch(profile, product);
        if (!result) continue;
        const score = (typeof result.pct === 'number') ? result.pct : null;
        if (score == null) continue;
        scored.push({ product, score, result });
      } catch (e) { /* skip */ }
    }
    console.info('[Vetrina] Catalog:', catalog.length, '· Esclusi:', excluded,
      '(exp:' + excludedExp + ', owned:' + excludedOwned + ', oos:' + excludedOOS + ')',
      '· Scored:', scored.length);

    // v=8: selezione STABILE nella settimana (spina dorsale). La novità quotidiana
    // arriva da Daily Drop (1 pick/giorno) + deck "Continua a scoprire" (daily).
    const out = { w: week, d: day, v: 8, computed_at: Math.floor(Date.now() / 1000) };
    // Budget compagni condiviso su tutti i tier (t1 costruito per primo = match più
    // alti): impedisce che lo stesso gioco-riferimento saturi la vetrina.
    const compUsage = new Map();
    for (const key of ['t1', 't2', 't3', 't4']) {
      const conf = TIERS[key];
      // Strict half-open interval [min, max) — evita che un gioco con score
      // esattamente sul confine (es. 75) cada in entrambi t1 e t2 (bug visto in UI).
      const inTier = scored.filter(s => s.score >= conf.min && s.score < conf.max);
      inTier.sort((a, b) => b.score - a.score);
      const candidates = inTier.slice(0, 30);
      const shuffled = shuffleDeterministic(candidates, seedBase + '_' + key);
      const picks = shuffled.slice(0, conf.n);
      out[key] = picks.map(p => {
        const pick = {
          h: p.product.h,
          m: Math.round(p.score),
          r: buildReasons(p.result, profile),
          e: buildExplainObject(p.result, p.product, profile),
          comp: findCompanion(p.product, profile),
          com: findCommunityCount(p.product)
        };
        pick.tag = buildCardTagline(pick, p.product, profile, compUsage);
        return pick;
      });
      out[key + '_total'] = inTier.length;
    }
    return out;
  }

  // ── Worker persistence ──────────────────────────────────────
  async function savePicksToWorker(picks) {
    const workerUrl = getWorkerUrl();
    const customerId = window.FrogMatchVetrinaCustomer && window.FrogMatchVetrinaCustomer.id;
    if (!workerUrl || !customerId) return;
    try {
      const res = await fetch(workerUrl.replace(/\/$/, '') + '/api/frogmatch/weekly-picks', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ customerId: String(customerId), picks })
      });
      if (res.ok) console.info('[Vetrina] picks salvati per settimana', picks.w);
    } catch (e) { /* silent */ }
  }

  // ── Persiste Daily Drop al worker (cache server-side per future newsletter/push)
  // Client calcola e mostra subito; il worker mantiene snapshot per Klaviyo/PWA.
  // 1 save al primo load del giorno (rate limit: 5/min sul worker, ridondanza ok).
  async function saveDailyDropToWorker(dailyPick) {
    const workerUrl = getWorkerUrl();
    const customerId = window.FrogMatchVetrinaCustomer && window.FrogMatchVetrinaCustomer.id;
    if (!workerUrl || !customerId || !dailyPick || !dailyPick.h) return;
    const day = getISODate(new Date());
    // Evita re-save nello stesso giorno (localStorage marker)
    const markerKey = 'frogmatch_daily_saved_' + day;
    try {
      if (localStorage.getItem(markerKey)) return;
    } catch (e) { /* ignore */ }
    try {
      const res = await fetch(workerUrl.replace(/\/$/, '') + '/api/frogmatch/daily', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          customerId: String(customerId),
          day: day,
          dailyDrop: { h: dailyPick.h, m: dailyPick.m, tag: dailyPick.tag || null }
        })
      });
      if (res.ok) {
        try { localStorage.setItem(markerKey, '1'); } catch (e) {}
        console.info('[Vetrina] Daily Drop salvato al worker per', day);
      }
    } catch (e) { /* silent — è solo cache opzionale */ }
  }

  // ── MOOD detection — stringente per evitare che lo stesso gioco appaia
  // in più chip non distinguibili (es. "Solo" vs "In 2" mostravano gli stessi
  // perché un gioco 1-4 ha sia f.solo che f.t2p).
  function detectMoods(product) {
    const moods = [];
    const f = product.f || {};
    const pmin = product.pmin || 0;
    const pmax = product.pmax || 0;
    const w = product.w || 0;
    const tmax = product.tmax || 0;

    // SOLO: gioco progettato per il solitario.
    //   - Solo puro (pmax === 1) → mood "solo" forte
    //   - Solo-friendly con BGG flag (f.solo) e pmin === 1 → mood "solo" debole
    //   - Esclude giochi 2+ che sono solo "anche solo" come fallback
    if (pmax === 1 || (f.solo && pmin === 1 && pmax <= 3)) moods.push('solo');

    // IN 2: progettato/eccellente in 2 — pmin ≤ 2, pmax ≥ 2, flag t2p,
    //   e NON solo-only (escluso da chi è pmax === 1).
    if (f.t2p && pmin <= 2 && pmax >= 2 && pmax !== 1) moods.push('duet');

    // FAMIGLIA: party OR coop OR leggero family-friendly.
    //   Escludo giochi pesanti (w > 2.8) anche se hanno pmin basso.
    if (f.party) moods.push('family');
    else if (f.coop && w > 0 && w <= 2.8) moods.push('family');
    else if (pmin <= 2 && w > 0 && w <= 2.4 && tmax > 0 && tmax <= 60) moods.push('family');

    // VELOCE: durata max ≤ 45 min (tutto)
    if (tmax > 0 && tmax <= 45) moods.push('quick');

    // CERVELLO: weight ≥ 3 (heavy strategici)
    if (w >= 3) moods.push('heavy');

    return moods;
  }

  // ── Strip pick per JSON nei data-attr (no .product circolare) ─
  function stripPick(pick) {
    const out = {};
    for (const k of ['h', 'm', 'r', 'e', 'comp', 'com', 'tag']) {
      if (pick[k] !== undefined) out[k] = pick[k];
    }
    return out;
  }

  // ── CURATED — leggi handle prodotti dalle collezioni Shopify ─
  // Bootstrappate dallo snippet frogmatch-vetrina-curated.liquid.
  // Lo snippet emette ARRAY [{handle, products}] (più robusto di oggetto).
  // Qui ricostruisco la mappa {handle: [productHandles]}.
  function readCuratedData() {
    const el = document.getElementById('frogmatch-vetrina-curated');
    if (!el) return {};
    // Sanitize: trim + strip BOM + strip control chars iniziali (\x00-\x1F).
    let txt = (el.textContent || '').trim().replace(/^﻿/, '').replace(/^[\x00-\x1F]+/, '');
    if (!txt) return {};
    try {
      const parsed = JSON.parse(txt);
      const data = {};
      if (Array.isArray(parsed)) {
        for (const entry of parsed) {
          if (entry && entry.handle && Array.isArray(entry.products)) {
            data[entry.handle] = entry.products;
          }
        }
      } else if (parsed && typeof parsed === 'object') {
        Object.assign(data, parsed); // backward compat con vecchio formato oggetto
      }
      const found = Object.keys(data).length;
      console.info('[Vetrina] curated:', found, 'collezioni →',
        Object.keys(data).map(k => k + '(' + (data[k] || []).length + ')').join(', '));
      return data;
    } catch (e) {
      console.warn('[Vetrina] curated parse error:', e.message,
        '· first 120 chars:', JSON.stringify(txt.substring(0, 120)),
        '· length:', txt.length);
      return {};
    }
  }

  // F1 — date preordini (consegna_fino_al) emesse dal section liquid: { handle: data }.
  let _preDatesCache = null;
  function readPreorderDates() {
    if (_preDatesCache) return _preDatesCache;
    _preDatesCache = {};
    try {
      const el = document.getElementById('frogmatch-preorder-dates');
      const txt = el && (el.textContent || '').trim();
      if (txt) _preDatesCache = JSON.parse(txt) || {};
    } catch (e) { _preDatesCache = {}; }
    return _preDatesCache;
  }
  // "2026-03-01" → "1 mar 2026" · "2026-03" → "mar 2026" · altro → raw
  function formatPreorderDate(d) {
    if (!d) return '';
    const m = String(d).match(/^(\d{4})-(\d{2})(?:-(\d{2}))?/);
    if (m) {
      const months = ['gen', 'feb', 'mar', 'apr', 'mag', 'giu', 'lug', 'ago', 'set', 'ott', 'nov', 'dic'];
      const mo = months[parseInt(m[2], 10) - 1] || '';
      return (m[3] ? (parseInt(m[3], 10) + ' ') : '') + mo + ' ' + m[1];
    }
    return String(d);
  }

  // Mapping handle Shopify → metadata UI. Più handle possono mappare lo stesso id
  // (es. "hotness" + "hot" → entrambi 'hot'), il dedupe evita di emettere 2 row uguali.
  // HANDLE REALI Frogames (confermati 2026-06). Più handle → stesso id = dedup.
  // ── Le corsie del «polso» da FrogTop ──────────────────────────────
  // Prima venivano da tre collezioni Shopify tenute vive dai tag dell'app
  // reSort (bestseller-20, hotness, piu-visti). Ora le classifiche le
  // calcola FrogTop sui NOSTRI dati: si chiedono i tre JSON, si prendono
  // gli handle, e la vetrina li tratta come qualunque altra corsia curated.
  // Se FrogTop non risponde, le tre corsie semplicemente non compaiono:
  // meglio una vetrina piu' corta di una che aspetta.
  const FROGTOP_BASE = 'https://frogtop.info-frogames.workers.dev/chart/';
  const FROGTOP_CURATED = {};
  async function caricaFrogtopCurated() {
    const mappa = { 'frogtop-venduti': 'venduti', 'frogtop-salita': 'salita', 'frogtop-guardati': 'guardati' };
    await Promise.all(Object.keys(mappa).map(async (chiave) => {
      try {
        const ctrl = ('AbortController' in window) ? new AbortController() : null;
        const timer = ctrl ? setTimeout(() => ctrl.abort(), 4000) : null;
        const res = await fetch(FROGTOP_BASE + mappa[chiave] + '.json', ctrl ? { signal: ctrl.signal } : undefined);
        if (timer) clearTimeout(timer);
        if (!res.ok) return;
        const d = await res.json();
        const righe = Array.isArray(d.righe) ? d.righe : [];
        const handles = righe.map(r => r && r.handle).filter(Boolean);
        if (handles.length) FROGTOP_CURATED[chiave] = handles;
      } catch (e) { /* una classifica mancante non ferma la vetrina */ }
    }));
  }

  const CURATED_META = {
    // ── Polso marketplace (F1) ──
    // Le tre corsie del «polso» arrivano da FrogTop (3 set 2026), non piu' dalle
    // collezioni bestseller-20 / hotness / piu-visti, che vivevano sui tag
    // dell'app reSort e sono in ritiro. Stessi id, stesse posizioni: cambia la
    // sorgente, non la vetrina. Vedi caricaFrogtopCurated().
    'frogtop-salita':                 { id: 'hot',        icon: '🔥', title: 'In salita su Frogames',       intro: 'Quello che sta accelerando in questi giorni: vendite, carrelli, sguardi.', layout: 'carousel' },
    'frogtop-guardati':               { id: 'mostviewed', icon: '👥', title: 'Cosa guarda la community',   intro: 'I giochi che i Frogger stanno guardando di più in questi giorni. Se tanti ci fanno un pensiero, vale uno sguardo — e magari scopri qualcosa di nuovo.', layout: 'carousel' },
    'frogtop-venduti':                { id: 'bestseller', icon: '🏆', title: 'I più venduti',               intro: 'I più venduti del momento, fra tutti gli archetipi.',   layout: 'mosaic'   },
    'nuovi-arrivi-1':                 { id: 'new',        icon: '🆕', title: 'Appena arrivati',              intro: 'Le novità di questo periodo dal magazzino.',            layout: 'carousel' },
    'preordine':                      { id: 'preorder',   icon: '🌱', title: 'In arrivo — per te',          intro: 'Preordini in consegna entro 45 giorni, con i più affini a te in cima. Prenotali prima che escano.', layout: 'carousel' },
    'frogdeal-offerte-giochi-da-tavolo': { id: 'frogdeal', icon: '🎯', title: 'In offerta per te',          intro: 'I tagli prezzo attivi, con i più affini al tuo profilo in cima.',  layout: 'carousel' },
    'back-in-stock':                  { id: 'restock',    icon: '🔁', title: 'Tornati disponibili',         intro: 'Erano esauriti, ora ci sono di nuovo. Di solito non restano a lungo.', layout: 'carousel' },
    'frogworld-selections':           { id: 'imported',   icon: '🌍', title: 'Importati da FrogWorld',      intro: 'Chicche estere che portiamo noi. Spesso introvabili altrove in Italia.', layout: 'carousel' },
    // ── Slot push editoriale (dichiarato) ──
    'frogames-picks':                 { id: 'featured',   icon: '🏷️', title: 'Dal team Frogames',           intro: 'Indipendentemente dal tuo match — questa settimana puntiamo su questi.', layout: 'carousel', editorial: true }
    // NB: 'frogpatch' (danneggiati) NON cablato di proposito: i danneggiati condividono
    // il BGG id con la copia normale → conflitto col dedup BGG. Escluso dalla Vetrina.
  };

  // Tagline per card curated — niente "evoluzione di X" personalizzato fuori posto.
  // Mostra match%, community count, o niente.
  function buildCuratedTagline(matchPct, communityCount) {
    if (communityCount >= 5) return communityCount + ' Frogger ce l\'hanno.';
    if (matchPct >= 70) return matchPct + '% match col tuo profilo.';
    if (matchPct >= 50) return 'Anche se per te è ' + matchPct + '%, vale lo sguardo.';
    return null;
  }

  function buildCuratedRows(curatedData, catalog, profile) {
    // Le classifiche FrogTop entrano qui come corsie curated qualsiasi:
    // stesso incrocio col catalogo, stesso dedup, stessa rete anti-esauriti.
    Object.assign(curatedData, FROGTOP_CURATED);
    const rows = [];
    const preDates = readPreorderDates(); // date consegna per la row "In arrivo"
    const ownedCur = buildOwnedSets(profile); // escludi i giochi che POSSIEDI dalle curated
    const seenIds = new Set();
    for (const handle in curatedData) {
      const meta = CURATED_META[handle];
      if (!meta) {
        console.warn('[Vetrina] curated handle senza META:', handle, '(aggiungi a CURATED_META se vuoi mostrarla)');
        continue;
      }
      if (seenIds.has(meta.id)) continue;
      const productHandles = curatedData[handle] || [];
      const rowSeenBgg = new Set();   // dedupe edizioni doppie (ENG+ITA) dentro la stessa row curated
      let picks = productHandles
        .map(h => {
          const product = catalog.find(p => p.h === h);
          if (!product) {
            console.warn('[Vetrina] curated handle "' + handle + '": prodotto "' + h + '" non in catalog (skip)');
            return null;
          }
          if (product.bgg) { if (rowSeenBgg.has(product.bgg)) return null; rowSeenBgg.add(product.bgg); }
          // Mai esauriti, nemmeno nelle row curated/editoriali.
          if (product.av === false || product.available === false) return null;
          if (isKnownOOS(product.h)) return null; // già noto esaurito (cache sweep) → niente conteggio gonfiato poi sgonfiato
          // FrogMatch = scoperta: non proporre giochi che il cliente GIÀ POSSIEDE.
          if ((product.bgg && ownedCur.bggIds && ownedCur.bggIds.has(product.bgg)) || (ownedCur.handles && ownedCur.handles.has(product.h))) return null;
          // Trust del curatore sui Picks editoriali: NO filtro espansioni.
          // Sulle altre collezioni curated (hot, bestseller…) filtra come prima.
          if (!meta.editorial) {
            if (product.is_exp === true || looksLikeExpansion(product)) return null;
          }
          // Rispetta sempre il blocco utente (✕) anche su curated/editoriali —
          // è una scelta personale che vale ovunque, non solo nelle row personali.
          if (isBlocked(product.h)) return null;
          let m = 50;
          try {
            const r = window.FrogMatch.computeMatch(profile, product);
            if (r && typeof r.pct === 'number') m = Math.round(r.pct);
          } catch (e) {}
          const com = findCommunityCount(product);
          return {
            h: product.h,
            m: m,
            r: [],
            e: null,
            comp: null,
            com: com,
            tag: meta.editorial ? null : buildCuratedTagline(m, com),
            preorderDate: (meta.id === 'preorder') ? (preDates[product.h] || null) : null,
            product: product
          };
        })
        .filter(Boolean);
      // FROGMATCH REGNA SU TUTTO: ogni row curated è ordinata per il TUO match (più
      // affini davanti, poi a scalare). È ciò che rende unica la Vetrina rispetto al
      // semplice "vai alla collezione". UNICA eccezione: l'editoriale "Dal team Frogames"
      // (push dichiarato, ordine scelto dal team).
      if (meta.id === 'preorder') {
        // "In arrivo": solo preordini in consegna entro 45 giorni + ordinati per match.
        const limit45 = Date.now() + 45 * 86400 * 1000;
        picks = picks.filter(p => {
          if (!p.preorderDate) return false;          // senza data certa → fuori
          const t = Date.parse(p.preorderDate);
          return !isNaN(t) && t <= limit45;            // in arrivo entro 45 giorni
        }).sort((a, b) => (b.m || 0) - (a.m || 0));
      } else if (!meta.editorial) {
        picks.sort((a, b) => (b.m || 0) - (a.m || 0)); // più affini a te in cima
      }
      picks = picks.slice(0, 10);
      // Soglia minima più bassa per Picks editoriali (può anche essere 2 giochi spinti)
      const minPicks = meta.editorial ? 2 : 3;
      // Diagnostica per Picks editoriali: rendono visibile perché una row non scatta
      if (meta.editorial) {
        console.info('[Vetrina] EDITORIAL "' + handle + '":',
          productHandles.length, 'handle in collezione →',
          picks.length, 'picks utilizzabili (min richiesto: ' + minPicks + ')');
        if (picks.length === 0 && productHandles.length > 0) {
          console.warn('[Vetrina] EDITORIAL "' + handle + '" ha ' + productHandles.length +
            ' prodotti in collezione ma NESSUNO viene trovato in catalog. ' +
            'Possibili cause: handle differente, prodotti fuori catalog.all, prodotti non disponibili.');
        }
      }
      if (picks.length >= minPicks) {
        seenIds.add(meta.id);
        rows.push({
          id: 'curated-' + meta.id,
          layout: meta.layout,
          icon: meta.icon,
          title: meta.title,
          intro: meta.intro,
          picks: picks,
          curated: true,
          editorial: meta.editorial === true
        });
      }
    }
    console.info('[Vetrina] curated rows:', rows.map(r => r.id + '(' + r.picks.length + ')').join(' · '));
    return rows;
  }

  // ── COLLECTION-ENGINE (F2) — row Vetrina da metaobject, senza codice ──
  // Legge la config emessa dal section liquid (#frogmatch-vetrina-rows): ogni voce
  // del metaobject "vetrina_row" diventa una row, con titolo/intro/icona/layout dal
  // config e prodotti dalla collezione collegata. Marketing aggiunge row senza dev.
  function readDynamicRows() {
    const el = document.getElementById('frogmatch-vetrina-rows');
    if (!el) return [];
    try { const a = JSON.parse((el.textContent || '').trim()); return Array.isArray(a) ? a : []; } catch (e) { console.warn('[Vetrina] dynamic rows parse error:', e.message); return []; }
  }
  function buildDynamicRows(catalog, profile) {
    const cfg = readDynamicRows();
    if (!cfg.length) return [];
    const out = [];
    for (const r of cfg) {
      const seenBgg = new Set();
      const picks = (r.products || []).map(h => {
        const product = catalog.find(p => p.h === h);
        if (!product) return null;
        if (product.bgg) { if (seenBgg.has(product.bgg)) return null; seenBgg.add(product.bgg); }
        if (product.av === false || product.available === false) return null;
        if (isBlocked(product.h)) return null;
        if (!r.editorial && (product.is_exp === true || looksLikeExpansion(product))) return null;
        let m = 50;
        try { const rr = window.FrogMatch.computeMatch(profile, product); if (rr && typeof rr.pct === 'number') m = Math.round(rr.pct); } catch (e) {}
        const com = findCommunityCount(product);
        return { h: product.h, m: m, r: [], e: null, comp: null, com: com, tag: r.editorial ? null : buildCuratedTagline(m, com), product: product };
      }).filter(Boolean).slice(0, 10);
      const minPicks = r.editorial ? 2 : 3;
      if (picks.length >= minPicks) {
        out.push({
          id: 'dyn-' + (r.key || out.length),
          layout: r.layout || 'carousel',
          icon: r.icon || '✨',
          title: r.title || '',
          intro: r.intro || '',
          picks: picks,
          curated: true,
          editorial: r.editorial === true,
          order: typeof r.order === 'number' ? r.order : 50
        });
      }
    }
    out.sort((a, b) => a.order - b.order);
    if (out.length) console.info('[Vetrina] dynamic rows (metaobject):', out.map(r => r.title + '(' + r.picks.length + ')').join(' · '));
    return out;
  }

  // Strategia di interleave tra row personali e curated.
  // Ordine narrativo: te (1) → community (1) → te (1) → community (1)... per dare
  // ritmo "specchio + polso community". Le row personali "core" (pairing, evolution,
  // hot, tavolo) sono entrelacée con curated. Le row finali (scoperta, beyond,
  // catch-all) chiudono in fondo come zona "fuori dal solito".
  function interleavePersonalCurated(personal, curated) {
    // L0 "La tua roba" (F0.5) resta SEMPRE in cima, raggruppata, FUORI dall'interleave:
    // è la spine anti-stanchezza, non va spezzata da row community.
    const headIds = new Set(['topmatch', 'valutando', 'riprendi', 'radar', 'curated-mostviewed']);
    const tailIds = new Set(['discovery', 'beyond', 'rest']);
    // Testa = L0 personali + match alti + community promossa, in ORDINE ESPLICITO:
    // Riprendi (continuità) → I tuoi match più alti (cuore FrogMatch) → Radar → Community.
    const headOrder = ['riprendi', 'topmatch', 'radar', 'curated-mostviewed'];
    const head = personal.filter(r => headIds.has(r.id)).concat(curated.filter(r => headIds.has(r.id)))
      .sort((a, b) => {
        const ia = headOrder.indexOf(a.id), ib = headOrder.indexOf(b.id);
        return (ia === -1 ? 99 : ia) - (ib === -1 ? 99 : ib);
      });
    const core = personal.filter(r => !headIds.has(r.id) && !tailIds.has(r.id));
    const tail = personal.filter(r => tailIds.has(r.id));
    const curatedRest = curated.filter(r => !headIds.has(r.id)); // curated NON in testa

    const out = [];
    for (const r of head) out.push(r);   // testa: la tua roba + community, compatta
    let pi = 0, ci = 0;
    // Alterna 1:1 finché entrambi hanno materiale
    while (pi < core.length || ci < curatedRest.length) {
      if (pi < core.length) out.push(core[pi++]);
      if (ci < curatedRest.length) out.push(curatedRest[ci++]);
    }
    // Tail in fondo (scoperta/beyond/catch-all chiudono sempre)
    for (const r of tail) out.push(r);
    return out;
  }

  // ── BUILD ROWS — compone le N righe-per-motivazione con DEDUPE ──
  // Ordine processing per "selettività" (chi pesca da pool ristretto va prima):
  //   1. Pairing (sinergia mech) → 2 picks t2 (top1 t1 escluso = spotlight)
  //   2. Evoluzione Favorites (companion forte) → 5 picks
  //   3. Hot tra archetipo (community count) → 4 picks
  //   4. Per il tavolo in N (player count flag) → 4 picks
  //   5. Scoperta della settimana (1 pick t3 top)
  //   6. Fuori dal solito (3 picks t4)
  // Ogni row marca i suoi picks come "usati": le row successive non li ripescano.
  function buildRows(profile, picks, catalog, spotlightHandle) {
    const rows = [];
    const ownedRows = buildOwnedSets(profile); // giochi POSSEDUTI/acquistati → mai nei consigli
    const used = new Set();      // handle già usati
    const usedBgg = new Set();   // BGG id già usati → evita doppioni stesso gioco (es. edizione ENG + ITA)
    if (spotlightHandle) {
      used.add(spotlightHandle);
      const _sp = catalog.find(p => p.h === spotlightHandle);
      if (_sp && _sp.bgg) usedBgg.add(_sp.bgg);
    }

    // Algoritmo V1: ogni pick prende un BOOST da segnali tracciati (view/click/wish/skip).
    // Decay temporale (≤7gg pieno, 7-30gg ×0.6, 30-90gg ×0.2). Cap ±15% per non
    // stravolgere il match base. Salvato in p.boost + p.ranked (per ranking only).
    function enrich(arr) {
      return (arr || []).map(p => {
        const product = catalog.find(x => x.h === p.h);
        if (!product) return null;
        // Filtra ESAURITI: i picks possono essere stati calcolati quando il gioco
        // era disponibile, ma ora è OOS. Il catalog (worker o DOM) ha sempre av
        // aggiornato → ricontrolliamo qui, gateway di tutte le row personali.
        if (product.av === false || product.available === false) return null;
        if (isKnownOOS(p.h)) return null; // già noto esaurito (cache sweep) → niente lampeggio
        // MAI consigliare un gioco che il cliente GIÀ POSSIEDE (FrogMatch = scoperta).
        if ((product.bgg && ownedRows.bggIds && ownedRows.bggIds.has(product.bgg)) || (ownedRows.handles && ownedRows.handles.has(product.h))) return null;
        // Rispetta anche il blocco utente (✕) per coerenza con le altre row.
        if (isBlocked(product.h)) return null;
        const rawBoost = computeInterestScore(p.h);
        // rawBoost varia ∞: 1 click=+3 raw, 1 wishlist=+10 raw. Comprimo ×0.5
        // → 10 raw ≈ +5% boost. Saturo a ±15% per non stravolgere il match base.
        const boost = Math.max(-15, Math.min(15, rawBoost * 0.5));
        // Anti-ripetizione: se "stanco" (mostrato ≥3 sessioni senza interesse),
        // penalizza il ranking → scivola in fondo/fuori, entrano facce nuove.
        const fatiguePen = isFatigued(p.h) ? FATIGUE_PENALTY : 0;
        return Object.assign({}, p, {
          product: product,
          boost: boost,
          ranked: Math.max(0, Math.min(100, (p.m || 0) + boost - fatiguePen))
        });
      }).filter(Boolean);
    }
    // Risolve il BGG id di un pick (da .product, da .bgg, o cercando nel catalog).
    function bggOf(p) {
      if (p && p.product && p.product.bgg) return p.product.bgg;
      if (p && p.bgg) return p.bgg;
      if (p && p.h) { const _x = catalog.find(c => c.h === p.h); if (_x && _x.bgg) return _x.bgg; }
      return null;
    }
    // Un gioco è "usato" se il suo handle O il suo BGG id sono già stati emessi.
    // Il check BGG evita di mostrare due edizioni dello stesso gioco (ENG + ITA).
    function notUsed(p) {
      if (used.has(p.h)) return false;
      const b = bggOf(p);
      if (b && usedBgg.has(b)) return false;
      return true;
    }
    function markUsed(arr) {
      for (const p of arr) {
        used.add(p.h);
        const b = bggOf(p);
        if (b) usedBgg.add(b);
      }
    }

    const t1 = enrich(picks.t1);
    const t2 = enrich(picks.t2);
    const t3 = enrich(picks.t3);
    const t4 = enrich(picks.t4);
    const allHi = [].concat(t1, t2);
    const allMid = [].concat(t1, t2, t3);
    const allAll = [].concat(t1, t2, t3, t4);

    // 0. L0 "LA TUA ROBA" — i blocchi persistenti che parlano del CLIENTE, in cima.
    // Anti-stanchezza (F0.5): prima la sua roba, non il catalogo. Tre intenzioni:
    //  · Stai valutando — aperto ≥3 volte (30gg), non in wishlist → sta decidendo
    //  · Riprendi da dove eri — aperto 1-2 volte (30gg) → ha sbirciato
    //  · Il tuo radar — la wishlist Frogames, viva
    // Helper: pick "ricco" da un handle (match% al volo + tag), con tutti i filtri.
    function buildSeenPick(h, tagText) {
      if (used.has(h) || isBlocked(h)) return null;
      const product = catalog.find(p => p.h === h);
      if (!product) return null;
      if (product.av === false || product.available === false) return null;
      if (isKnownOOS(h)) return null; // già noto esaurito → niente lampeggio
      if (product.bgg && usedBgg.has(product.bgg)) return null;
      let m = 50;
      try { const r = window.FrogMatch.computeMatch(profile, product); if (r && typeof r.pct === 'number') m = Math.round(r.pct); } catch (e) {}
      return { h: h, m: m, r: [], comp: findCompanion(product, profile), com: findCommunityCount(product), tag: tagText, product: product };
    }
    // Wishlist (product-id) per separare il radar da valutando/riprendi.
    const wishIds = getWishlistIds();
    function isWishlistedHandle(h) { const p = catalog.find(x => x.h === h); return !!(p && wishIds.has(String(p.id))); }
    // Giochi che il cliente GIÀ POSSIEDE o GIOCA → non li "sta valutando" (bug Harmonies).
    const haveL0 = new Set();
    try {
      const ownedL0 = buildOwnedSets(profile);
      for (const p of catalog) { if (p.bgg && ownedL0.bggIds && ownedL0.bggIds.has(p.bgg)) haveL0.add(p.h); }
      if (ownedL0.handles) ownedL0.handles.forEach(h => haveL0.add(h));
      const playedL0 = (profile.playsActivity && profile.playsActivity.topPlayed) || [];
      if (playedL0.length) {
        const byT = {};
        for (const p of catalog) { byT[(p.t || '').toLowerCase().trim()] = p.h; }
        for (const g of playedL0) { const hh = g && g.name && byT[g.name.toLowerCase().trim()]; if (hh) haveL0.add(hh); }
      }
    } catch (e) {}
    // Visti di recente (30gg), distinti, dal più recente — fino a 24 raccolti.
    try {
      const raw = localStorage.getItem(EVENT_STORAGE_KEY);
      if (raw) {
        const events = JSON.parse(raw);
        const cutoff = Math.floor(Date.now() / 1000) - 30 * 86400;
        const seenH = new Set();
        const recentHandles = [];
        for (let i = events.length - 1; i >= 0; i--) {
          const e = events[i];
          if (e.n !== 'click_open') continue;
          if (e.t < cutoff) break;
          if (!e.h || seenH.has(e.h)) continue;
          seenH.add(e.h);
          recentHandles.push(e.h);
          if (recentHandles.length >= 40) break;
        }
        // UNICA sezione "Riprendi da dove eri": tutti i giochi aperti di recente
        // (non wishlist/posseduti), ORDINATI per interesse (prima quelli a cui sei
        // tornato di più). L'intensità è sulla card ("ci sei tornato N volte").
        const seenList = [];
        for (const h of recentHandles) {
          if (isWishlistedHandle(h)) continue; // i wishlistati vanno nel radar
          if (haveL0.has(h)) continue;         // già posseduto/giocato → non qui
          const opens = countRecentVisits(h, 30);
          const pick = buildSeenPick(h, opens >= 2 ? ('Ci sei tornato ' + opens + ' volte — ti aiuto a decidere.') : 'L\'avevi aperto di recente.');
          if (!pick) continue;
          pick._opens = opens;
          seenList.push(pick);
        }
        seenList.sort((a, b) => (b._opens || 0) - (a._opens || 0)); // più tornato = più in alto
        if (seenList.length >= 2) {
          const v = seenList.slice(0, 18);
          rows.push({ id: 'riprendi', layout: 'carousel', icon: '👁️', title: 'Riprendi da dove eri', intro: 'I giochi che hai aperto di recente — prima quelli a cui sei tornato.', picks: v });
          markUsed(v);
        }
      }
    } catch (e) { /* localStorage non disponibile, silent */ }
    // "Giochi che segui" (wishlist): le NOVITÀ (calo prezzo) in cima — non si perdono
    // mai — e il RESTO a rotazione settimanale, così con wishlist da 100 giochi nel
    // tempo li rivedi tutti invece di vedere sempre gli stessi 12.
    try {
      const mem = loadMem();
      const radarSeen = new Set();
      const news = [], restW = [];
      for (const p of catalog) {
        if (!wishIds.has(String(p.id))) continue;
        if (used.has(p.h) || isBlocked(p.h)) continue;
        if (p.av === false || p.available === false || isKnownOOS(p.h)) continue;
        if (p.bgg) { if (radarSeen.has(p.bgg)) continue; radarSeen.add(p.bgg); }
        const pick = buildSeenPick(p.h, 'Lo segui tu.');
        if (!pick) continue;
        // Novità = calo prezzo dal baseline salvato quando l'hai aggiunto.
        const base = mem[p.h];
        let dropped = false;
        if (base && typeof base.p === 'number' && base.p > 0) {
          const cur = parseFloat(String(p.price || '0').replace(',', '.')) || 0;
          if (cur > 0 && cur < base.p - 0.01) { dropped = true; pick.tag = '💶 In calo: era € ' + base.p.toFixed(2).replace('.', ',') + '.'; }
        }
        (dropped ? news : restW).push(pick);
      }
      // Rotazione settimanale del resto (stabile nella settimana, fresca ogni lunedì).
      const seedR = ((window.FrogMatchVetrinaCustomer && window.FrogMatchVetrinaCustomer.id) || 'a') + '_radar_' + getISOWeek(new Date());
      const radar = news.concat(shuffleDeterministic(restW, seedR)).slice(0, 15);
      if (radar.length >= 2) {
        const totFollow = news.length + restW.length;
        rows.push({
          id: 'radar', layout: 'carousel', icon: '🎯', title: 'Giochi che segui',
          intro: totFollow > 15
            ? ('La tua lista desideri (' + totFollow + ') — novità in cima, il resto a rotazione ogni settimana.')
            : 'La tua lista desideri — te la tengo d\'occhio per cali prezzo e ritorni.',
          picks: radar
        });
        markUsed(radar);
      }
    } catch (e) { /* silent */ }

    // 0.5 I TUOI MATCH PIÙ ALTI — IL CUORE DI FROGMATCH: i giochi più affini che NON
    // hai ancora (i picks escludono i posseduti; qui tolgo anche i wishlistati = radar).
    // Struttura: TOP FISSI in alto (i veri match più alti, stabili) + RESTO a rotazione
    // settimanale tramite finestra scorrevole → ogni gioco torna ~ogni 5 settimane (~35gg),
    // non subito e non tutto in blocco. Deterministico (stabile nella settimana).
    const wishM = getWishlistIds();
    const TM_POOL = 24, TM_CAP = 12;
    // Pool = i tuoi top match (non posseduti, non wishlist), ordinati per affinità.
    const matchPool = allAll.filter(notUsed)
      .filter(p => p.product && !wishM.has(String(p.product.id)))
      .sort((a, b) => (b.ranked || b.m) - (a.ranked || a.m))
      .slice(0, TM_POOL);
    let topMatch;
    if (matchPool.length <= TM_CAP) {
      topMatch = matchPool; // pochi: mostrali tutti, già dal più alto
    } else {
      // Ogni settimana pesco 12 dal pool (shuffle settimanale) → niente fissi, ruotano e
      // tornano a giro. Poi li mostro ORDINATI PER MATCH: i più alti sempre davanti.
      const cid = (window.FrogMatchVetrinaCustomer && window.FrogMatchVetrinaCustomer.id) || 'a';
      topMatch = shuffleDeterministic(matchPool, cid + '_topmatch_' + getISOWeek(new Date()))
        .slice(0, TM_CAP)
        .sort((a, b) => (b.ranked || b.m) - (a.ranked || a.m));
    }
    if (topMatch.length >= 3) {
      rows.push({
        id: 'topmatch',
        layout: 'carousel',
        icon: '🎯',
        title: 'I tuoi match più alti',
        intro: 'I giochi che ti somigliano di più — e che non hai ancora. I più affini sempre davanti; cambiano ogni settimana, così ne scopri di nuovi.',
        picks: topMatch
      });
      markUsed(topMatch);
    }

    // 1. PAIRING DELLA SETTIMANA — 2 picks con sinergia (≥1 mech in comune,
    // si tiene il miglior overlap globale; soglia bassa = sempre trovata se
    // ci sono almeno 2 picks con mech popolati).
    const pairPool = allHi.filter(notUsed);
    let pair = null, pairScore = 0;
    for (let i = 0; i < pairPool.length; i++) {
      for (let j = i + 1; j < pairPool.length; j++) {
        const a = pairPool[i], b = pairPool[j];
        // Mai accoppiare due edizioni dello stesso gioco (stesso BGG id, es. ENG + ITA)
        if (a.product.bgg && a.product.bgg === b.product.bgg) continue;
        const aMech = new Set(a.product.mch || []);
        const aCat = new Set(a.product.cat || []);
        const sharedMech = (b.product.mch || []).filter(m => aMech.has(m));
        const sharedCat = (b.product.cat || []).filter(c => aCat.has(c));
        if (sharedMech.length < 1) continue;
        const score = sharedMech.length * 2 + sharedCat.length;
        if (score > pairScore) {
          pair = { a, b, sharedMech, sharedCat };
          pairScore = score;
        }
      }
    }
    if (pair) {
      rows.push({
        id: 'pairing',
        layout: 'paired',
        icon: '🤝',
        title: 'La coppia della settimana',
        intro: 'Insieme funzionano: condividono ' + pair.sharedMech.slice(0, 2).join(' e ') + '. Apri con uno, chiudi con l\'altro.',
        picks: [pair.a, pair.b]
      });
      markUsed([pair.a, pair.b]);
    }

    // 2. EVOLUZIONE FAVORITES — picks con companion forte sul tuo top played
    const topPlayedFavs = ((profile.playsActivity && profile.playsActivity.topPlayed) || [])
      .filter(g => g && g.name && (g.plays || 0) >= 3);
    if (topPlayedFavs.length >= 1) {
      const favName = topPlayedFavs[0].name;
      const evolution = allAll.filter(notUsed)
        .filter(p => p.comp && p.comp.name === favName && p.comp.mechShared >= 1)
        .sort((a, b) => ((b.comp.mechShared * 2) + b.comp.catShared) - ((a.comp.mechShared * 2) + a.comp.catShared))
        .slice(0, 10);
      if (evolution.length >= 2) {
        rows.push({
          id: 'evolution',
          layout: 'carousel',
          icon: '🌱',
          title: 'L\'evoluzione di ' + favName,
          intro: 'Hai messo ' + (topPlayedFavs[0].plays || 0) + ' partite su ' + favName + '. Questi gli danno il passaggio di consegne.',
          picks: evolution
        });
        markUsed(evolution);
      }
    }

    // 3. HOT TRA IL TUO ARCHETIPO — picks con community count alto
    let hot = allAll.filter(notUsed)
      .filter(p => p.com >= 3)
      .sort((a, b) => b.com - a.com)
      .slice(0, 8);
    // V2: diversità — no 3+ giochi consecutivi stessa mech anche su questa row
    hot = diversifyByMech(hot, 2);
    if (hot.length >= 2) {
      const archName = detectArchetypeLabel(profile) || 'Frogger come te';
      rows.push({
        id: 'hot',
        layout: 'carousel',
        icon: '🔥',
        title: 'Hot tra i ' + archName,
        intro: 'I Frogger del tuo profilo li hanno scelti questa settimana.',
        picks: hot
      });
      markUsed(hot);
    }

    // 4. PER IL TAVOLO IN N — flag su prodotto + player count preferito
    const preferredP = detectPreferredPlayerCount(profile);
    if (preferredP) {
      const flagKey = preferredP === 1 ? 'solo' : preferredP === 2 ? 't2p' : 'team';
      let tablePicks = allAll.filter(notUsed)
        .filter(p => p.product.f && p.product.f[flagKey])
        .sort((a, b) => (b.ranked || b.m) - (a.ranked || a.m)).slice(0, 6);
      // V2: diversità intra-feed — no 3+ giochi consecutivi stessa mech
      tablePicks = diversifyByMech(tablePicks, 2);
      if (tablePicks.length >= 2) {
        const icon = preferredP === 1 ? '🎲' : preferredP === 2 ? '👥' : '🎉';
        const label = preferredP === 1 ? 'solitaria' : preferredP + ' giocatori';
        rows.push({
          id: 'players',
          layout: 'mosaic',
          icon,
          title: 'Per il tuo tavolo in ' + label,
          intro: 'Giochi soprattutto in ' + label + '. Ho cercato giochi che brillano in quel formato.',
          picks: tablePicks
        });
        markUsed(tablePicks);
      }
    }

    // 4b. FUORI DALLO STAGNO — Wild Card dichiarata (anti-echo chamber).
    // 15-20% del feed che esce dal pattern del tuo profilo. Pescata da tier
    // bassi (t3/t4) ma con almeno 1 mech in comune (no random pure).
    // Dichiarata visivamente: "questa è fuori dal tuo solito, di proposito".
    const wildPool = [].concat(t3, t4).filter(notUsed).filter(p => {
      // Almeno 1 mech in comune col tuo top: lontano ma non random
      const topMechs = profile.topMechanics || [];
      if (topMechs.length === 0) return true;
      const productMechs = p.product.mch || [];
      return productMechs.some(m => topMechs.indexOf(m) !== -1);
    });
    // Shuffle daily per varietà tra giorni
    // F0.5: seed SETTIMANALE (era giornaliero) → ordine stabile nella settimana.
    const wildSeed = (window.FrogMatchVetrinaCustomer && window.FrogMatchVetrinaCustomer.id || 'a') + '_wild_' + getISOWeek(new Date());
    const wild = shuffleDeterministic(wildPool, wildSeed).slice(0, 6);
    if (wild.length >= 3) {
      rows.push({
        id: 'wild',
        layout: 'carousel',
        icon: '🌑',
        title: 'Fuori dallo Stagno',
        intro: 'Lontano dal tuo solito. Te li propongo apposta — la scoperta, a volte, vale più di una conferma.',
        picks: wild,
        wildCard: true
      });
      markUsed(wild);
    }

    // 5. SCOPERTA DELLA SETTIMANA — top pick t3; con FALLBACK garantito così c'è SEMPRE
    // una scoperta visibile e spiegata (serendipità calibrata: novità dosata + motivo).
    const t3Avail = t3.filter(notUsed).sort((a, b) => (b.ranked || b.m) - (a.ranked || a.m));
    let discoveryPick = t3Avail[0] || null;
    if (!discoveryPick) {
      // Fallback: un gioco di QUALITÀ BGG fuori dal tuo solito (non posseduto/wishlist).
      const ownedD = buildOwnedSets(profile);
      const wishD = getWishlistIds();
      const pool = catalog.filter(p => {
        if (p.av === false || p.available === false) return false;
        if (p.is_exp === true || looksLikeExpansion(p)) return false;
        if (isBlocked(p.h) || used.has(p.h) || wishD.has(String(p.id))) return false;
        if (p.bgg && (usedBgg.has(p.bgg) || (ownedD.bggIds && ownedD.bggIds.has(p.bgg)))) return false;
        return (p.rk && p.rk > 0 && p.rk <= 1500) || (p.rt && p.rt >= 7.5);
      });
      if (pool.length) {
        const seedD = ((window.FrogMatchVetrinaCustomer && window.FrogMatchVetrinaCustomer.id) || 'a') + '_disc_' + getISOWeek(new Date());
        const prod = shuffleDeterministic(pool, seedD)[0];
        let m = 50;
        try { const r = window.FrogMatch.computeMatch(profile, prod); if (r && typeof r.pct === 'number') m = Math.round(r.pct); } catch (e) {}
        discoveryPick = { h: prod.h, m: m, r: [], comp: findCompanion(prod, profile), com: findCommunityCount(prod), tag: null, product: prod };
      }
    }
    if (discoveryPick) {
      rows.push({
        id: 'discovery',
        layout: 'discovery',
        icon: '🌿',
        title: 'La scoperta della settimana',
        intro: 'Te la porto apposta, fuori dal tuo solito — ma con criterio, non a caso.',
        picks: [discoveryPick]
      });
      markUsed([discoveryPick]);
    }

    // 5a. PIÙ DESIDERATI DAI FROGGER — polso community VERO.
    // Pesca dal CATALOG completo (2374 prodotti) per i veri top desiderati di
    // Frogames, non solo dai 95 picks personali (sennò non avresti mai visto
    // un gioco con wl=300 che ti matcha poco). Trust signal puro di community.
    //
    // Rotation SETTIMANALE (non daily): i top desiderati cambiano poco da un
    // giorno all'altro, daily sarebbe "fisso noioso". Settimanale dà varietà
    // ogni lunedì pescando 5 dal top 10.
    //
    // Layout BENTO 5 picks: 1 hero 2×2 + 4 moduli 1×1 = grid 4×2 perfetta.
    // owned non era in scope di buildRows: lo costruisco al volo qui
    const ownedSetsLocal = buildOwnedSets(profile);
    const _desiredSeenBgg = new Set();
    const desiredPool = catalog.filter(p => {
      if (used.has(p.h)) return false;
      if (p.bgg && usedBgg.has(p.bgg)) return false;
      if (p.bgg && ownedSetsLocal.bggIds.has(p.bgg)) return false;
      if (ownedSetsLocal.handles.has(p.h)) return false;
      // Dedup interno: una sola edizione per BGG id dentro questa row
      if (p.bgg) { if (_desiredSeenBgg.has(p.bgg)) return false; _desiredSeenBgg.add(p.bgg); }
      if ((p.av === false || p.available === false) || isKnownOOS(p.h)) return false;
      if (p.is_exp === true || looksLikeExpansion(p)) return false;
      if (isBlocked(p.h)) return false;
      return p.wl && p.wl >= 2;
    });
    // Soglia ALTA (≥12): "Più desiderati" appare SOLO quando il conteggio wishlist è
    // davvero popolato. Finché il worker non aggrega wishlist_count, il pool è scarso
    // → la row resta nascosta (niente "3 prodotti" deboli; ci pensa "Cosa guarda la community").
    if (desiredPool.length >= 12) {
      // Top 40 più seguiti Frogames (pool ampio = più varietà settimana dopo settimana)
      const top25Desired = desiredPool.sort((a, b) => (b.wl || 0) - (a.wl || 0)).slice(0, 40);
      const customerId = (window.FrogMatchVetrinaCustomer && window.FrogMatchVetrinaCustomer.id) || 'a';
      const weekISO = getISOWeek(new Date());

      // HERO (cover grande): shuffle settimanale del TOP 5 più desiderati.
      //   Ogni lunedì può capitare uno dei 5 in cima → sempre "qualità top community"
      //   ma non sempre il #1 fisso.
      const heroShuffled = shuffleDeterministic(top25Desired.slice(0, 5), customerId + '_desired_hero_' + weekISO);
      const hero = heroShuffled[0];

      // MODULI (4 card piccole): shuffle settimanale dal RANK 5-25.
      //   Pool largo (20 giochi) garantisce varietà settimanale vera. Nel corso
      //   di 2-3 mesi vedi praticamente tutti i 25 top community.
      const modulesPool = top25Desired.slice(5);
      const modulesShuffled = shuffleDeterministic(modulesPool, customerId + '_desired_modules_' + weekISO);
      const modules = modulesShuffled.slice(0, 4);

      // Risultato: 5 picks (1 hero + 4 moduli) per bento 4×2 perfetto
      const desiredProducts = hero ? [hero].concat(modules) : modules;
      const desired = desiredProducts.map(product => {
        let m = 50;
        let cr = null; // compute result completo per esporre positives/negatives nella modal
        try {
          const r = window.FrogMatch.computeMatch(profile, product);
          if (r && typeof r.pct === 'number') {
            m = Math.round(r.pct);
            cr = r;
          }
        } catch (e) {}
        return {
          h: product.h,
          m: m,
          ranked: m,
          r: [],
          e: buildExplainObject(cr || { positives: [], negatives: [], parts: [] }, product, profile),
          comp: findCompanion(product, profile),
          com: findCommunityCount(product),
          tag: product.wl + ' Frogger lo vogliono.',
          product: product
        };
      });
      if (desired.length >= 3) {
        rows.push({
          id: 'desired',
          layout: 'bento',
          icon: '💝',
          title: 'Più desiderati dai Frogger',
          intro: 'I giochi più salvati dalla community su Frogames.',
          picks: desired,
          curated: true
        });
        markUsed(desired);
      }
    }

    // 5b. TOP BGG NEL TUO PROFILO — picks con rank BGG basso (top mondiali)
    const bggTop = allMid.filter(notUsed)
      .filter(p => p.product.rk && p.product.rk > 0 && p.product.rk <= 500)
      .sort((a, b) => (a.product.rk || 9999) - (b.product.rk || 9999))
      .slice(0, 8);
    if (bggTop.length >= 3) {
      rows.push({
        id: 'bggtop',
        layout: 'carousel',
        icon: '🏆',
        title: 'Top BGG nel tuo profilo',
        intro: 'Tra i più amati al mondo che corrispondono ai tuoi gusti.',
        picks: bggTop
      });
      markUsed(bggTop);
    }

    // 5c. NUOVI AFFINI — picks più recenti (yr alto) ancora non usati
    const fresh = allMid.filter(notUsed)
      .filter(p => p.product.yr && p.product.yr >= 2022)
      .sort((a, b) => (b.product.yr || 0) - (a.product.yr || 0))
      .slice(0, 6);
    if (fresh.length >= 3) {
      rows.push({
        id: 'fresh',
        layout: 'mosaic',
        icon: '✨',
        title: 'Nuovi affini al tuo gusto',
        intro: 'Usciti negli ultimi anni, pensati per chi sta esplorando come te.',
        picks: fresh
      });
      markUsed(fresh);
    }

    // 6. FUORI DAL SOLITO — t4 non ancora usati (carousel, fino a 8)
    const t4Avail = t4.filter(notUsed).sort((a, b) => (b.ranked || b.m) - (a.ranked || a.m)).slice(0, 8);
    if (t4Avail.length >= 2) {
      rows.push({
        id: 'beyond',
        layout: 'carousel',
        icon: '🌒',
        title: 'Fuori dal solito',
        intro: 'Giochi distanti dal tuo profilo. Non scelti a caso: condividono almeno un filo con quello che ami.',
        picks: t4Avail
      });
      markUsed(t4Avail);
    }

    // 7. CATCH-ALL "Altri match per te" RIMOSSO (F0): era la coda-catalogo travestita
    // (16 item da exploration-mix) → faceva sembrare la Vetrina "il solito catalogo
    // infinito" e stancava. Principio di finitezza: la pagina è la porta CURATA;
    // per sfogliare tutto c'è la chiusura "Sfoglia tutto il catalogo →" (vedi liquid).
    // (applyExplorationMix/diversifyByMech restano definiti, ora inutilizzati qui.)

    console.info('[Vetrina] rows:', rows.map(r => r.id + '(' + r.picks.length + ')').join(' · '),
                 '· picks usati:', used.size);
    // Stat algoritmo V1: quanti picks hanno ricevuto un boost dai segnali tracciati
    let boostedCount = 0, totalBoost = 0;
    for (const r of rows) {
      for (const p of (r.picks || [])) {
        if (p.boost && Math.abs(p.boost) >= 1) { boostedCount++; totalBoost += p.boost; }
      }
    }
    if (boostedCount > 0) {
      console.info('[Vetrina] algoritmo V1: ' + boostedCount + ' picks con boost da segnali tuoi · medio ' +
        (totalBoost / boostedCount).toFixed(1) + '%');
    }
    return rows;
  }

  // ── Card MEDIUM (usata in carousel/mosaic/paired/trio) ───────
  // opts.showTagline: false → nasconde tagline (paired: l'intro spiega già)
  // opts.hideMatch: true → nasconde badge match% (editorial picks: lo team Frogames
  //   propone indipendentemente dal match, mostrare un 50% sopra confonde)
  // opts.editorial: true → variante visiva premium (bordo/sfondo distinguibili)
  function renderCardMedium(pick, product, opts) {
    if (!product) return '';
    opts = opts || {};
    const showTagline = opts.showTagline !== false;
    const hideMatch = opts.hideMatch === true;
    const editorial = opts.editorial === true;
    const matchTier = pick.m >= 75 ? 't1' : pick.m >= 60 ? 't2' : pick.m >= 45 ? 't3' : 't4';
    // Daltonismo: il tier non deve dipendere SOLO dal colore. Il numero % è già testo
    // ridondante; aggiungo la PAROLA del tier in aria-label/title (testo + icona).
    const matchWord = pick.m >= 75 ? 'Forte affinità' : pick.m >= 60 ? 'Buona scelta' : pick.m >= 45 ? 'Esperimento intelligente' : 'Fuori dal solito';
    const moods = detectMoods(product).join(' ');
    const cls = 'fm-vt-cm' + (editorial ? ' fm-vt-cm--editorial' : '');
    const productId = product.id || '';
    const wishlisted = isWishlisted(productId);
    // Badge intent: se l'utente è tornato 3+ volte negli ultimi 7gg sullo stesso gioco
    const revisits = countRecentVisits(product.h, 7);
    // Badge V1 algoritmo: boost da segnali tracciati. ≥5 = segnali forti (almeno
    // 1 wishlist o 2-3 click rilevanti). Mostra che la pagina "ti sta capendo".
    const boost = pick.boost || 0;
    let intentBadge = '';
    // V2: wild slot ha priorità — il badge dichiara l'esplorazione esplicita
    if (pick.wildSlot === true) {
      intentBadge = '<span class="fm-vt-cm__intent fm-vt-cm__intent--wild" title="Te lo propongo apposta fuori dal tuo solito profilo">🎲 nuovo per te</span>';
    } else if (revisits >= 3) {
      intentBadge = '<span class="fm-vt-cm__intent" title="Lo hai aperto ' + revisits + ' volte negli ultimi 7 giorni">🔄 ci sei tornato ' + revisits + 'x</span>';
    } else if (boost >= 5) {
      intentBadge = '<span class="fm-vt-cm__intent fm-vt-cm__intent--boost" title="Tieni d\'occhio questo tipo di giochi · +' + boost.toFixed(0) + '% dal tuo comportamento">🎯 sai cosa cerchi</span>';
    }
    return (
      '<article class="' + cls + '" data-fm-vt-card data-pick="' + escapeHtml(JSON.stringify(stripPick(pick))) + '" data-moods="' + escapeHtml(moods) + '" data-handle="' + escapeHtml(product.h) + '" data-product-id="' + escapeHtml(String(productId)) + '">' +
        '<div class="fm-vt-cm__cover">' +
          '<img class="fm-vt-cm__img" src="' + escapeHtml(product.img) + '" alt="' + escapeHtml(product.t) + '" loading="lazy">' +
          (hideMatch ? '' : '<span class="fm-vt-cm__match fm-vt-cm__match--' + matchTier + '" title="' + pick.m + '% — ' + matchWord + '" aria-label="Affinità ' + pick.m + ' per cento, ' + matchWord + '">' + pick.m + '<small>%</small></span>') +
          // Reactions floating sopra cover, top-left — 2 bottoni puliti
          '<div class="fm-vt-cm__reactions" data-fm-vt-reactions>' +
            '<button type="button" class="fm-vt-cm__rx fm-vt-cm__rx--wish' + (wishlisted ? ' is-active' : '') + '" data-react="wishlist" data-handle="' + escapeHtml(product.h) + '" data-product-id="' + escapeHtml(String(productId)) + '" aria-label="Wishlist" title="' + (wishlisted ? 'Togli dalla wishlist' : 'Aggiungi alla wishlist') + '">' + (wishlisted ? '♥' : '♡') + '</button>' +
            '<button type="button" class="fm-vt-cm__rx fm-vt-cm__rx--no" data-react="not_interested" data-handle="' + escapeHtml(product.h) + '" aria-label="Non mi interessa" title="Non mostrarmi più (90 giorni)">✕</button>' +
          '</div>' +
        '</div>' +
        '<div class="fm-vt-cm__body">' +
          '<h3 class="fm-vt-cm__title">' + escapeHtml(product.t) + '</h3>' +
          intentBadge +
          (pick.preorderDate ? '<span class="fm-vt-cm__preorder">📦 In arrivo · entro ' + escapeHtml(formatPreorderDate(pick.preorderDate)) + '</span>' : '') +
          (showTagline && pick.tag ? '<p class="fm-vt-cm__tagline">' + escapeHtml(pick.tag) + '</p>' : '') +
          '<div class="fm-vt-cm__foot">' +
            '<span class="fm-vt-cm__price">€ ' + escapeHtml(product.price) + '</span>' +
            '<button type="button" class="fm-vt-cm__cart" data-react="cart" data-handle="' + escapeHtml(product.h) + '" aria-label="Aggiungi al carrello" title="Aggiungi al carrello">🛒 Aggiungi</button>' +
          '</div>' +
        '</div>' +
      '</article>'
    );
  }

  // ── Row head ─────────────────────────────────────────────────
  // ── TUNE "più/meno così" — auto-correzione guida↔scoperta ──────
  // L'utente regola cosa vede: "meno così" mette via il TIPO di row per ~4 settimane,
  // "più così" lo conferma. Persistente in localStorage; applicato al prossimo render.
  const ROWPREF_KEY = 'fmv_row_pref';      // rowId → { v:1|-1, t:ts }
  const ROWPREF_SUPPRESS_DAYS = 28;
  const L0_IDS = { valutando: 1, riprendi: 1, radar: 1 }; // la tua roba: non si "tuna"
  function loadRowPref() { try { const o = JSON.parse(localStorage.getItem(ROWPREF_KEY) || '{}'); return (o && typeof o === 'object') ? o : {}; } catch (e) { return {}; } }
  function setRowPref(rowId, v) { const m = loadRowPref(); m[rowId] = { v: v, t: Math.floor(Date.now() / 1000) }; try { localStorage.setItem(ROWPREF_KEY, JSON.stringify(m)); } catch (e) {} }
  function isRowSuppressed(rowId) { const r = loadRowPref()[rowId]; if (!r || r.v !== -1) return false; return (Math.floor(Date.now() / 1000) - r.t) < ROWPREF_SUPPRESS_DAYS * 86400; }

  function renderRowHead(row) {
    let eyebrow;
    if (row.editorial) {
      eyebrow = '<span class="fm-vt-row__eyebrow fm-vt-row__eyebrow--editorial">🏷️ DAL TEAM FROGAMES</span>';
    } else if (row.wildCard) {
      eyebrow = '<span class="fm-vt-row__eyebrow fm-vt-row__eyebrow--wild">🌑 FUORI BOLLA · DI PROPOSITO</span>';
    } else if (row.curated) {
      eyebrow = '<span class="fm-vt-row__eyebrow fm-vt-row__eyebrow--curated">📡 POLSO FROGAMES</span>';
    } else {
      eyebrow = '<span class="fm-vt-row__eyebrow fm-vt-row__eyebrow--personal">PER TE</span>';
    }
    const loved = (loadRowPref()[row.id] || {}).v === 1;
    const tune = L0_IDS[row.id] ? '' : (
      '<div class="fm-vt-row__tune">' +
        '<button type="button" class="fm-vt-row__tuneBtn' + (loved ? ' is-active' : '') + '" data-rowtune="more" data-rowid="' + escapeHtml(row.id) + '" aria-label="Più cose così" title="Più cose così">👍</button>' +
        '<button type="button" class="fm-vt-row__tuneBtn" data-rowtune="less" data-rowid="' + escapeHtml(row.id) + '" aria-label="Meno così" title="Meno così, mettila via">👎</button>' +
      '</div>'
    );
    return (
      '<header class="fm-vt-row__head">' +
        '<span class="fm-vt-row__icon">' + row.icon + '</span>' +
        '<div class="fm-vt-row__headText">' +
          eyebrow +
          '<h2 class="fm-vt-row__title">' + escapeHtml(row.title) + '</h2>' +
          '<p class="fm-vt-row__intro">' + escapeHtml(row.intro) + '</p>' +
        '</div>' +
        tune +
      '</header>'
    );
  }

  // ── Row layouts ──────────────────────────────────────────────
  function renderRowCarousel(row) {
    const cardOpts = row.editorial ? { hideMatch: true, editorial: true } : {};
    const cards = row.picks.map(p => renderCardMedium(p, p.product, cardOpts)).join('');
    const cls = 'fm-vt-row fm-vt-row--carousel' + (row.editorial ? ' fm-vt-row--editorial' : '');
    return (
      '<section class="' + cls + '" id="row-' + row.id + '" data-row-id="' + row.id + '">' +
        renderRowHead(row) +
        '<div class="fm-vt-row__viewport">' +
          '<button type="button" class="fm-vt-row__arrow fm-vt-row__arrow--prev" data-scroll="prev" aria-label="Scorri indietro" hidden>‹</button>' +
          '<div class="fm-vt-row__scroller">' + cards + '</div>' +
          '<button type="button" class="fm-vt-row__arrow fm-vt-row__arrow--next" data-scroll="next" aria-label="Scorri avanti">›</button>' +
        '</div>' +
      '</section>'
    );
  }
  function renderRowMosaic(row) {
    const cardOpts = row.editorial ? { hideMatch: true, editorial: true } : {};
    const cards = row.picks.map(p => renderCardMedium(p, p.product, cardOpts)).join('');
    const cls = 'fm-vt-row fm-vt-row--mosaic' + (row.editorial ? ' fm-vt-row--editorial' : '');
    return (
      '<section class="' + cls + '" id="row-' + row.id + '" data-row-id="' + row.id + '">' +
        renderRowHead(row) +
        '<div class="fm-vt-row__mosaic">' + cards + '</div>' +
      '</section>'
    );
  }
  function renderRowPaired(row) {
    if (!row.picks[0] || !row.picks[1]) return '';
    // showTagline: false — la intro della row spiega già la sinergia,
    // tagline individuale ridondante (e nei paired spesso uguale per entrambe).
    const a = renderCardMedium(row.picks[0], row.picks[0].product, { showTagline: false });
    const b = renderCardMedium(row.picks[1], row.picks[1].product, { showTagline: false });
    return (
      '<section class="fm-vt-row fm-vt-row--paired" id="row-' + row.id + '" data-row-id="' + row.id + '">' +
        renderRowHead(row) +
        '<div class="fm-vt-row__paired">' +
          '<div class="fm-vt-row__pairedItem">' + a + '</div>' +
          '<div class="fm-vt-row__pairedPlus" aria-hidden="true">+</div>' +
          '<div class="fm-vt-row__pairedItem">' + b + '</div>' +
        '</div>' +
      '</section>'
    );
  }
  function renderRowTrio(row) {
    const cards = row.picks.map(p => renderCardMedium(p, p.product)).join('');
    return (
      '<section class="fm-vt-row fm-vt-row--trio" id="row-' + row.id + '" data-row-id="' + row.id + '">' +
        renderRowHead(row) +
        '<div class="fm-vt-row__trio">' + cards + '</div>' +
      '</section>'
    );
  }
  function buildDiscoveryWhy(pick, product) {
    if (pick.comp && pick.comp.name) {
      const t = (pick.comp.mechShared + pick.comp.catShared);
      return 'Condivide ' + t + ' tratti con il tuo ' + pick.comp.name + '. Stesso DNA, contesto diverso.';
    }
    if (product.rk > 0 && product.rk <= 200) {
      return 'È nella Top ' + product.rk + ' BGG. Vale il salto fuori dal tuo solito.';
    }
    return 'Non è il tuo solito profilo, ma il modo in cui si gioca tocca corde che già ti piacciono.';
  }
  function renderRowDiscovery(row) {
    const pick = row.picks[0];
    const product = pick.product;
    if (!product) return '';
    const matchTier = pick.m >= 75 ? 't1' : pick.m >= 60 ? 't2' : pick.m >= 45 ? 't3' : 't4';
    const moods = detectMoods(product).join(' ');
    return (
      '<section class="fm-vt-row fm-vt-row--discovery" id="row-' + row.id + '" data-row-id="' + row.id + '">' +
        '<article class="fm-vt-disc" data-fm-vt-card data-pick="' + escapeHtml(JSON.stringify(stripPick(pick))) + '" data-moods="' + escapeHtml(moods) + '">' +
          '<div class="fm-vt-disc__cover">' +
            '<img src="' + escapeHtml(product.img) + '" alt="' + escapeHtml(product.t) + '">' +
            '<span class="fm-vt-disc__match fm-vt-disc__match--' + matchTier + '">' + pick.m + '<small>%</small></span>' +
          '</div>' +
          '<div class="fm-vt-disc__text">' +
            '<span class="fm-vt-disc__eyebrow">' + row.icon + ' LA SCOPERTA DELLA SETTIMANA</span>' +
            '<h2 class="fm-vt-disc__title">' + escapeHtml(product.t) + '</h2>' +
            '<p class="fm-vt-disc__lead">' + escapeHtml(pick.tag || row.intro) + '</p>' +
            '<p class="fm-vt-disc__why">' + escapeHtml(buildDiscoveryWhy(pick, product)) + '</p>' +
            '<div class="fm-vt-disc__foot">' +
              '<span class="fm-vt-disc__price">€ ' + escapeHtml(product.price) + '</span>' +
              '<button type="button" class="fm-vt-disc__cta" data-fm-vt-card-open>Voglio scoprire →</button>' +
            '</div>' +
          '</div>' +
        '</article>' +
      '</section>'
    );
  }

  function renderRowBento(row) {
    // Bento grid asimmetrica Apple-style: 1 hero (2x2) + 5 moduli (1x1).
    // La prima card riceve classe .fm-vt-cm--hero che la fa spaziosa (grid span).
    const cardOpts = row.editorial ? { hideMatch: true, editorial: true } : {};
    const cards = row.picks.map((p, i) => {
      const html = renderCardMedium(p, p.product, cardOpts);
      // Marker per la prima card: la "hero" del bento (cover grande)
      if (i === 0) return html.replace('class="fm-vt-cm"', 'class="fm-vt-cm fm-vt-cm--bento-hero"');
      return html;
    }).join('');
    const cls = 'fm-vt-row fm-vt-row--bento' + (row.editorial ? ' fm-vt-row--editorial' : '');
    return (
      '<section class="' + cls + '" id="row-' + row.id + '" data-row-id="' + row.id + '">' +
        renderRowHead(row) +
        '<div class="fm-vt-row__bento">' + cards + '</div>' +
      '</section>'
    );
  }

  function renderRow(row) {
    switch (row.layout) {
      case 'carousel': return renderRowCarousel(row);
      case 'mosaic': return renderRowMosaic(row);
      case 'paired': return renderRowPaired(row);
      case 'trio': return renderRowTrio(row);
      case 'discovery': return renderRowDiscovery(row);
      case 'bento': return renderRowBento(row);
      default: return '';
    }
  }

  // ── Spotlight (top match della settimana) ────────────────────
  function renderSpotlight(pick, product) {
    if (!product) return '';
    const matchTier = pick.m >= 75 ? 't1' : pick.m >= 60 ? 't2' : pick.m >= 45 ? 't3' : 't4';
    const moods = detectMoods(product).join(' ');
    const trustLine = pick.com >= 5
      ? '👥 ' + pick.com + ' Frogger della community lo hanno già'
      : (product.rk > 0 && product.rk <= 100
        ? '🏆 Top ' + product.rk + ' BGG · validato dalla community'
        : '★ Il match più alto della settimana');
    return (
      '<article class="fm-vt-spotlight" data-fm-vt-card data-pick="' + escapeHtml(JSON.stringify(stripPick(pick))) + '" data-moods="' + escapeHtml(moods) + '">' +
        '<div class="fm-vt-spotlight__cover">' +
          '<img src="' + escapeHtml(product.img) + '" alt="' + escapeHtml(product.t) + '">' +
          '<span class="fm-vt-spotlight__match fm-vt-spotlight__match--' + matchTier + '">' + pick.m + '<small>%</small></span>' +
        '</div>' +
        '<div class="fm-vt-spotlight__info">' +
          '<span class="fm-vt-spotlight__eyebrow">★ IL TOP DI QUESTA SETTIMANA</span>' +
          '<h2 class="fm-vt-spotlight__title">' + escapeHtml(product.t) + '</h2>' +
          (pick.tag ? '<p class="fm-vt-spotlight__tagline">' + escapeHtml(pick.tag) + '</p>' : '') +
          '<p class="fm-vt-spotlight__trust">' + trustLine + '</p>' +
          '<div class="fm-vt-spotlight__footer">' +
            '<span class="fm-vt-spotlight__price">€ ' + escapeHtml(product.price) + '</span>' +
            '<button type="button" class="fm-vt-spotlight__cta" data-fm-vt-card-open>Vediamolo →</button>' +
          '</div>' +
        '</div>' +
      '</article>'
    );
  }

  // ── SIDEBAR LEFT — Nav anchor jump + identità mini ───────────
  function renderSidebarLeft(rows, profile) {
    const archetype = detectArchetypeLabel(profile);
    const topMech = (profile.topMechanics || [])[0] || '';
    const playerC = detectPreferredPlayerCount(profile);
    const playerStr = playerC === 1 ? 'In solitaria'
                    : playerC === 2 ? 'In 2 al tavolo'
                    : playerC ? 'In ' + playerC : 'Tavoli misti';

    const navItems = rows.map(r =>
      '<li><a href="#row-' + r.id + '" class="fm-vt-side__navItem" data-anchor="row-' + r.id + '">' +
        '<span class="fm-vt-side__navIcon">' + r.icon + '</span>' +
        '<span class="fm-vt-side__navLabel">' + escapeHtml(r.title) + '</span>' +
      '</a></li>'
    ).join('');

    return (
      '<div class="fm-vt-side__block fm-vt-side__nav">' +
        '<h3 class="fm-vt-side__head">Vai a</h3>' +
        '<ul class="fm-vt-side__navList">' + navItems + '</ul>' +
      '</div>' +
      '<div class="fm-vt-side__block fm-vt-side__profile">' +
        '<h3 class="fm-vt-side__head">Il tuo profilo</h3>' +
        '<dl class="fm-vt-side__dl">' +
          (archetype ? '<dt>Archetipo</dt><dd>' + escapeHtml(archetype) + '</dd>' : '') +
          (topMech ? '<dt>Meccanica top</dt><dd>' + escapeHtml(topMech) + '</dd>' : '') +
          '<dt>Tavolo</dt><dd>' + escapeHtml(playerStr) + '</dd>' +
          (profile.weightTarget ? '<dt>Peso ideale</dt><dd>' + profile.weightTarget.toFixed(1) + '</dd>' : '') +
        '</dl>' +
      '</div>'
    );
  }

  // ── SIDEBAR RIGHT — Mini card contestuali ────────────────────
  function renderMiniCard(pick, product, badge) {
    if (!product) return '';
    return (
      '<article class="fm-vt-mini" data-fm-vt-card data-pick="' + escapeHtml(JSON.stringify(stripPick(pick))) + '">' +
        '<div class="fm-vt-mini__cover">' +
          '<img src="' + escapeHtml(product.img) + '" alt="' + escapeHtml(product.t) + '" loading="lazy">' +
        '</div>' +
        '<div class="fm-vt-mini__body">' +
          (badge ? '<span class="fm-vt-mini__badge">' + escapeHtml(badge) + '</span>' : '') +
          '<h4 class="fm-vt-mini__title">' + escapeHtml(product.t) + '</h4>' +
          '<span class="fm-vt-mini__price">€ ' + escapeHtml(product.price) + ' · ' + pick.m + '% match</span>' +
        '</div>' +
      '</article>'
    );
  }
  function renderSidebarRight(picks, catalog, profile, spotlightHandle) {
    const blocks = [];
    const seen = new Set();
    const seenBgg = new Set();   // evita doppioni stesso gioco (ENG + ITA) anche in sidebar
    if (spotlightHandle) {
      seen.add(spotlightHandle);
      const _sp = catalog.find(x => x.h === spotlightHandle);
      if (_sp && _sp.bgg) seenBgg.add(_sp.bgg);
    }

    // Helper: enrich + filter (no espansioni, no duplicati, no senza prodotto)
    function safe(p) {
      if (!p || seen.has(p.h)) return null;
      const prod = catalog.find(x => x.h === p.h);
      if (!prod) return null;
      if (prod.bgg && seenBgg.has(prod.bgg)) return null;
      // Mai esauriti nelle mini card sidebar.
      if (prod.av === false || prod.available === false) return null;
      // Doppio filtro espansioni: is_exp metafield + fallback testuale
      if (prod.is_exp === true) return null;
      const titleLow = (prod.t || '').toLowerCase();
      if (/\b(espansione|expansion|add-?on|big box|deluxe edition)\b/i.test(titleLow)) return null;
      return { p, prod };
    }
    function take(arr, n) {
      const out = [];
      for (const p of arr) {
        const s = safe(p);
        if (!s) continue;
        seen.add(s.p.h);
        if (s.prod.bgg) seenBgg.add(s.prod.bgg);
        out.push(s);
        if (out.length >= n) break;
      }
      return out;
    }

    const allPicks = [].concat(picks.t1 || [], picks.t2 || [], picks.t3 || []);

    // F0: RIDONDANZA sidebar↔feed risolta. "Caldo in community", "Top BGG" e
    // "Più desiderati" vivono SOLO nel feed (row L5, card ricche). La sidebar tiene
    // ciò che è ADDITIVO: accesso rapido ai tuoi match più alti + nota del curatore.

    // Top match% — quick glance ai match più forti (non duplicato nel feed)
    const byMatch = allPicks.slice().sort((a, b) => (b.ranked || b.m) - (a.ranked || a.m));
    let matchMinis = take(byMatch, 3);
    // I picks bootstrap a volte sono magri → uscivano 1 solo. Fallback: calcolo i veri
    // top match DAL CATALOGO (esclusi posseduti + wishlist/radar; OOS/espansioni via safe()).
    if (matchMinis.length < 3) {
      const ownedTM = buildOwnedSets(profile);
      const wishTM = getWishlistIds();
      const catScored = [];
      for (const prod of catalog) {
        if (!prod || !prod.h) continue;
        if (prod.bgg && ownedTM.bggIds.has(prod.bgg)) continue;
        if (ownedTM.handles.has(prod.h)) continue;
        if (prod.id && wishTM.has(String(prod.id))) continue;
        let m = 0;
        try { const r = window.FrogMatch.computeMatch(profile, prod); if (r && typeof r.pct === 'number') m = Math.round(r.pct); } catch (e) {}
        if (m <= 0) continue;
        catScored.push({ h: prod.h, m: m });
      }
      catScored.sort((a, b) => b.m - a.m);
      matchMinis = matchMinis.concat(take(catScored, 3 - matchMinis.length)); // take() deduplica contro i già usciti
    }
    if (matchMinis.length >= 1) {
      blocks.push(
        '<div class="fm-vt-side__block">' +
          '<h3 class="fm-vt-side__head">⭐ I tuoi match più alti</h3>' +
          '<div class="fm-vt-side__minis">' +
            matchMinis.map(s => renderMiniCard(s.p, s.prod, s.p.m + '% match')).join('') +
          '</div>' +
        '</div>'
      );
    }

    // (Top BGG e Più desiderati RIMOSSI dalla sidebar — F0: vivono nel feed, niente doppioni.)

    // Curator note
    blocks.push(
      '<div class="fm-vt-side__block fm-vt-side__note">' +
        '<h3 class="fm-vt-side__head">📝 Nota del curatore</h3>' +
        '<p class="fm-vt-side__noteText">Ho pescato da ' + (picks.t1 ? picks.t1.length : 0) +
        ' match certi e ' + (picks.t2 ? picks.t2.length : 0) + ' forti. ' +
        'La selezione cambia ogni lunedì sulla tua attività della settimana.</p>' +
      '</div>'
    );

    return blocks.join('');
  }

  // ── MOOD filter RIMOSSO (v5.16.10) — vedi nota nel markup liquid e nell'handler.
  //    Le card mantengono comunque data-moods (innocuo) per un eventuale futuro
  //    re-build come ri-curatela vera (non hide-in-place).

  // ── Modal: card explainer ───────────────────────────────────
  // ── MODAL REDESIGN 2026 — narrative-first, voce Frog, gerarchia visiva ──
  // Sezioni in ordine:
  //   1. HERO: cover grande + titolo + meta compact + match% prominent
  //   2. NARRATIVE: paragrafo "Perché Frog te lo propone" (voce calda)
  //   3. STATS GRID: 3 numeri grossi (mech in comune, cat in comune, peso)
  //   4. HIGHLIGHTS: 2-3 meccaniche/categorie TOP del cliente con tag "★ TUO TOP"
  //   5. COMPAGNO TAVOLO (se applicabile, narrative box)
  //   6. COMMUNITY (se segnale forte, una sola riga semplice)
  //   7. CTA FOOTER: prezzo + bottone dorato
  function openCardModal(pick, catalog, profile) {
    console.info('[Vetrina] openCardModal called with pick.h=' + (pick && pick.h));
    const product = catalog.find(p => p.h === pick.h);
    if (!product) {
      console.warn('[Vetrina] openCardModal: product NOT FOUND in catalog for handle:', pick && pick.h);
      return;
    }
    console.info('[Vetrina] openCardModal: product found, title=' + product.t);
    const explain = pick.e || {};

    // ── Estrai mech/cat che sono nei top dell'utente (con rank)
    const topMechs = (explain.mech || []).filter(m => m.rank);
    const otherMechs = (explain.mech || []).filter(m => !m.rank);
    const topCats = (explain.cat || []).filter(c => c.rank);
    const otherCats = (explain.cat || []).filter(c => !c.rank);

    // ── Stats per la grid (numeri grossi)
    const mechCommonCount = topMechs.length;
    const catCommonCount = topCats.length;
    const weightDelta = explain.weight ? Math.abs(explain.weight.game - explain.weight.user) : null;
    const weightMatch = weightDelta != null && weightDelta < 0.4;

    // ── Narrative di Frog: paragrafo unico, ONESTO ma onesto-AMPLIFICATO.
    // Regola: guido sempre col segnale REALE più forte disponibile, e il match%
    // detta il tono. Il framing dismissivo ("non centra il tuo profilo") compare
    // SOLO quando il match è davvero basso E non c'è overlap reale — altrimenti
    // il parere contraddiceva il pannello "Cosa funziona" mostrato sopra
    // (es. 69% + Top 85 BGG + 2 mech + 1 cat che diventava "non centra...").
    const customerName = (window.FrogMatchVetrinaCustomer && window.FrogMatchVetrinaCustomer.firstName) || '';
    const nm = customerName ? customerName + ', ' : '';
    // Segnali reali — STESSO calcolo della sezione "Cosa funziona per te",
    // così parere e dati non si contraddicono mai.
    const _topMechsArr = profile.topMechanics || [];
    const _topCatsArr = profile.topCategories || [];
    const mechOverlap = Array.isArray(product.mch) ? product.mch.filter(m => _topMechsArr.indexOf(m) !== -1) : [];
    const catOverlap = Array.isArray(product.cat) ? product.cat.filter(c => _topCatsArr.indexOf(c) !== -1) : [];
    const isTopBGG = product.rk && product.rk > 0 && product.rk <= 500;
    const isLovedBGG = product.rt && product.rt >= 7.5;
    const isWished = product.wl && product.wl >= 5;
    // Frase-mattone: cosa condivide col profilo (mech + cat), in parole non numeri secchi
    const overlapParts = [];
    if (mechOverlap.length === 1) overlapParts.push('la meccanica <strong>' + escapeHtml(mechOverlap[0]) + '</strong>');
    else if (mechOverlap.length >= 2) overlapParts.push('<strong>' + mechOverlap.length + ' meccaniche</strong> che ami (' + escapeHtml(mechOverlap.slice(0, 2).join(', ')) + ')');
    if (catOverlap.length === 1) overlapParts.push('<strong>' + escapeHtml(catOverlap[0]) + '</strong>');
    else if (catOverlap.length >= 2) overlapParts.push('<strong>' + catOverlap.length + ' categorie</strong> tue');
    const overlapPhrase = overlapParts.join(' e ');
    // Frase-mattone: conferma community/BGG
    const bggConfirm = isTopBGG ? ('è <strong>Top ' + product.rk + ' BGG</strong> mondiale')
      : (isLovedBGG ? ('ha rating BGG <strong>' + product.rt.toFixed(1) + '</strong>') : '');

    let narrative = '';
    if (pick.comp && pick.comp.name) {
      // 1. Companion: somiglia a un gioco che ami già — il segnale più forte.
      // Nomino le meccaniche/categorie condivise (l'utente vuole SAPERE quali sono).
      const compFull = (pick.comp.mechNames || pick.comp.catNames) ? pick.comp : (findCompanion(product, profile) || pick.comp);
      const mNames = compFull.mechNames || [];
      const cNames = compFull.catNames || [];
      const shareBits = [];
      if (mNames.length === 1) shareBits.push('la meccanica <strong>' + escapeHtml(mNames[0]) + '</strong>');
      else if (mNames.length >= 2) shareBits.push('le meccaniche <strong>' + escapeHtml(mNames.slice(0, 2).join(', ')) + '</strong>');
      if (cNames.length === 1) shareBits.push('la categoria <strong>' + escapeHtml(cNames[0]) + '</strong>');
      else if (cNames.length >= 2) shareBits.push('le categorie <strong>' + escapeHtml(cNames.slice(0, 2).join(', ')) + '</strong>');
      const shareStr = shareBits.length
        ? ('Condividono ' + shareBits.join(' e '))
        : (compFull.mechShared + (compFull.mechShared === 1 ? ' meccanica' : ' meccaniche') + ' e ' + (compFull.catShared || 0) + ((compFull.catShared || 0) === 1 ? ' categoria' : ' categorie') + ' in comune');
      narrative = nm + 'tocca le stesse corde del tuo <strong>' + escapeHtml(pick.comp.name) +
        '</strong>, che hai già macinato <strong>' + pick.comp.plays + ' volte</strong>. ' +
        shareStr + ' — stesso DNA, contesto nuovo.';
    } else if (topMechs.length > 0) {
      // 2. Centra una tua meccanica TOP con rank esplicito
      const m = topMechs[0];
      narrative = nm + 'vive di <strong>' + escapeHtml(m.name) + '</strong>' +
        (m.rank === 1 ? ', che è la tua meccanica top' : ' (' + m.rank + '° tra le tue preferite)') +
        ' — esattamente quello che cerchi.' +
        (bggConfirm ? ' E ' + bggConfirm + ': il tuo gusto e la community vanno d\'accordo.' : '');
    } else if (pick.m >= 60 && overlapPhrase) {
      // 3. Match buono/forte CON overlap reale: tono sicuro, mai dismissivo
      narrative = nm + 'centra il tuo profilo su ' + overlapPhrase + '.' +
        (bggConfirm ? ' In più ' + bggConfirm + ': il tuo gusto e la community vanno d\'accordo.' : ' Un match solido sui tuoi gusti.');
    } else if (overlapPhrase && (isTopBGG || isLovedBGG)) {
      // 4. Overlap parziale + conferma BGG forte (anche se match% medio-basso)
      narrative = nm + 'condivide ' + overlapPhrase + ' col tuo profilo, e ' + bggConfirm + '. Vale senz\'altro uno sguardo.';
    } else if (isTopBGG) {
      // 5. Non è il tuo profilo, ma conferma mondiale forte
      narrative = nm + 'non è una scoperta tua — è <strong>Top ' + product.rk + ' BoardGameGeek</strong> mondiale. Una conferma forte della community che vale alzare lo sguardo.';
    } else if (isLovedBGG) {
      // 6. Rating alto
      narrative = nm + 'ha rating BGG <strong>' + product.rt.toFixed(1) + '</strong>: il pubblico ci crede. Merita uno sguardo, anche se non centra il tuo solito.';
    } else if (isWished) {
      // 7. Segnale community (wishlist) — qui sì il framing onesto "non è il tuo profilo"
      narrative = nm + 'te lo propongo per onestà: non è il tuo profilo esatto, ma <strong>' + product.wl + ' Frogger</strong> della community lo desiderano. Quando la community fa rumore, vale uno sguardo.';
    } else {
      // 8. Fuori dal solito genuino
      narrative = nm + 'te lo propongo come "fuori dal solito". Non è centrato sul tuo profilo, ma c\'è qualcosa che vale guardare.';
    }

    // ── Highlights: TUTTE le mech/cat che sono nei tuoi top.
    // Il numero nella stat grid sopra DEVE corrispondere ai chip mostrati sotto,
    // altrimenti il cliente vede "4 meccaniche" ma sotto solo 2 chip → confusione.
    const highlightsList = [];
    // Ordina per rank (la #1 prima)
    const sortedTopMechs = topMechs.slice().sort((a, b) => (a.rank || 99) - (b.rank || 99));
    const sortedTopCats = topCats.slice().sort((a, b) => (a.rank || 99) - (b.rank || 99));
    for (const m of sortedTopMechs) {
      highlightsList.push({
        kind: 'mech',
        name: m.name,
        rank: m.rank,
        label: m.rank === 1 ? '★ la tua top' : '★ ' + m.rank + '° tuo'
      });
    }
    for (const c of sortedTopCats) {
      highlightsList.push({
        kind: 'cat',
        name: c.name,
        rank: c.rank,
        label: c.rank === 1 ? '★ la tua top cat' : '★ ' + c.rank + '° cat'
      });
    }

    // Diagnostica: stampa cosa abbiamo in mano per questo pick
    console.info('[Vetrina] modal opened: handle=' + product.h +
      ' · mech=' + ((explain.mech || []).length) +
      ' · cat=' + ((explain.cat || []).length) +
      ' · weight=' + (explain.weight ? 'sì' : 'no') +
      ' · rank=' + (product.rk || '-') +
      ' · rating=' + (product.rt || '-'));

    // ── Match label verbale stile product page
    // Trasforma il numero in parola che CHIAMA per nome ("Buona scelta", non "69%")
    let matchLabel = '', matchLabelEmoji = '';
    if (pick.m >= 85)      { matchLabel = 'Quasi certo';          matchLabelEmoji = '🔥'; }
    else if (pick.m >= 75) { matchLabel = 'Forte affinità';       matchLabelEmoji = '💎'; }
    else if (pick.m >= 60) { matchLabel = 'Buona scelta';         matchLabelEmoji = '👍'; }
    else if (pick.m >= 45) { matchLabel = 'Esperimento intelligente'; matchLabelEmoji = '✨'; }
    else                   { matchLabel = 'Fuori dal solito';     matchLabelEmoji = '🌱'; }

    // ── Caratteristiche derivate dai dati prodotto + profilo (per "scheda gioco")
    // Interazione (derivata dai flag/mech, perché interaction non è in bootstrap)
    let interactionLabel = 'Media';
    if (product.f && product.f.solo) interactionLabel = 'Solitaria';
    else if (product.f && product.f.coop) interactionLabel = 'Cooperativa';
    else if (product.f && product.f.t2p && !product.f.team) interactionLabel = 'Da duello (2)';
    else if (product.f && product.f.party) interactionLabel = 'Party / sociale';
    // Alea (derivata da mech "random" tipici)
    let aleaLabel = 'Media';
    const mechs = (product.mch || []).map(m => String(m).toLowerCase());
    const highAleaMechs = ['dice rolling', 'push your luck', 'variable set-up', 'roll / spin and move', 'roll and move'];
    const lowAleaMechs = ['worker placement', 'area majority', 'tile placement', 'chess', 'abstract'];
    if (mechs.some(m => highAleaMechs.some(h => m.indexOf(h) !== -1))) aleaLabel = 'Alta';
    else if (mechs.some(m => lowAleaMechs.some(l => m.indexOf(l) !== -1))) aleaLabel = 'Bassa';
    // Peso + label contestuale ("nel tuo ritmo" / "un po' distante" / "lontano")
    let weightLabel = '', weightCmt = '';
    if (product.w) {
      const w = product.w;
      if (w >= 4) weightLabel = 'Heavy (' + w.toFixed(1) + '/5)';
      else if (w >= 3) weightLabel = 'Medio-pesante (' + w.toFixed(1) + '/5)';
      else if (w >= 2) weightLabel = 'Medio (' + w.toFixed(1) + '/5)';
      else weightLabel = 'Leggero (' + w.toFixed(1) + '/5)';
      if (profile.weightTarget) {
        const delta = Math.abs(w - profile.weightTarget);
        if (delta < 0.3) weightCmt = 'nel tuo ritmo';
        else if (delta < 0.8) weightCmt = 'vicino al tuo';
        else if (delta < 1.5) weightCmt = 'un po\' distante';
        else weightCmt = 'lontano dal tuo';
      }
    }
    // Durata
    const durationLabel = (product.tmin || product.tmax) ?
      (product.tmin || '?') + '-' + (product.tmax || '?') + ' min' : null;
    // BGG rating
    const ratingLabel = product.rt ? product.rt.toFixed(1) + '/10' : null;

    const body = $('[data-fm-vt-modal-body]');
    if (!body) return;

    // ── Match tier per coloring badge
    const matchTier = pick.m >= 75 ? 't1' : pick.m >= 60 ? 't2' : pick.m >= 45 ? 't3' : 't4';

    // ── Preordine: data di consegna (sincrono, da #frogmatch-preorder-dates)
    const preDate = readPreorderDates()[product.h];
    const isPreorder = !!preDate;
    const preDateFmt = isPreorder ? formatPreorderDate(preDate) : '';

    // ── Costruisci HTML "Da dove viene il N%" PRIMA (più sicuro di IIFE inline)
    let reasonsHtml = '';
    try {
      let positivesArr = (explain.positives || []).map(p => formatExplainPart(p, product, profile)).filter(Boolean);
      let negativesArr = (explain.negatives || []).map(n => formatExplainPart(n, product, profile)).filter(Boolean);

      // FALLBACK: se positives/negatives vuoti (picks cached vecchi o cr null),
      // ricostruisco i motivi DIRETTAMENTE da product + profile. Mai più
      // modal senza la sezione "motivi".
      if (positivesArr.length === 0 && negativesArr.length === 0) {
        const topMechsArr = profile.topMechanics || [];
        const topCatsArr = profile.topCategories || [];
        // Mech overlap
        if (Array.isArray(product.mch) && product.mch.length > 0 && topMechsArr.length > 0) {
          const overlap = product.mch.filter(m => topMechsArr.indexOf(m) !== -1);
          if (overlap.length > 0) positivesArr.push('Meccaniche in comune: ' + overlap.slice(0, 3).join(', '));
          else negativesArr.push('Nessuna delle sue meccaniche è nelle tue top 10');
        }
        // Cat overlap
        if (Array.isArray(product.cat) && product.cat.length > 0 && topCatsArr.length > 0) {
          const overlap = product.cat.filter(c => topCatsArr.indexOf(c) !== -1);
          if (overlap.length > 0) positivesArr.push('Categorie in comune: ' + overlap.slice(0, 2).join(', '));
          else negativesArr.push('Nessuna delle sue categorie è nelle tue top 5');
        }
        // Peso vs target
        if (product.w && profile.weightTarget) {
          const delta = Math.abs(product.w - profile.weightTarget);
          if (delta < 0.4) {
            positivesArr.push('Peso ' + product.w.toFixed(1) + ' molto vicino al tuo target ' + profile.weightTarget.toFixed(1));
          } else if (delta > 1.0) {
            negativesArr.push('Peso ' + product.w.toFixed(1) + ' lontano dal tuo target ' + profile.weightTarget.toFixed(1) + ' (differenza ' + delta.toFixed(1) + ')');
          } else {
            positivesArr.push('Peso ' + product.w.toFixed(1) + ' nella tua zona (target ' + profile.weightTarget.toFixed(1) + ')');
          }
        }
        // Player count
        const playerCDet = detectPreferredPlayerCount(profile);
        if (playerCDet && product.pmin && product.pmax) {
          if (product.pmin <= playerCDet && product.pmax >= playerCDet) {
            positivesArr.push('Giocabile in ' + playerCDet + ' (il tuo formato preferito)');
          } else {
            negativesArr.push('Non supporta bene il tuo formato preferito (' + playerCDet + ' giocatori)');
          }
        }
        // BGG rank/rating/year (sempre positivi se presenti)
        if (product.rk && product.rk > 0 && product.rk <= 500) {
          positivesArr.push('Top ' + product.rk + ' BoardGameGeek mondiale — la community lo conferma');
        }
        if (product.rt && product.rt >= 7.0) {
          positivesArr.push('Rating BGG ' + product.rt.toFixed(1) + ' — la community lo ama');
        }
        if (product.yr && product.yr >= 2023) {
          positivesArr.push('Uscito nel ' + product.yr + ' — gioco recente, ancora caldo');
        }
        // Wishlist count (segnale community)
        if (product.wl && product.wl >= 10) {
          positivesArr.push(product.wl + ' Frogger della community lo desiderano');
        }
      }

      if (positivesArr.length > 0 || negativesArr.length > 0) {
        reasonsHtml = '<section class="fm-vt-modal2__reasons">' +
          '<h3 class="fm-vt-modal2__h3">Da dove viene il ' + pick.m + '% (i motivi)</h3>' +
          (positivesArr.length > 0 ?
            '<div class="fm-vt-modal2__reasonGroup fm-vt-modal2__reasonGroup--pos">' +
              '<span class="fm-vt-modal2__reasonHead">✓ Cosa centra col tuo profilo</span>' +
              '<ul class="fm-vt-modal2__reasonList">' +
                positivesArr.map(t => '<li>' + escapeHtml(t) + '</li>').join('') +
              '</ul>' +
            '</div>' : '') +
          (negativesArr.length > 0 ?
            '<div class="fm-vt-modal2__reasonGroup fm-vt-modal2__reasonGroup--neg">' +
              '<span class="fm-vt-modal2__reasonHead">✗ Cosa è diverso dal tuo solito</span>' +
              '<ul class="fm-vt-modal2__reasonList">' +
                negativesArr.map(t => '<li>' + escapeHtml(t) + '</li>').join('') +
              '</ul>' +
            '</div>' : '') +
        '</section>';
      }
    } catch (err) {
      console.warn('[Vetrina] reasonsHtml error:', err.message);
      reasonsHtml = '';
    }

    // ── Costruzione "Cosa funziona per te" (positives lista pulita, voce sintetica)
    let positivesList = (explain.positives || []).map(p => formatExplainPart(p, product, profile)).filter(Boolean);
    let negativesList = (explain.negatives || []).map(n => formatExplainPart(n, product, profile)).filter(Boolean);
    if (positivesList.length === 0 && negativesList.length === 0) {
      // Fallback sintetico
      const topMechsArr = profile.topMechanics || [];
      const topCatsArr = profile.topCategories || [];
      if (Array.isArray(product.mch) && product.mch.length > 0 && topMechsArr.length > 0) {
        const overlap = product.mch.filter(m => topMechsArr.indexOf(m) !== -1);
        if (overlap.length > 0) positivesList.push(overlap.length + ' meccaniche in comune con i tuoi gusti: ' + overlap.slice(0, 3).join(' · '));
        else negativesList.push('Nessuna delle sue meccaniche è nelle tue top 10');
      }
      if (Array.isArray(product.cat) && product.cat.length > 0 && topCatsArr.length > 0) {
        const overlap = product.cat.filter(c => topCatsArr.indexOf(c) !== -1);
        if (overlap.length > 0) positivesList.push(overlap.length + ' categoria in comune: ' + overlap.slice(0, 2).join(' · '));
      }
      const playerCDet = detectPreferredPlayerCount(profile);
      if (playerCDet && product.pmin && product.pmax && product.pmin <= playerCDet && product.pmax >= playerCDet) {
        positivesList.push('Numero giocatori ideale per il tuo tavolo');
      }
      if (product.rk && product.rk > 0 && product.rk <= 500) {
        positivesList.push('Top ' + product.rk + ' BGG mondiale — la community lo conferma');
      }
      if (product.wl && product.wl >= 10) {
        positivesList.push(product.wl + ' Frogger della community lo desiderano');
      }
    }

    // ── Footer trasparenza: "Calcolato sui tuoi N swipe + M partite..."
    const swipeCount = profile.swipeCount || profile.quizSwipes || 0;
    const playsCount = (profile.playsActivity && profile.playsActivity.totalPlays) || 0;
    const ownedCount = (profile.bggCollection && profile.bggCollection.owned && profile.bggCollection.owned.length) || 0;
    const purchasedCount = (profile.purchasedProducts && profile.purchasedProducts.length) || 0;
    const transparencyParts = [];
    if (swipeCount > 0) transparencyParts.push(swipeCount + ' swipe');
    if (playsCount > 0) transparencyParts.push(playsCount + ' partite loggate');
    if (ownedCount > 0) transparencyParts.push(ownedCount + ' giochi posseduti');
    if (purchasedCount > 0) transparencyParts.push(purchasedCount + ' acquisti Frogames');

    let modalHtml = '';
    try {
    modalHtml =
      '<article class="fm-vt-modal2">' +
        // CLOSE button sticky in cima a destra
        '<button type="button" class="fm-vt-modal2__close" data-fm-vt-modal-close aria-label="Chiudi">' +
          '<span aria-hidden="true">×</span>' +
          '<span class="fm-vt-modal2__closeLabel">Chiudi</span>' +
        '</button>' +

        // HERO
        '<header class="fm-vt-modal2__hero">' +
          '<div class="fm-vt-modal2__cover">' +
            '<img src="' + escapeHtml(product.img) + '" alt="' + escapeHtml(product.t) + '">' +
          '</div>' +
          '<div class="fm-vt-modal2__heroBody">' +
            '<h2 class="fm-vt-modal2__title">' + escapeHtml(product.t) + '</h2>' +
            '<div class="fm-vt-modal2__metaRow">' +
              '<span class="fm-vt-modal2__meta">' + (product.pmin || '?') + '–' + (product.pmax || '?') + ' giocatori</span>' +
              '<span class="fm-vt-modal2__metaSep">•</span>' +
              '<span class="fm-vt-modal2__meta">' + (product.tmin || '?') + '–' + (product.tmax || '?') + ' min</span>' +
              (product.w ? '<span class="fm-vt-modal2__metaSep">•</span><span class="fm-vt-modal2__meta">peso ' + product.w.toFixed(1) + '</span>' : '') +
              // Lingua (bandiera) IN ALTO, riempita async dai metafield. Nascosta se ignota.
              '<span class="fm-vt-modal2__metaSep" data-fm-vt-modal-langsep hidden>•</span>' +
              '<span class="fm-vt-modal2__meta fm-vt-modal2__meta--lang" data-fm-vt-modal-lang hidden></span>' +
            '</div>' +
            // Match badge + LABEL VERBALE (es. "69% Buona scelta 👍")
            '<div class="fm-vt-modal2__matchRow">' +
              '<span class="fm-vt-modal2__match fm-vt-modal2__match--' + matchTier + '">' +
                pick.m + '<small>%</small>' +
              '</span>' +
              '<span class="fm-vt-modal2__matchLabel">' + escapeHtml(matchLabel) + ' ' + matchLabelEmoji + '</span>' +
            '</div>' +
            // Chip STATO unificato (Preordine / Disponibile / Esaurito): chiaro e semplice.
            // Prefill sync per i preordini noti; rifinito async dai metafield (incl. available).
            '<div class="fm-vt-modal2__status" data-fm-vt-modal-status' + (isPreorder ? ' data-state="preorder"' : ' hidden') + '>' +
              (isPreorder ? ('🌱 <strong>Preordine</strong>' + (preDateFmt ? ' · consegna stimata <strong>' + escapeHtml(preDateFmt) + '</strong>' : '')) : '') +
            '</div>' +
          '</div>' +
        '</header>' +

        // 1. COSA FUNZIONA PER TE — positives in primo piano (verde-soft, pulito)
        (positivesList.length > 0 ?
          '<section class="fm-vt-modal2__works">' +
            '<h3 class="fm-vt-modal2__sectionH">✅ Cosa funziona per te</h3>' +
            '<ul class="fm-vt-modal2__worksList">' +
              positivesList.map(t => '<li>' + escapeHtml(t) + '</li>').join('') +
            '</ul>' +
          '</section>' : '') +

        // 2. CARATTERISTICHE DEL GIOCO — con commenti contestuali tipo product page
        '<section class="fm-vt-modal2__chars">' +
          '<h3 class="fm-vt-modal2__sectionH">🎮 Caratteristiche del gioco</h3>' +
          '<dl class="fm-vt-modal2__charsList">' +
            '<div class="fm-vt-modal2__charRow"><dt>🎲 Interazione</dt><dd>' + escapeHtml(interactionLabel) + '</dd></div>' +
            '<div class="fm-vt-modal2__charRow"><dt>🌀 Alea</dt><dd>' + escapeHtml(aleaLabel) + '</dd></div>' +
            (weightLabel ? '<div class="fm-vt-modal2__charRow"><dt>🧠 Complessità</dt><dd>' + escapeHtml(weightLabel) + (weightCmt ? ' <em class="fm-vt-modal2__charCmt">· ' + escapeHtml(weightCmt) + '</em>' : '') + '</dd></div>' : '') +
            (durationLabel ? '<div class="fm-vt-modal2__charRow"><dt>⏱️ Durata</dt><dd>' + escapeHtml(durationLabel) + '</dd></div>' : '') +
            (ratingLabel ? '<div class="fm-vt-modal2__charRow"><dt>⭐ BGG Rating</dt><dd>' + escapeHtml(ratingLabel) + '</dd></div>' : '') +
          '</dl>' +
        '</section>' +

        // 3. NEGATIVI (opzionale, mostrati solo se ci sono — non come blocco invasivo)
        (negativesList.length > 0 ?
          '<section class="fm-vt-modal2__notFit">' +
            '<h3 class="fm-vt-modal2__sectionH">↗️ Cosa è diverso dal tuo solito</h3>' +
            '<ul class="fm-vt-modal2__notFitList">' +
              negativesList.map(t => '<li>' + escapeHtml(t) + '</li>').join('') +
            '</ul>' +
          '</section>' : '') +

        // 4. IL PARERE DI FROG — voce caldo, IN FONDO (non più in cima)
        '<section class="fm-vt-modal2__opinion">' +
          '<h3 class="fm-vt-modal2__sectionH">🐸 Il parere di Frog</h3>' +
          '<p class="fm-vt-modal2__opinionBody">' + narrative + '</p>' +
        '</section>' +

        // 5. TRASPARENZA — calcolato sui tuoi dati (uguale alla product page)
        (transparencyParts.length > 0 ?
          '<section class="fm-vt-modal2__trust">' +
            '<p class="fm-vt-modal2__trustLine">📊 Calcolato sui tuoi <strong>' + transparencyParts.join('</strong> + <strong>') + '</strong>.</p>' +
            '<p class="fm-vt-modal2__trustLine fm-vt-modal2__trustLine--sub">🎯 Più giochi = match più precisi. Ogni partita registrata, sync BGG, acquisto e gioco simile dei Frogger come te affina i suggerimenti.</p>' +
          '</section>' : '') +

        // FOOTER CTA — azione PRIMARIA = aggiungi/preordina (resta in vetrina);
        // "Scheda" secondaria per chi vuole approfondire. Obiettivo: agire da qui.
        '<footer class="fm-vt-modal2__footer">' +
          '<span class="fm-vt-modal2__price">€ ' + escapeHtml(product.price) + '</span>' +
          '<div class="fm-vt-modal2__actions">' +
            '<button type="button" class="fm-vt-modal2__cta fm-vt-modal2__cta--cart" data-fm-vt-modal-cart data-handle="' + escapeHtml(product.h) + '">' +
              (isPreorder ? '🌱 Preordina' : '🛒 Aggiungi al carrello') +
            '</button>' +
            '<a class="fm-vt-modal2__cta fm-vt-modal2__cta--ghost" href="' + escapeHtml(product.u || product.url || '#') + '" target="_blank" rel="noopener">Scheda →</a>' +
          '</div>' +
        '</footer>' +
      '</article>';
    } catch (err) {
      // Se la costruzione HTML fallisce per qualche motivo, log l'errore e fallback minimo.
      console.error('[Vetrina] modal HTML build error:', err.message, err.stack);
      modalHtml =
        '<article class="fm-vt-modal2">' +
          '<button type="button" class="fm-vt-modal2__close" data-fm-vt-modal-close aria-label="Chiudi"><span aria-hidden="true">×</span><span class="fm-vt-modal2__closeLabel">Chiudi</span></button>' +
          '<header class="fm-vt-modal2__hero">' +
            '<div class="fm-vt-modal2__cover"><img src="' + escapeHtml(product.img || '') + '" alt=""></div>' +
            '<div class="fm-vt-modal2__heroBody"><h2 class="fm-vt-modal2__title">' + escapeHtml(product.t || 'Gioco') + '</h2></div>' +
          '</header>' +
          '<p style="padding:20px;color:#7A6E5C;font-style:italic">Modal in errore (' + escapeHtml(err.message) + ')</p>' +
          '<footer class="fm-vt-modal2__footer">' +
            '<a class="fm-vt-modal2__cta" href="' + escapeHtml(product.u || product.url || '#') + '" target="_blank" rel="noopener">Vai al prodotto →</a>' +
          '</footer>' +
        '</article>';
    }
    body.innerHTML = modalHtml;

    // Enrich async: lingua + preordine (data+precisione) dai METAFIELD reali
    // (/products/{h}?view=fm-meta). Riempie la riga Lingua e rifinisce il chip preordine.
    enrichModalMeta(product.h);

    const modal = $('[data-fm-vt-modal]');
    if (modal) {
      modal.hidden = false;
      // FORZA visibilità con cssText + !important (bypass app Shopify esterne con regole !important)
      modal.style.cssText = 'display:flex !important; align-items:center !important; justify-content:center !important; position:fixed !important; top:0 !important; left:0 !important; right:0 !important; bottom:0 !important; z-index:999999 !important; visibility:visible !important; opacity:1 !important; background:rgba(31,26,20,0.78) !important; backdrop-filter:blur(4px) !important;';
      // Diagnostica visiva: log stato dopo apertura
      setTimeout(function () {
        const cs = getComputedStyle(modal);
        const rect = modal.getBoundingClientRect();
        console.info('[Vetrina] modal post-open state:',
          'hidden=' + modal.hidden,
          '· display=' + cs.display,
          '· visibility=' + cs.visibility,
          '· opacity=' + cs.opacity,
          '· z-index=' + cs.zIndex,
          '· position=' + cs.position,
          '· bodyLen=' + body.innerHTML.length,
          '· rect={w:' + Math.round(rect.width) + ',h:' + Math.round(rect.height) + ',top:' + Math.round(rect.top) + '}',
          '· offsetParent=' + (modal.offsetParent ? modal.offsetParent.tagName : 'null'));
      }, 50);
    } else {
      console.warn('[Vetrina] modal element [data-fm-vt-modal] NOT FOUND');
    }
    document.body.style.overflow = 'hidden';
  }

  function closeModal() {
    const modal = $('[data-fm-vt-modal]');
    if (modal) {
      modal.hidden = true;
      // Pulisci TUTTI gli style inline (cssText forzato in openCardModal)
      modal.style.cssText = '';
    }
    document.body.style.overflow = '';
  }

  function bindEvents(catalog, profile) {
    document.addEventListener('click', function (e) {
      // LENTI mobile: chip filtro → mostra solo le row di quella lente + scroll su
      const lensChip = e.target.closest('.fm-vt-lenschip');
      if (lensChip) {
        e.preventDefault();
        applyLens(lensChip.dataset.lens);
        // Tab bar in fondo → al cambio lente scorro in CIMA al feed (contenuto da inizio)
        const feedEl = $('.fm-vt-feed');
        if (feedEl) {
          const y = feedEl.getBoundingClientRect().top + window.pageYOffset - 80;
          window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
        }
        return;
      }
      // MODAL: aggiungi/preordina al carrello (bottone con label dedicato)
      const modalCartBtn = e.target.closest('[data-fm-vt-modal-cart]');
      if (modalCartBtn) {
        e.preventDefault();
        e.stopPropagation();
        addToCartModal(modalCartBtn.dataset.handle, modalCartBtn);
        return;
      }
      // REACTION button → toggle + feedback visivo
      const reactBtn = e.target.closest('[data-react]');
      if (reactBtn) {
        e.preventDefault();
        e.stopPropagation();
        const kind = reactBtn.dataset.react;
        const handle = reactBtn.dataset.handle;
        const productId = reactBtn.dataset.productId;
        const safeHandle = handle.replace(/"/g, '\\"');

        if (kind === 'cart') {
          addToCartQuick(handle, reactBtn, catalog);
          return;
        }

        if (kind === 'wishlist') {
          const nowWishlisted = toggleWishlistFrogames(productId, handle);
          if (nowWishlisted) snapshotSeen(handle, catalog); // F0.5: baseline prezzo del radar

          $$('[data-fm-vt-card][data-handle="' + safeHandle + '"]').forEach(card => {
            const btn = card.querySelector('[data-react="wishlist"]');
            if (btn) {
              btn.classList.toggle('is-active', nowWishlisted);
              btn.textContent = nowWishlisted ? '♥' : '♡';
              btn.title = nowWishlisted ? 'Togli dalla wishlist' : 'Aggiungi alla wishlist';
            }
          });
          // Voce di Frog (sostituisce il toast generico di Frogames con personalità)
          if (nowWishlisted) {
            const lines = [
              'L\'ho segnato. Te ne propongo di simili nei prossimi giorni.',
              'Lo terrò d\'occhio per te.',
              'Annotato. Da qui in poi ti porto roba che gli somiglia.'
            ];
            showFrogToast(lines[Math.floor(Math.random() * lines.length)]);
          } else {
            showFrogToast('Tolto dalla wishlist. Capito.');
          }
          console.info('[Vetrina] wishlist:', nowWishlisted ? 'added' : 'removed', '→', handle, '(id ' + productId + ')');
        } else if (kind === 'not_interested') {
          const blocked = toggleBlocked(handle);
          if (blocked) {
            const hiddenCards = $$('[data-fm-vt-card][data-handle="' + safeHandle + '"]');
            hiddenCards.forEach(card => {
              card.style.transition = 'opacity 0.4s ease, transform 0.4s ease';
              card.style.opacity = '0';
              card.style.transform = 'scale(0.92)';
              setTimeout(() => { card.style.display = 'none'; }, 400);
            });
            const lines = [
              'Capito, lo metto via. Ti porto altro.',
              'Tolto. Cerco strade diverse.',
              'Va bene così. Cambio rotta.'
            ];
            // Toast con ANNULLA: recupero immediato da click accidentale (6s).
            showFrogToast(lines[Math.floor(Math.random() * lines.length)], {
              duration: 6000,
              action: {
                label: '↩ Annulla',
                onClick: function () {
                  if (isBlocked(handle)) toggleBlocked(handle); // sblocca
                  hiddenCards.forEach(card => { card.style.display = ''; card.style.opacity = '1'; card.style.transform = ''; });
                  showFrogToast('Rimesso a posto. Te lo ritengo.');
                  console.info('[Vetrina] not_interested ANNULLATO →', handle);
                }
              }
            });
          }
          console.info('[Vetrina] not_interested:', blocked ? 'blocked' : 'unblocked', '→', handle);
        }
        return;
      }
      // Mood chip RIMOSSO (v5.16.10): la barra mood nascondeva card sul feed già
      // personalizzato → layout rotti + contraddizione con "Frog ti cura".
      // F0.5: chip delta "cali prezzo" → scrolla ai tuoi blocchi L0 (radar/valutando/riprendi)
      const deltaChip = e.target.closest('[data-fm-vt-delta]');
      if (deltaChip) {
        e.preventDefault();
        let target = null;
        for (const id of ['row-radar', 'row-valutando', 'row-riprendi']) {
          target = document.getElementById(id);
          if (target) break;
        }
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
      // Tune "più/meno così" → regola cosa mostro (auto-correzione guida↔scoperta)
      const tuneBtn = e.target.closest('[data-rowtune]');
      if (tuneBtn) {
        e.preventDefault();
        e.stopPropagation();
        const rowId = tuneBtn.dataset.rowid;
        if (tuneBtn.dataset.rowtune === 'less') {
          setRowPref(rowId, -1);
          const rowEl = tuneBtn.closest('.fm-vt-row');
          if (rowEl) {
            rowEl.style.transition = 'opacity .3s ease';
            rowEl.style.opacity = '0';
            setTimeout(function () { rowEl.style.display = 'none'; }, 300);
          }
          showFrogToast('Capito. Meno roba così — la metto via per un po\'.');
        } else {
          setRowPref(rowId, 1);
          tuneBtn.classList.add('is-active');
          showFrogToast('Bene. Te ne porto di più così.');
        }
        return;
      }
      // Sidebar nav anchor → smooth scroll to row
      const anchor = e.target.closest('[data-anchor]');
      if (anchor) {
        e.preventDefault();
        const target = document.getElementById(anchor.dataset.anchor);
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        $$('.fm-vt-side__navItem').forEach(a => a.classList.toggle('is-active', a === anchor));
        return;
      }
      // F3: pulsanti deck "Continua a scoprire" (pass/like/open/restart)
      const deckBtn = e.target.closest('[data-deck-action]');
      if (deckBtn) {
        e.preventDefault();
        e.stopPropagation();
        const act = deckBtn.dataset.deckAction;
        const sec = $('[data-fm-vt-discover]');
        const cur = _deck && _deck[_deckIdx];
        if (act === 'start' || act === 'restart') { startDiscover(profile, catalog); return; }
        if (act === 'open' && cur) { openCardModal({ h: cur.h, m: cur.m }, catalog, profile); return; }
        if (act === 'like' && deckBtn.dataset.handle) {
          toggleWishlistFrogames(deckBtn.dataset.productId, deckBtn.dataset.handle); // → wishlist_hot (+boost)
          snapshotSeen(deckBtn.dataset.handle, catalog);
          _deckSwipes++;
          showFrogToast('Segnato. Da qui ti porto roba che gli somiglia.');
        } else if (act === 'pass' && deckBtn.dataset.handle) {
          if (!isBlocked(deckBtn.dataset.handle)) toggleBlocked(deckBtn.dataset.handle); // → not_interested (-boost, 90gg)
          _deckSwipes++;
        }
        _deckIdx++;
        if (sec) drawDeckCard(sec);
        return;
      }
      // Card click → modal + tracking
      const card = e.target.closest('[data-fm-vt-card]');
      if (card && !e.target.closest('a')) {
        try {
          const pick = JSON.parse(card.dataset.pick);
          trackEvent('click_open', pick.h);
          snapshotSeen(pick.h, catalog); // F0.5: baseline prezzo/disp "come l'hai visto"
          const recentVisits = countRecentVisits(pick.h, 7);
          if (recentVisits >= 3) trackEvent('visit_repeat', pick.h);
          openCardModal(pick, catalog, profile);
        } catch (err) {
          // NON ingoiare in silenzio: era qui che il ReferenceError di openCardModal
          // veniva mangiato e la modal sembrava "non aprirsi" senza alcun segnale.
          console.error('[Vetrina] card click / openCardModal error:', err && err.message, err && err.stack);
        }
        return;
      }
      // Modal close
      if (e.target.closest('[data-fm-vt-modal-close]')) {
        closeModal();
        return;
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeModal();
    });
  }

  // ── ESAURITI client-side ─────────────────────────────────────
  // Soluzione 100% lato tema, indipendente dal worker: il catalog non porta
  // sempre la disponibilità (campo av assente), quindi verifichiamo lo STOCK
  // REALE dei soli giochi renderizzati via l'endpoint Shopify /products/{h}.js
  // e nascondiamo gli esauriti (incluso il caso "backorder con 0 pezzi").
  const AVAIL_CACHE_KEY = 'fmv_avail_v1';
  const AVAIL_TTL = 30 * 60; // 30 min: stock cambia lentamente, ma non lo teniamo stantio

  function _loadAvailCache() {
    try { const o = JSON.parse(localStorage.getItem(AVAIL_CACHE_KEY) || '{}'); return (o && typeof o === 'object') ? o : {}; }
    catch (e) { return {}; }
  }
  function _saveAvailCache(c) { try { localStorage.setItem(AVAIL_CACHE_KEY, JSON.stringify(c)); } catch (e) {} }
  // True se il gioco è GIÀ NOTO esaurito (da uno sweep precedente): permette di
  // escluderlo a monte ed evitare il "lampeggio" (card che appare e poi sparisce).
  function isKnownOOS(handle) {
    try { const hit = _loadAvailCache()[handle]; return !!(hit && hit.a === false); } catch (e) { return false; }
  }

  // Estrae l'handle da una card (data-handle o, in fallback, dal JSON data-pick).
  function _cardHandle(el) {
    if (el.dataset.handle) return el.dataset.handle;
    try { return JSON.parse(el.dataset.pick).h || null; } catch (e) { return null; }
  }

  // Da /products/{h}.js: true=disponibile, false=esaurito, null=sconosciuto.
  // NB: lo storefront NON espone inventory_quantity (Shopify lo nasconde), quindi
  // l'unico segnale affidabile è il booleano `available` (true se almeno un variant
  // è acquistabile). Cattura tutti gli esauriti con policy "deny" (il caso normale).
  // I backorder (policy "continua a vendere") restano available=true e non sono
  // distinguibili lato client — limite di Shopify, non del nostro codice.
  function _trulyAvailable(json) {
    if (!json || typeof json.available !== 'boolean') return null;
    return json.available;
  }

  async function _fetchAvail(handle, cache, now) {
    const hit = cache[handle];
    if (hit && (now - hit.t) < AVAIL_TTL) return hit.a;
    try {
      const res = await fetch('/products/' + encodeURIComponent(handle) + '.js', { headers: { 'Accept': 'application/json' } });
      if (!res.ok) return null;
      const a = _trulyAvailable(await res.json());
      if (a !== null) cache[handle] = { a: a, t: now }; // cacha solo esiti certi
      return a;
    } catch (e) { return null; }
  }

  async function sweepSoldOut() {
    const cards = $$('[data-fm-vt-card]');
    if (cards.length === 0) return;
    const handles = Array.from(new Set(cards.map(_cardHandle).filter(Boolean)));
    if (handles.length === 0) return;
    const cache = _loadAvailCache();
    const now = Math.floor(Date.now() / 1000);
    const soldOut = new Set();
    // Concorrenza limitata (6 in parallelo) per non martellare lo storefront.
    let idx = 0;
    async function worker() {
      while (idx < handles.length) {
        const h = handles[idx++];
        if (await _fetchAvail(h, cache, now) === false) soldOut.add(h);
      }
    }
    await Promise.all(Array.from({ length: Math.min(6, handles.length) }, worker));
    _saveAvailCache(cache);
    if (soldOut.size === 0) { console.info('[Vetrina] sweep esauriti: 0 OOS su', handles.length, 'verificati'); return; }
    // Nascondi le card esaurite
    cards.forEach(c => { const h = _cardHandle(c); if (h && soldOut.has(h)) c.setAttribute('data-oos-hidden', ''); });
    // Ricompatta: row / daily senza card visibili → nascondi tutto il blocco
    $$('.fm-vt-row').forEach(r => {
      const total = r.querySelectorAll('[data-fm-vt-card]').length;
      const hidden = r.querySelectorAll('[data-fm-vt-card][data-oos-hidden]').length;
      if (total > 0 && hidden === total) r.setAttribute('data-oos-hidden', '');
    });
    const daily = $('[data-fm-vt-daily]');
    if (daily) { const dc = daily.querySelector('[data-fm-vt-card]'); const dh = dc && _cardHandle(dc); if (dh && soldOut.has(dh)) daily.setAttribute('data-oos-hidden', ''); }
    console.info('[Vetrina] sweep esauriti: nascosti', soldOut.size, 'giochi su', handles.length, 'verificati');
  }

  // ── F0.5 — barra "Bentornato + delta" (compatta, adattiva) ───
  // Chi torna: saluto + cosa è cambiato (cali prezzo). Chi è nuovo: benvenuto, niente delta.
  function renderWelcomeDelta(catalog, customerName) {
    const feedEl = $('.fm-vt-feed');
    if (!feedEl) return;
    const existing = feedEl.querySelector('[data-fm-vt-welcome]');
    if (existing) existing.remove();
    const name = (customerName && customerName !== 'Frogger') ? customerName : '';
    const deltas = computeDeltas(catalog);
    const chips = [];
    if (deltas.priceDrops.length > 0) {
      const n = deltas.priceDrops.length;
      chips.push('<button type="button" class="fm-vt-welcome__chip" data-fm-vt-delta="price">💶 ' +
        n + (n === 1 ? ' calo prezzo' : ' cali prezzo') + ' sui tuoi giochi</button>');
    }
    // SOLO-DELTA: la barra appare SOLO se c'è una vera novità (calo prezzo/restock).
    // Niente saluto fisso "sempre lì": la pagina parte dalla tua roba (L0 in cima).
    if (chips.length === 0) return;
    const line = 'Bentornato' + (name ? ' ' + escapeHtml(name) : '') + ' — dall\'ultima volta:';
    const bar = document.createElement('div');
    bar.className = 'fm-vt-welcome';
    bar.setAttribute('data-fm-vt-welcome', '');
    bar.innerHTML =
      '<span class="fm-vt-welcome__line">' + line + '</span>' +
      (chips.length ? '<span class="fm-vt-welcome__chips">' + chips.join('') + '</span>' : '');
    feedEl.insertBefore(bar, feedEl.firstChild);
    if (deltas.priceDrops.length) {
      console.info('[Vetrina] delta: ' + deltas.priceDrops.length + ' cali prezzo —',
        deltas.priceDrops.map(d => d.t + ' (' + d.oldP + '→' + d.newP + ')').join(', '));
    }
  }

  // ── LENTI mobile: chip filtro per domare il "muro di scorrimento" ──────────
  // Su mobile 15+ caroselli in fila stancano. Una barra sticky di chip filtra il
  // feed per INTENTO: una lente alla volta. Su desktop è nascosta (lì c'è la sidebar).
  const LENSES = [
    { id: 'perte',     icon: '🎯', label: 'Per te' },
    { id: 'novita',    icon: '🆕', label: 'Novità' },
    { id: 'offerte',   icon: '🏷️', label: 'Offerte' },
    { id: 'community', icon: '👥', label: 'Community' },
    { id: 'esplora',   icon: '🌍', label: 'Esplora' }
  ];
  let _activeLens = (function () {
    try { return localStorage.getItem('fmv_lens') || 'perte'; } catch (e) { return 'perte'; }
  })();
  // id row → lente. Default 'perte' per ciò che non è mappato.
  function lensForRowId(id) {
    if (!id) return 'perte';
    if (id === 'curated-hot') return 'community';   // "Hot su Frogames" (non il personale)
    const base = id.indexOf('curated-') === 0 ? id.slice(8) : id;
    const MAP = {
      // Per te (personale)
      riprendi: 'perte', radar: 'perte', topmatch: 'perte', pairing: 'perte',
      evolution: 'perte', hot: 'perte', players: 'perte',
      // Novità
      'new': 'novita', preorder: 'novita', restock: 'novita', fresh: 'novita',
      // Offerte
      frogdeal: 'offerte',
      // Community
      mostviewed: 'community', bestseller: 'community', desired: 'community', bggtop: 'community',
      // Esplora
      imported: 'esplora', featured: 'esplora', wild: 'esplora', discovery: 'esplora', beyond: 'esplora'
    };
    return MAP[base] || 'perte';
  }
  function applyLens(lens) {
    _activeLens = lens;
    try { localStorage.setItem('fmv_lens', lens); } catch (e) {}
    $$('[data-lens]').forEach(function (el) {
      // I CHIP hanno anch'essi data-lens (per identità) ma NON sono sezioni da filtrare:
      // senza questo escludo, applyLens nascondeva i chip stessi → restava solo "Per te".
      if (el.classList.contains('fm-vt-lenschip')) return;
      el.classList.toggle('fm-vt-lens-hide', el.getAttribute('data-lens') !== lens);
    });
    $$('.fm-vt-lenschip').forEach(function (c) {
      c.classList.toggle('is-active', c.dataset.lens === lens);
    });
  }
  // Tag delle row + barra chip. Da chiamare dopo che le row sono nel DOM.
  function setupLensFilter() {
    // 1) Tag ogni row col proprio gruppo
    $$('.fm-vt-row[data-row-id]').forEach(function (el) {
      el.setAttribute('data-lens', lensForRowId(el.dataset.rowId));
    });
    // 2) Quali lenti hanno DAVVERO contenuto? (no chip morti) — conta le sezioni reali.
    const count = {};
    $$('[data-lens]').forEach(function (el) {
      if (el.classList.contains('fm-vt-lenschip')) return;
      const k = el.getAttribute('data-lens');
      count[k] = (count[k] || 0) + 1;
    });
    const avail = LENSES.filter(function (l) { return (count[l.id] || 0) > 0; });
    if (avail.length < 2) return; // una sola lente → barra inutile
    if (!avail.some(function (l) { return l.id === _activeLens; })) _activeLens = avail[0].id;
    // 3) Barra chip in cima al feed (una sola volta), solo per le lenti disponibili
    const feedEl = $('.fm-vt-feed');
    if (feedEl && !feedEl.querySelector('[data-fm-vt-lensbar]')) {
      const bar = document.createElement('nav');
      bar.className = 'fm-vt-lensbar';
      bar.setAttribute('data-fm-vt-lensbar', '');
      bar.setAttribute('aria-label', 'Filtra la vetrina');
      bar.innerHTML = avail.map(function (l) {
        return '<button type="button" class="fm-vt-lenschip' + (l.id === _activeLens ? ' is-active' : '') +
          '" data-lens="' + l.id + '"><span class="fm-vt-lenschip__icon" aria-hidden="true">' + l.icon +
          '</span>' + l.label + '</button>';
      }).join('');
      feedEl.insertBefore(bar, feedEl.firstChild); // prima riga → sticky in alto
    }
    // 4) Applica la lente di default
    applyLens(_activeLens);
    // 5) Aggancia la barra sotto l'header REALE del tema (no sovrapposizione)
    setVetrinaHeaderOffset();
  }

  // Misura l'altezza dell'header del tema (sticky-header) → CSS var, così la barra
  // chip si pinna ESATTAMENTE sotto senza coprirsi. ROBUSTO: rimisura dopo il load
  // (il logo che carica cambia l'altezza) e osserva i cambi con ResizeObserver.
  let _headerOffsetBound = false;
  function measureHeaderH() {
    try {
      const h = document.querySelector('[is="sticky-header"]') ||
                document.querySelector('[is="custom-header"]') ||
                document.querySelector('.header') ||
                document.querySelector('header.section');
      const root = $('.fm-vt-page') || document.documentElement;
      if (!h || !root) return;
      const height = Math.round(h.getBoundingClientRect().height);
      if (height > 20) root.style.setProperty('--fmv-vt-headerh', (height + 4) + 'px'); // 4px di respiro
    } catch (e) {}
  }
  function setVetrinaHeaderOffset() {
    measureHeaderH();
    if (_headerOffsetBound) return;
    _headerOffsetBound = true;
    // rimisure: dopo load (immagini/logo), resize/rotazione, e fallback ritardati
    window.addEventListener('resize', measureHeaderH, { passive: true });
    window.addEventListener('load', measureHeaderH);
    setTimeout(measureHeaderH, 400);
    setTimeout(measureHeaderH, 1200);
    try {
      const h = document.querySelector('[is="sticky-header"]') || document.querySelector('.header');
      if (h && typeof ResizeObserver === 'function') new ResizeObserver(measureHeaderH).observe(h);
    } catch (e) {}
  }

  // ── Riga "motore" in cima al feed ───────────────────────────
  // Comunica il valore di FrogMatch: sceglie per te su TUTTO il catalogo, escludendo
  // ciò che possiedi. Personale (catalogo + match forti), non il vecchio banner generico.
  function renderEngineLine(catalog, profile, picks) {
    const feedEl = $('.fm-vt-feed');
    if (!feedEl) return;
    const existing = feedEl.querySelector('[data-fm-vt-engine]');
    if (existing) existing.remove();
    const total = (catalog && catalog.length) ? catalog.length : 0;
    if (total < 50) return; // catalogo non ancora pronto: niente riga
    const totalFmt = total.toLocaleString('it-IT');
    // Match forti questa settimana (≥75%) — segnale personale, non solo il numero catalogo.
    let strong = 0;
    try {
      const all = [].concat((picks && picks.t1) || [], (picks && picks.t2) || [], (picks && picks.t3) || []);
      strong = all.filter(p => (p.ranked || p.m || 0) >= 75).length;
    } catch (e) {}
    const bar = document.createElement('div');
    bar.className = 'fm-vt-engine';
    bar.setAttribute('data-fm-vt-engine', '');
    bar.innerHTML =
      '<span class="fm-vt-engine__icon" aria-hidden="true">🎯</span>' +
      '<span class="fm-vt-engine__text">FrogMatch sta scegliendo per te tra <strong>' + totalFmt + ' giochi</strong>' +
        (strong > 0 ? ' · <strong>' + strong + '</strong> con match forte questa settimana' : '') +
        '. Esclusi quelli che hai già.</span>';
    feedEl.insertBefore(bar, feedEl.firstChild);
  }

  // ── F3 "Continua a scoprire" — deck swipe (loop attivo) ─────────
  // Riusa l'infra esistente: ❤ = wishlist, 👎 = block 90gg, ogni azione è un evento
  // che alimenta computeInterestScore → i match si affinano al prossimo render.
  // Niente riscrittura del motore profilo: il loop sfrutta il sistema di boost.
  let _deck = null, _deckIdx = 0, _deckSwipes = 0;

  function buildDiscoverDeck(profile, catalog) {
    const topM = new Set(profile.topMechanics || []);
    const topC = new Set(profile.topCategories || []);
    const hasTaste = topM.size > 0 || topC.size > 0;
    const wishIds = getWishlistIds();
    const owned = buildOwnedSets(profile);
    const seenBgg = new Set();
    const cand = [];
    for (const p of catalog) {
      if (p.av === false || p.available === false) continue;
      if (p.is_exp === true || looksLikeExpansion(p)) continue;
      if (isBlocked(p.h) || isKnownOOS(p.h)) continue;
      if (wishIds.has(String(p.id))) continue;
      if (p.bgg && owned.bggIds && owned.bggIds.has(p.bgg)) continue; // non proporre ciò che possiedi già
      if (owned.handles && owned.handles.has(p.h)) continue;
      if (p.bgg) { if (seenBgg.has(p.bgg)) continue; seenBgg.add(p.bgg); }
      let m = 50;
      try { const r = window.FrogMatch.computeMatch(profile, p); if (r && typeof r.pct === 'number') m = Math.round(r.pct); } catch (e) {}
      if (hasTaste) {
        // Con profilo gusti: solo giochi affini (overlap mech/cat) e match decente.
        const overlap = (p.mch || []).some(mm => topM.has(mm)) || (p.cat || []).some(c => topC.has(c));
        if (!overlap || m < 40) continue;
      } else {
        // FALLBACK senza profilo gusti (es. solo collezione BGG, niente swipe-quiz):
        // proponi giochi di QUALITÀ (top rank o rating alto) come scoperta.
        const quality = (p.rk && p.rk > 0 && p.rk <= 2500) || (p.rt && p.rt >= 7.2);
        if (!quality) continue;
      }
      cand.push({ h: p.h, m: m, product: p });
    }
    // Seed GIORNALIERO: il deck "Continua a scoprire" è il canale di scoperta fresca
    // ogni giorno (mentre match più alti / la tua roba restano stabili nella settimana).
    const seed = (window.FrogMatchVetrinaCustomer && window.FrogMatchVetrinaCustomer.id || 'a') + '_deck_' + getISODate(new Date());
    const shuffled = shuffleDeterministic(cand, seed);
    // Con gusti: ordina per match. Senza: per qualità BGG (rating, poi rank).
    if (hasTaste) shuffled.sort((a, b) => b.m - a.m);
    else shuffled.sort((a, b) => (b.product.rt || 0) - (a.product.rt || 0) || (a.product.rk || 9999) - (b.product.rk || 9999));
    return shuffled.slice(0, 30); // pool ampio: filtreremo per disponibilità reale
  }

  function deckCardHtml(c, p, idx, total) {
    const tier = c.m >= 75 ? 't1' : c.m >= 60 ? 't2' : c.m >= 45 ? 't3' : 't4';
    const specs = [];
    if (p.pmin || p.pmax) specs.push((p.pmin || '?') + '–' + (p.pmax || '?') + ' giocatori');
    if (p.tmin || p.tmax) specs.push((p.tmin || '?') + '–' + (p.tmax || '?') + ' min');
    if (p.w) specs.push('peso ' + p.w.toFixed(1));
    return (
      '<div class="fm-vt-deck">' +
        '<div class="fm-vt-deck__head">' +
          '<h2 class="fm-vt-deck__title">🃏 Continua a scoprire</h2>' +
          '<span class="fm-vt-deck__progress">' + (idx + 1) + ' / ' + total + '</span>' +
        '</div>' +
        '<article class="fm-vt-deck__card" data-fm-vt-card data-pick="' + escapeHtml(JSON.stringify({ h: p.h, m: c.m })) + '" data-handle="' + escapeHtml(p.h) + '">' +
          '<div class="fm-vt-deck__cover">' +
            '<img src="' + escapeHtml(p.img) + '" alt="' + escapeHtml(p.t) + '" loading="lazy">' +
            '<span class="fm-vt-deck__match fm-vt-deck__match--' + tier + '">' + c.m + '<small>%</small></span>' +
          '</div>' +
          '<div class="fm-vt-deck__body">' +
            '<h3 class="fm-vt-deck__name">' + escapeHtml(p.t) + '</h3>' +
            (specs.length ? '<p class="fm-vt-deck__specs">' + escapeHtml(specs.join(' · ')) + '</p>' : '') +
            '<span class="fm-vt-deck__price">€ ' + escapeHtml(p.price) + '</span>' +
          '</div>' +
        '</article>' +
        '<div class="fm-vt-deck__controls">' +
          '<button type="button" class="fm-vt-deck__btn fm-vt-deck__btn--pass" data-deck-action="pass" data-handle="' + escapeHtml(p.h) + '">👎 Non fa per me</button>' +
          '<button type="button" class="fm-vt-deck__btn fm-vt-deck__btn--open" data-deck-action="open" title="Dettagli">🔎</button>' +
          '<button type="button" class="fm-vt-deck__btn fm-vt-deck__btn--like" data-deck-action="like" data-handle="' + escapeHtml(p.h) + '" data-product-id="' + escapeHtml(String(p.id || '')) + '">❤ Mi piace</button>' +
        '</div>' +
        '<p class="fm-vt-deck__hint">Ogni scelta affina i tuoi match qui sopra.</p>' +
      '</div>'
    );
  }

  function drawDeckCard(sec) {
    if (!_deck || _deckIdx >= _deck.length) {
      const fb = _deckSwipes > 0
        ? 'Hai dato <strong>' + _deckSwipes + '</strong> ' + (_deckSwipes === 1 ? 'parere' : 'pareri') + '. Ho affinato i tuoi gusti — i match qui sopra ne tengono conto.'
        : 'Fatto. I match qui sopra si affinano ad ogni tua scelta.';
      sec.innerHTML =
        '<div class="fm-vt-deck fm-vt-deck--done">' +
          '<h2 class="fm-vt-deck__title">🃏 Continua a scoprire</h2>' +
          '<p class="fm-vt-deck__doneMsg">' + fb + '</p>' +
          '<button type="button" class="fm-vt-deck__btn fm-vt-deck__btn--restart" data-deck-action="restart">Ancora un giro</button>' +
        '</div>';
      return;
    }
    const c = _deck[_deckIdx];
    sec.innerHTML = deckCardHtml(c, c.product, _deckIdx, _deck.length);
  }

  // INTRO on-demand: non costruiamo (né fetchiamo) finché il cliente non clicca "Inizia".
  // Risolve il costo di ~30 fetch ad ogni caricamento + rende il loop più intenzionale.
  function renderDiscoverIntro(profile, catalog) {
    const sec = $('[data-fm-vt-discover]');
    if (!sec) return;
    // Gate sul pool REALE di candidati (sync), non sui soli topMechanics: così scatta
    // anche col fallback "qualità BGG" per chi non ha fatto lo swipe-quiz.
    const pool = (catalog && catalog.length) ? buildDiscoverDeck(profile, catalog) : [];
    if (pool.length < 3) { sec.hidden = true; sec.innerHTML = ''; console.info('[Vetrina] deck intro nascosto: pool candidati =', pool.length); return; }
    sec.hidden = false;
    sec.innerHTML =
      '<div class="fm-vt-deck fm-vt-deck--intro">' +
        '<h2 class="fm-vt-deck__title">🃏 Continua a scoprire</h2>' +
        '<p class="fm-vt-deck__introMsg">Ti mostro qualche gioco affine, uno alla volta. Dici se ti va o no — e i tuoi match qui sopra si affinano.</p>' +
        '<button type="button" class="fm-vt-deck__btn fm-vt-deck__btn--start" data-deck-action="start">Inizia →</button>' +
      '</div>';
  }

  // SINCRONO e istantaneo: niente verifica-fetch bloccante (poteva impallarsi su una
  // richiesta lenta → "Sto pescando…" infinito). Il pool esclude già gli esauriti-noti;
  // le rare OOS le gestisce il sweep sulla card visibile.
  function startDiscover(profile, catalog) {
    const sec = $('[data-fm-vt-discover]');
    if (!sec) return;
    const pool = buildDiscoverDeck(profile, catalog);
    if (pool.length < 3) { sec.hidden = true; sec.innerHTML = ''; console.info('[Vetrina] deck: pool < 3 (' + pool.length + ')'); return; }
    _deck = pool.slice(0, 12);
    _deckIdx = 0;
    _deckSwipes = 0;
    sec.hidden = false;
    drawDeckCard(sec);
    console.info('[Vetrina] deck "Continua a scoprire": ' + _deck.length + ' carte');
  }

  // ── F2 v2 — "Editori che segui" (personalizzato dai tuoi giochi) ──
  // L'editore = Shopify vendor (confermato), letto da /products/{h}.js. Tally sui
  // giochi con cui hai mostrato interesse (wishlist + click recenti). Niente a caso.
  const VENDOR_KEY = 'fmv_vendor'; // handle → vendor (cache, evita refetch)
  // Vendor del negozio (auto-pubblicazione): escluso da "Editori che segui" — non è
  // un publisher esterno che "segui", e in cima sa di auto-promo. Per RE-INCLUDERLO,
  // svuota questo set.
  const PUB_EXCLUDE = new Set(['frogames', 'frogames.it']);
  function _loadVendors() { try { const o = JSON.parse(localStorage.getItem(VENDOR_KEY) || '{}'); return (o && typeof o === 'object') ? o : {}; } catch (e) { return {}; } }
  function _saveVendors(m) { try { localStorage.setItem(VENDOR_KEY, JSON.stringify(m)); } catch (e) {} }

  // Handle dei giochi "di interesse" — segnale d'interesse REALE (max 30):
  // POSSEDUTI (collezione BGG) + GIOCATI (plays) + ACQUISTATI, poi wishlist + click.
  // L'ordine d'inserimento dà priorità a posseduti/giocati nello slice finale.
  function engagedHandles(profile, catalog) {
    const set = new Set();
    // Posseduti (BGG collection) → handle via match bgg id; + acquistati (handle diretto)
    try {
      const owned = buildOwnedSets(profile);
      if (owned.bggIds && owned.bggIds.size) {
        for (const p of catalog) { if (p.bgg && owned.bggIds.has(p.bgg)) set.add(p.h); }
      }
      if (owned.handles) { owned.handles.forEach(h => set.add(h)); }
    } catch (e) {}
    // Giocati (topPlayed, per nome → titolo catalog)
    try {
      const played = (profile.playsActivity && profile.playsActivity.topPlayed) || [];
      if (played.length) {
        const byTitle = {};
        for (const p of catalog) { byTitle[(p.t || '').toLowerCase().trim()] = p.h; }
        for (const g of played) { const h = g && g.name && byTitle[g.name.toLowerCase().trim()]; if (h) set.add(h); }
      }
    } catch (e) {}
    // Wishlist (id → handle)
    const wishIds = getWishlistIds();
    for (const p of catalog) { if (wishIds.has(String(p.id))) set.add(p.h); }
    // Click recenti (eventi)
    try {
      const raw = localStorage.getItem(EVENT_STORAGE_KEY);
      if (raw) {
        const ev = JSON.parse(raw);
        const cutoff = Math.floor(Date.now() / 1000) - 60 * 86400;
        for (let i = ev.length - 1; i >= 0; i--) { const e = ev[i]; if (e.n === 'click_open' && e.h && e.t >= cutoff) set.add(e.h); }
      }
    } catch (e) {}
    return Array.from(set).slice(0, 30);
  }

  async function buildTopPublishers(profile, catalog) {
    const handles = engagedHandles(profile, catalog);
    if (handles.length < 2) return [];
    const vcache = _loadVendors();
    const acache = _loadAvailCache();
    const now = Math.floor(Date.now() / 1000);
    let i = 0;
    async function worker() {
      while (i < handles.length) {
        const h = handles[i++];
        if (vcache[h] !== undefined) continue; // già in cache
        try {
          const res = await fetch('/products/' + encodeURIComponent(h) + '.js', { headers: { 'Accept': 'application/json' } });
          if (res.ok) { const j = await res.json(); vcache[h] = j.vendor || ''; if (typeof j.available === 'boolean') acache[h] = { a: _trulyAvailable(j), t: now }; }
          else vcache[h] = '';
        } catch (e) { vcache[h] = ''; }
      }
    }
    await Promise.all(Array.from({ length: Math.min(6, handles.length) }, worker));
    _saveVendors(vcache); _saveAvailCache(acache);
    const tally = {};
    for (const h of handles) { const v = vcache[h]; if (v && !PUB_EXCLUDE.has(v.toLowerCase())) tally[v] = (tally[v] || 0) + 1; }
    return Object.keys(tally).map(v => ({ v: v, n: tally[v] })).sort((a, b) => b.n - a.n).slice(0, 6);
  }

  function renderPublishers(profile, catalog) {
    const sec = $('[data-fm-vt-publishers]');
    if (!sec) return;
    buildTopPublishers(profile, catalog).then(function (tops) {
      if (!tops || tops.length < 2) { sec.hidden = true; sec.innerHTML = ''; return; }
      sec.hidden = false;
      sec.innerHTML =
        '<h2 class="fm-vt-pub__title">Editori che segui</h2>' +
        '<p class="fm-vt-pub__sub">Le case dei giochi che possiedi, giochi e salvi — continua con chi già ti piace.</p>' +
        '<div class="fm-vt-pub__chips">' +
          tops.map(function (t) {
            return '<a class="fm-vt-pub__chip" href="/collections/vendors?q=' + encodeURIComponent(t.v) + '">' +
              '<span class="fm-vt-pub__chipName">' + escapeHtml(t.v) + '</span>' +
              '<span class="fm-vt-pub__chipCount" title="' + t.n + ' tuoi giochi">' + t.n + '</span>' +
            '</a>';
          }).join('') +
        '</div>';
      console.info('[Vetrina] editori che segui:', tops.map(t => t.v + '(' + t.n + ')').join(', '));
    });
  }

  // ── F2 v2 — "Autori che segui" (designer + artisti, personalizzato) ──
  // I designer/artisti NON sono in metafield né in product.js in forma pulita: il
  // widget PDP li prende live dal proxy BGG. Riuso lo STESSO proxy (frogames-bgg-updater)
  // sui bgg id dei TUOI giochi posseduti/giocati. Cache 30gg (non cambiano mai).
  const CREATORS_KEY = 'fmv_creators_v2'; // bggId → { c:[nomi], t:ts } — v2: nomi puliti dal suffisso BGG
  const CREATORS_TTL = 30 * 86400;
  function _loadCreators() { try { const o = JSON.parse(localStorage.getItem(CREATORS_KEY) || '{}'); return (o && typeof o === 'object') ? o : {}; } catch (e) { return {}; } }
  function _saveCreators(m) { try { localStorage.setItem(CREATORS_KEY, JSON.stringify(m)); } catch (e) {} }

  async function buildTopCreators(profile, catalog) {
    const handles = engagedHandles(profile, catalog);
    if (handles.length < 3) return [];
    const bggIds = [];
    const seenId = new Set();
    for (const h of handles) {
      const p = catalog.find(x => x.h === h);
      if (p && p.bgg && !seenId.has(p.bgg)) { seenId.add(p.bgg); bggIds.push(p.bgg); }
      if (bggIds.length >= 12) break; // proxy free-tier: limito le fetch
    }
    if (bggIds.length < 3) return [];
    const cache = _loadCreators();
    const now = Math.floor(Date.now() / 1000);
    let i = 0;
    async function worker() {
      while (i < bggIds.length) {
        const id = bggIds[i++];
        const hit = cache[id];
        if (hit && (now - hit.t) < CREATORS_TTL) continue;
        try {
          const res = await fetch('https://frogames-bgg-updater.onrender.com/thing?id=' + id, { headers: { 'Accept': 'application/xml' } });
          if (res.ok) {
            const xml = new DOMParser().parseFromString(await res.text(), 'text/xml');
            const names = Array.from(xml.querySelectorAll("link[type='boardgamedesigner'],link[type='boardgameartist']"))
              // Rimuovo il suffisso di disambiguazione BGG "(I)"/"(II)"/… (es. "David Gordon (I)" → "David Gordon")
              .map(n => (n.getAttribute('value') || '').replace(/\s*\([IVXLC]+\)\s*$/i, '').trim())
              .filter(v => v && v !== '(Uncredited)');
            cache[id] = { c: names, t: now };
          } else cache[id] = { c: [], t: now };
        } catch (e) { cache[id] = { c: [], t: now }; }
      }
    }
    await Promise.all(Array.from({ length: Math.min(4, bggIds.length) }, worker)); // concorrenza bassa (proxy free)
    _saveCreators(cache);
    const tally = {};
    for (const id of bggIds) { const rec = cache[id]; if (rec && rec.c) for (const name of rec.c) tally[name] = (tally[name] || 0) + 1; }
    return Object.keys(tally).map(name => ({ name: name, n: tally[name] })).sort((a, b) => b.n - a.n).slice(0, 6);
  }

  function renderCreators(profile, catalog) {
    const sec = $('[data-fm-vt-creators]');
    if (!sec) return;
    buildTopCreators(profile, catalog).then(function (tops) {
      if (!tops || tops.length < 2) { sec.hidden = true; sec.innerHTML = ''; return; }
      sec.hidden = false;
      sec.innerHTML =
        '<h2 class="fm-vt-pub__title">Autori che segui</h2>' +
        '<p class="fm-vt-pub__sub">Designer e artisti dei giochi che possiedi e giochi.</p>' +
        '<div class="fm-vt-pub__chips">' +
          tops.map(function (t) {
            return '<a class="fm-vt-pub__chip" href="/search?q=' + encodeURIComponent(t.name) + '">' +
              '<span class="fm-vt-pub__chipName">' + escapeHtml(t.name) + '</span>' +
              (t.n > 1 ? '<span class="fm-vt-pub__chipCount" title="' + t.n + ' tuoi giochi">' + t.n + '</span>' : '') +
            '</a>';
          }).join('') +
        '</div>';
      console.info('[Vetrina] autori che segui:', tops.map(t => t.name + '(' + t.n + ')').join(', '));
    });
  }

  // ── SCROLLSPY — evidenzia in "VAI A" la sezione in cui sei mentre scrolli ──
  let _scrollObs = null;
  function initScrollSpy() {
    if (typeof IntersectionObserver !== 'function') return;
    const navItems = $$('.fm-vt-side__navItem');
    if (!navItems.length) return;
    if (_scrollObs) { try { _scrollObs.disconnect(); } catch (e) {} }
    const anchors = navItems.map(a => a.dataset.anchor).filter(Boolean);
    const visible = new Set();
    function setActive(id) {
      navItems.forEach(a => a.classList.toggle('is-active', a.dataset.anchor === id));
    }
    function refresh() {
      // tra le sezioni che toccano la "banda" in alto, attiva quella più in cima.
      let best = null, bestTop = Infinity;
      visible.forEach(id => {
        const el = document.getElementById(id);
        if (!el) return;
        const top = el.getBoundingClientRect().top;
        if (top < bestTop) { bestTop = top; best = id; }
      });
      if (best) setActive(best);
    }
    // Banda di rilevamento ~15–30% dall'alto (sotto l'header fisso del tema).
    _scrollObs = new IntersectionObserver(function (entries) {
      entries.forEach(e => { if (e.isIntersecting) visible.add(e.target.id); else visible.delete(e.target.id); });
      refresh();
    }, { rootMargin: '-15% 0px -70% 0px', threshold: 0 });
    anchors.forEach(id => { const el = document.getElementById(id); if (el) _scrollObs.observe(el); });
  }

  // ── Frecce di scorrimento carousel (DESKTOP) ─────────────────
  // Su PC il drag/swipe non è ovvio: aggiungo frecce flottanti con ombra che
  // scorrono il carousel di ~80% larghezza. Si nascondono a inizio/fine corsa
  // e su touch (lì il dito basta). Binding diretto: i carousel si renderizzano
  // una volta sola per load.
  function initCarouselArrows() {
    $$('.fm-vt-row--carousel').forEach(function (sec) {
      const scroller = sec.querySelector('.fm-vt-row__scroller');
      const prev = sec.querySelector('[data-scroll="prev"]');
      const next = sec.querySelector('[data-scroll="next"]');
      if (!scroller || !prev || !next) return;
      if (sec.dataset.arrowsBound === '1') return; // no doppio binding
      sec.dataset.arrowsBound = '1';
      function step() { return Math.max(240, Math.round(scroller.clientWidth * 0.8)); }
      function update() {
        const max = scroller.scrollWidth - scroller.clientWidth - 4;
        prev.hidden = scroller.scrollLeft <= 4;
        next.hidden = scroller.scrollLeft >= max;
      }
      prev.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); scroller.scrollBy({ left: -step(), behavior: 'smooth' }); });
      next.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); scroller.scrollBy({ left: step(), behavior: 'smooth' }); });
      scroller.addEventListener('scroll', update, { passive: true });
      // ricalcola se la finestra cambia (es. resize → meno card visibili)
      if (typeof ResizeObserver === 'function') {
        try { new ResizeObserver(update).observe(scroller); } catch (e) {}
      }
      update();
    });
  }

  // ── Render principale ────────────────────────────────────────
  function renderAll(picks, catalog, profile) {
    const main = $('[data-fm-vt-main]');
    const loading = $('[data-fm-vt-loading]');
    const customerName = (window.FrogMatchVetrinaCustomer && window.FrogMatchVetrinaCustomer.firstName) || 'Frogger';

    // ESCLUSIONE DANNEGGIATI: i prodotti 'frogpatch' condividono il BGG id con la
    // copia normale → una copia danneggiata potrebbe vincere il dedup BGG nei
    // consigli. Li tolgo dall'intero catalog della Vetrina (daily, rows, sidebar).
    try {
      const _damaged = new Set(readCuratedData()['frogpatch'] || []);
      if (_damaged.size) {
        const _before = catalog.length;
        catalog = catalog.filter(p => !_damaged.has(p.h));
        console.info('[Vetrina] esclusi ' + (_before - catalog.length) + ' danneggiati (frogpatch) dal catalog');
      }
    } catch (e) {}

    // Hero — eyebrow settimana + specchio identità + visual montage
    const weekEl = $('[data-fm-vt-week]');
    if (weekEl && picks.w) weekEl.textContent = 'settimana ' + picks.w.split('-W')[1];

    const mirrorEl = $('[data-fm-vt-mirror]');
    if (mirrorEl) mirrorEl.textContent = buildMirror(profile, customerName);

    const visualEl = $('[data-fm-vt-hero-visual]');
    if (visualEl) visualEl.innerHTML = buildHeroVisual(profile);

    // Spotlight RIMOSSO (v5.16.9): era un secondo hero gemello del Daily Drop
    // (stessa anatomia, stessa copy "Tocca le stesse corde del tuo X") e per di
    // più ridondante con la sidebar "I tuoi match più alti". Teniamo UN solo hero
    // (il Daily Drop, time-aware e con identità Frogames). La sezione resta nel
    // DOM ma vuota/nascosta.
    const spotSection = $('[data-fm-vt-spot]');
    if (spotSection) { spotSection.hidden = true; spotSection.innerHTML = ''; }
    // Handle del gioco "in vetrina" (ora = Daily Drop): lo escludiamo dalle rows
    // così l'unico hero non si ripete più sotto.
    let featuredHandle = null;

    // Stat counter "Sto guardando N giochi per te" RIMOSSO: banner generico in cima
    // che non aggiungeva valore personale (in cima ci sono già Bentornato+delta e L0).

    // Daily Drop — unico hero "MUBI-style" (1 gioco/giorno, voce Frog, time-aware)
    const dailySection = $('[data-fm-vt-daily]');
    if (dailySection) {
      const timeCtx = getTimeContext(new Date());
      const dailyPick = pickDailyDrop(profile, catalog, picks, null);
      if (dailyPick && dailyPick.product) {
        dailySection.innerHTML = renderDailyDrop(dailyPick, dailyPick.product, profile, customerName, timeCtx);
        dailySection.hidden = false;
        featuredHandle = dailyPick.h;
        trackEvent('daily_drop_view', dailyPick.h);
        console.info('[Vetrina] Daily Drop:', dailyPick.product.t, '· match%:', dailyPick.m);
        // Persist al worker (cache server-side per future newsletter Klaviyo / push PWA / cross-device)
        saveDailyDropToWorker(dailyPick);
      } else {
        console.info('[Vetrina] Daily Drop saltato (no pick disponibile)');
      }
    }

    // Rows dinamiche — passo l'handle del Daily Drop a buildRows così
    // il dedupe lo esclude dal primo step e ogni row pesca da pool diversi.
    const rowsContainer = $('[data-fm-vt-rows]');
    if (rowsContainer) {
      const personalRows = buildRows(profile, picks, catalog, featuredHandle);
      // Curated rows (polso Frogames — non-personalizzato, da collezioni Shopify)
      const curatedData = readCuratedData();
      delete curatedData['frogpatch']; // solo esclusione catalog, mai una row
      // Curated (CURATED_META) + dinamiche da metaobject (collection-engine, senza codice).
      const curatedRows = buildCuratedRows(curatedData, catalog, profile)
        .concat(buildDynamicRows(catalog, profile));
      // Interleave strategica: te → community → te → community → tail
      const allRows = interleavePersonalCurated(personalRows, curatedRows);
      // RETE DI SICUREZZA ESAURITI: filtro finale a livello di card su OGNI row.
      // Qualunque sorgente di picks (presente o futura) che lasci passare un OOS
      // viene ripulita qui prima del render → garanzia "nessun esaurito, in nessun blocco".
      allRows.forEach(r => {
        if (!Array.isArray(r.picks)) return;
        r.picks = r.picks.filter(p => {
          const prod = p.product || catalog.find(x => x.h === p.h);
          return !prod || (prod.av !== false && prod.available !== false);
        });
      });
      // Guard layout-specific min counts (dopo il filtro esauriti: una row che
      // scende sotto il minimo sparisce, meglio assente che con buchi)
      const layoutMin = { paired: 2, discovery: 1, carousel: 2, mosaic: 2, trio: 2, bento: 3 };
      const validRows = allRows
        .filter(r => !isRowSuppressed(r.id)) // tune "meno così": row messe via per ~4 settimane
        .filter(r => r.picks && r.picks.length >= (layoutMin[r.layout] || 1));
      // L0 "La tua roba" va nel suo container IN CIMA (sopra il Daily Drop): la pagina
      // parte da TE, riconoscibile subito. Il resto va nel container rows (sotto il daily).
      const L0SET = { topmatch: 1, valutando: 1, riprendi: 1, radar: 1, 'curated-mostviewed': 1 };
      const l0Rows = validRows.filter(r => L0SET[r.id]);
      const feedRows = validRows.filter(r => !L0SET[r.id]);
      const l0Container = $('[data-fm-vt-l0]');
      if (l0Container) l0Container.innerHTML = l0Rows.map(r => renderRow(r)).join('');
      rowsContainer.innerHTML = feedRows.map(r => renderRow(r)).join('');
      console.info('[Vetrina] rows render: L0[' + l0Rows.map(r => r.id).join(',') + '] · feed[' + feedRows.map(r => r.id).join(',') + ']');

      // Sidebar LEFT: nav anchor jump + identità mini
      const sideLeft = $('[data-fm-vt-sidebar-left]');
      if (sideLeft) { sideLeft.innerHTML = renderSidebarLeft(validRows, profile); initScrollSpy(); }
      // Sidebar RIGHT: hot mini + top match mini + top BGG + curator note (con dedupe + filtro esp)
      const sideRight = $('[data-fm-vt-sidebar-right]');
      if (sideRight) sideRight.innerHTML = renderSidebarRight(picks, catalog, profile, featuredHandle);
    }

    if (loading) loading.hidden = true;
    if (main) main.hidden = false;

    // F0.5: barra saluto + delta (cali prezzo dall'ultima volta), in cima al feed.
    renderWelcomeDelta(catalog, customerName);
    // Riga motore in cima: "FrogMatch sceglie per te tra N giochi" (personale, non generica).
    // Inserita DOPO la welcome bar → resta la prima riga in assoluto del feed.
    renderEngineLine(catalog, profile, picks);
    // LENTI mobile: tag row + barra chip filtro (sticky, solo mobile via CSS).
    setupLensFilter();

    // F3: deck "Continua a scoprire" — AUTO-START (ora sincrono/istantaneo): mostra
    // subito la prima carta, niente più intro "Inizia" che a volte restava vuota.
    startDiscover(profile, catalog);

    // F2 v2: "Editori che segui" + "Autori che segui" (personalizzati, async).
    renderPublishers(profile, catalog);
    renderCreators(profile, catalog);

    // F0.5: registra (1×/sessione) i giochi mostrati → anti-ripetizione al ritorno.
    try { recordShows($$('[data-fm-vt-card]').map(_cardHandle).filter(Boolean)); } catch (e) {}

    bindEvents(catalog, profile);

    // Frecce di scorrimento sui carousel (solo desktop, CSS le nasconde su touch).
    initCarouselArrows();

    // ESAURITI — verifica disponibilità REALE lato client sui giochi mostrati.
    // Il catalog (worker) non include sempre lo stock: qui controlliamo via
    // /products/{handle}.js i soli giochi renderizzati e nascondiamo gli OOS.
    // Fire-and-forget: non blocca il render, ripulisce subito dopo.
    sweepSoldOut();

    // Presence: avvia heartbeat + counter live (trust signal "X Frogger in vetrina")
    startPresenceLoop();
    // Community stats: trust signal soft "negli ultimi 30 giorni"
    loadCommunityStats();
    // Colonna destra: "Più giocati dai Frogger" (data-driven, in-catalog, no posseduti)
    renderFroggerHot(catalog, profile);

    // Polish: reveal animato staggered delle row mentre entrano in viewport.
    // Pattern Apple/Linear/modern editorial — opacity 0 + translateY → 1 + 0,
    // 0.6s ease-out. Stagger di 60ms per row vicine (effetto "cascata").
    if (typeof window.IntersectionObserver === 'function') {
      const targets = $$('.fm-vt-row, .fm-vt-spot, .fm-vt-dailySection, .fm-vt-stat');
      targets.forEach((el, i) => {
        el.classList.add('fm-vt-reveal');
        // Stagger 120ms tra elementi vicini, cappato a 500ms per non bloccare
        // troppo le row in fondo. Più visibile dello stagger precedente.
        el.style.setProperty('--reveal-delay', Math.min(i * 120, 500) + 'ms');
      });
      const obs = new IntersectionObserver(function (entries) {
        for (const e of entries) {
          if (e.isIntersecting) {
            e.target.classList.add('is-revealed');
            obs.unobserve(e.target);
          }
        }
      }, { threshold: 0.12, rootMargin: '0px 0px -12% 0px' });
      targets.forEach(el => obs.observe(el));
    }

    // Post-render: nascondi card di giochi bloccati (not_interested attivo)
    // anche se la cache picks è ancora fresca (dura 24h, le reactions sono live).
    $$('[data-fm-vt-card][data-handle]').forEach(card => {
      if (isBlocked(card.dataset.handle)) {
        card.style.display = 'none';
      }
    });
  }

  // ── Init ────────────────────────────────────────────────────
  async function init(retries) {
    retries = retries || 0;
    const main = $('[data-fm-vt-main]');
    const loading = $('[data-fm-vt-loading]');
    const noprofile = $('[data-fm-vt-noprofile]');

    if (!main && !loading) return;

    // Adaptive palette: applica subito (anche se profile/catalog mancano)
    applyTimePalette();

    // F0.5: registra la visita (calcola PREV_VISIT per i delta al ritorno).
    initVisitMemory();

    if (!window.FrogMatch || !window.FrogMatch.computeMatch || !window.FrogMatch.loadProfile) {
      if (retries > 30) {
        if (loading) loading.hidden = true;
        if (noprofile) noprofile.hidden = false;
        return;
      }
      setTimeout(() => init(retries + 1), 200);
      return;
    }

    // Community data (non blocca)
    if (window.FrogMatch.loadCommunityData) {
      try { await window.FrogMatch.loadCommunityData(); } catch (e) {}
    }

    const profile = window.FrogMatch.loadProfile();
    if (!profile || (!profile.topMechanics && !profile.topTypologies)) {
      if (loading) loading.hidden = true;
      if (noprofile) noprofile.hidden = false;
      return;
    }

    // Catalog: prova prima il worker (sblocca cap 250 del Liquid paginate, accede a 2000+ prodotti),
    // fallback su DOM bootstrap se worker down o vuoto. Il DOM ha sempre i primi 250 come safety net.
    let catalog = [];
    try { catalog = window.FrogMatch.readProductDataFromDOM() || []; } catch (e) {}
    const catalogFromDOM = catalog.length;
    try {
      const workerUrl = getWorkerUrl();
      if (workerUrl) {
        const sub = $('[data-fm-vt-loading-sub]');
        if (sub) sub.textContent = 'Carico il catalogo completo…';
        const res = await fetch(workerUrl.replace(/\/$/, '') + '/api/frogmatch/catalog', {
          // 30s timeout: il PRIMO scan ci mette 20-30s (deve fare 8-10 chiamate
          // GraphQL paginate × 200ms anti-ratelimit). Le call successive sono
          // istantanee perché leggono dalla KV cache 24h.
          signal: typeof AbortSignal !== 'undefined' && AbortSignal.timeout ? AbortSignal.timeout(30000) : undefined
        });
        if (res.ok) {
          const json = await res.json();
          if (json && Array.isArray(json.products) && json.products.length > catalogFromDOM) {
            catalog = json.products;
            console.info('[Vetrina] catalog DA WORKER:', catalog.length, 'prodotti (DOM aveva ' + catalogFromDOM + ')',
              json.fresh ? '· fresh scan' : '· da cache');
          } else {
            console.info('[Vetrina] worker catalog non più grande del DOM, uso DOM');
          }
        } else {
          console.warn('[Vetrina] worker catalog HTTP', res.status, '— uso DOM');
        }
      }
    } catch (e) {
      console.warn('[Vetrina] worker catalog error, fallback DOM:', e.message);
    }
    console.info('[Vetrina] catalog:', catalog.length, '· profile keys:', Object.keys(profile).length);
    if (catalog.length === 0) {
      if (loading) loading.hidden = true;
      if (noprofile) noprofile.hidden = false;
      return;
    }

    const nowDate = new Date();
    const currentWeek = getISOWeek(nowDate);
    let picks = window.FrogMatchVetrinaCustomer && window.FrogMatchVetrinaCustomer.weeklyPicks;
    const isAllEmpty = (p) => !p || (
      (!p.t1 || p.t1.length === 0) &&
      (!p.t2 || p.t2.length === 0) &&
      (!p.t3 || p.t3.length === 0) &&
      (!p.t4 || p.t4.length === 0)
    );
    // v=8: rotation SETTIMANALE (picks.w cambia ogni lunedì). Stabile nella settimana;
    // la freschezza quotidiana è nel Daily Drop e nel deck "Continua a scoprire".
    let needRecompute = !picks || picks.w !== currentWeek || picks.v !== 8 || isAllEmpty(picks);

    if (needRecompute) {
      try {
        const cid = window.FrogMatchVetrinaCustomer.id;
        const workerUrl = getWorkerUrl();
        const res = await fetch(workerUrl.replace(/\/$/, '') + '/api/frogmatch/weekly-picks?customerId=' + cid);
        if (res.ok) {
          const json = await res.json();
          if (json && json.picks && json.picks.w === currentWeek && json.picks.v === 8 && !isAllEmpty(json.picks)) {
            picks = json.picks;
            needRecompute = false;
          }
        }
      } catch (e) {}
    }

    if (needRecompute) {
      const sub = $('[data-fm-vt-loading-sub]');
      if (sub) sub.textContent = 'Calcolo match su ' + catalog.length + ' giochi…';
      await new Promise(r => requestAnimationFrame(() => requestAnimationFrame(r)));
      picks = computeWeeklyPicks(profile, catalog);
      if (!picks) {
        if (loading) loading.hidden = true;
        if (noprofile) noprofile.hidden = false;
        return;
      }
      // Aggiunge tagline ai picks anche se vengono dal worker (così tag aggiornati alla versione corrente del JS)
      savePicksToWorker(picks);
    }

    // Se picks vengono dal worker le tagline possono essere di una versione precedente
    // (es. tutte "del tuo Jaipur"): le ricalcolo SEMPRE per i picks tier, con il tetto
    // di riuso condiviso, così la diversità vale anche sui picks cachati.
    if (!needRecompute) {
      const compUsage = new Map();
      for (const k of ['t1', 't2', 't3', 't4']) {
        if (!picks[k]) continue;
        for (const p of picks[k]) {
          const prod = catalog.find(x => x.h === p.h);
          if (prod) p.tag = buildCardTagline(p, prod, profile, compUsage);
        }
      }
    }

    // Le tre classifiche FrogTop, PRIMA di disegnare: renderAll e' sincrona
    // e le corsie curated le legge tutte in un colpo. Tetto 4 s: oltre, la
    // vetrina parte senza e nessuno aspetta.
    await caricaFrogtopCurated();
    renderAll(picks, catalog, profile);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }
})();
